const CO2_ITEMS = {
  "1003": {
    "name": "アスファルトフィニッシャ",
    "items": {
      "011": {
        "name": "クローラ型",
        "items": {
          "030-001": {
            "name": "舗装幅1.4~3.0m"
          }
        }
      },
      "012": {
        "name": "クローラ型・排出ガス対策型（第1次基準値）",
        "items": {
          "120-001": {
            "name": "舗装幅3.0~12.0m"
          }
        }
      },
      "013": {
        "name": "クローラ型・排出ガス対策型（第2次基準値）",
        "items": {
          "025-001": {
            "name": "舗装幅1.4~2.5m"
          },
          "031-001": {
            "name": "舗装幅1.7~3.1m"
          },
          "080-001": {
            "name": "舗装幅2.5~8.0m"
          },
          "120-001": {
            "name": "舗装幅3.0~12.0m"
          }
        }
      },
      "014": {
        "name": "クローラ型・排出ガス対策型（第3次基準値）",
        "items": {
          "014-001": {
            "name": "舗装幅0.8~1.4m"
          },
          "030-001": {
            "name": "舗装幅1.4~3.0m"
          },
          "031-001": {
            "name": "舗装幅1.7~3.1m"
          },
          "045-001": {
            "name": "舗装幅2.0~4.5m"
          },
          "060-001": {
            "name": "舗装幅2.4~6.0m"
          }
        }
      },
      "023": {
        "name": "ホイール型・排出ガス対策型（第2次基準値）",
        "items": {
          "030-001": {
            "name": "舗装幅1.4~3.0m"
          },
          "085-001": {
            "name": "舗装幅3.0~8.5m"
          }
        }
      },
      "024": {
        "name": "ホイール型・排出ガス対策型（第3次基準値）",
        "items": {
          "030-001": {
            "name": "舗装幅1.4~3.0m"
          },
          "031-001": {
            "name": "舗装幅1.7~3.1m"
          },
          "045-001": {
            "name": "舗装幅2.0~4.5m"
          },
          "060-001": {
            "name": "舗装幅2.4~6.0m"
          }
        }
      },
      "025": {
        "name": "ホイール型・排出ガス対策型（2011年規制）",
        "items": {
          "045-001": {
            "name": "舗装幅2.0~5.0m"
          },
          "060-001": {
            "name": "舗装幅2.3~6.0m"
          }
        }
      },
      "026": {
        "name": "ホイール型・排出ガス対策型（2014年規制）",
        "items": {
          "032-001": {
            "name": "舗装幅1.4~3.2m"
          },
          "080-001": {
            "name": "舗装幅2.5~8.0m"
          }
        }
      },
      "031": {
        "name": "乳剤散布装置付アスファルトフィニッシャ",
        "items": {
          "060-001": {
            "name": "舗装幅2.5~6.0m"
          }
        }
      },
      "044": {
        "name": "グースアスファルトフィニッシャ・排出ガス対策型（第3次基準値）",
        "items": {
          "045-001": {
            "name": "舗装幅2.4~4.5m"
          }
        }
      },
      "051": {
        "name": "グースアスファルトフィニッシャ（歩道用）",
        "items": {
          "017-001": {
            "name": "舗装幅1.7m"
          }
        }
      },
      "061": {
        "name": "二層式同時敷均アスファルトフィニッシャ（歩道用）",
        "items": {
          "050-001": {
            "name": "舗装幅2.5~5.2m"
          },
          "060-001": {
            "name": "舗装幅2.5~6.0m"
          }
        }
      }
    }
  },
  "1005": {
    "name": "ディストリビュータ",
    "items": {
      "022": {
        "name": "自走式（トラック架装式）",
        "items": {
          "150-001": {
            "name": "タンク容量1000~1500ℓ"
          },
          "300-001": {
            "name": "タンク容量2000~3000ℓ"
          },
          "400-001": {
            "name": "タンク容量4000ℓ"
          },
          "600-001": {
            "name": "タンク容量6000ℓ"
          }
        }
      }
    }
  },
  "1006": {
    "name": "チップスプレッダ",
    "items": {
      "017": {
        "name": "ハンガ敷",
        "items": {
          "050-001": {
            "name": "ホッパ容量0.4㎥　散布幅2.0~5.0m"
          }
        }
      },
      "027": {
        "name": "テールゲート式",
        "items": {
          "022-001": {
            "name": "ホッパ容量0.25㎥　散布幅1.6~2.2m"
          }
        }
      }
    }
  },
  "1007": {
    "name": "アスファルトクッカ",
    "items": {
      "100": {
        "name": "トラック架装・バーナ加熱式",
        "items": {
          "400-001": {
            "name": "容量3.0~4.0㎥"
          }
        }
      },
      "200": {
        "name": "トラック架装・電気加熱式",
        "items": {
          "400-001": {
            "name": "容量3.0~4.0㎥"
          }
        }
      }
    }
  },
  "1008": {
    "name": "コンクリートスプレッダ",
    "items": {
      "100": {
        "name": "ブレード式",
        "items": {
          "075-001": {
            "name": "舗装幅3.0~7.5m"
          },
          "085-001": {
            "name": "舗装幅5.0~8.5m"
          }
        }
      },
      "150": {
        "name": "勾配可変型・ブレード敷",
        "items": {
          "085-001": {
            "name": "舗装幅5.0~8.5m"
          }
        }
      },
      "300": {
        "name": "ボックス式",
        "items": {
          "075-001": {
            "name": "舗装幅3.0~7.5mボックス容量4.0㎥"
          },
          "085-001": {
            "name": "舗装幅5.0~8.5mボックス容量4.0㎥"
          }
        }
      }
    }
  },
  "1009": {
    "name": "コンクリートフィニッシャ",
    "items": {
      "015": {
        "name": "勾配固定型",
        "items": {
          "075-001": {
            "name": "舗装幅3.0~7.5m"
          },
          "085-001": {
            "name": "舗装幅5.0~8.5m"
          }
        }
      },
      "025": {
        "name": "勾配可変型",
        "items": {
          "085-001": {
            "name": "舗装幅5.0~8.5m"
          }
        }
      }
    }
  },
  "1010": {
    "name": "コンクリートレベラ",
    "items": {
      "015": {
        "name": "勾配固定型",
        "items": {
          "075-001": {
            "name": "舗装幅3.0~7.5m"
          },
          "085-001": {
            "name": "舗装幅5.0~8.5m"
          }
        }
      },
      "025": {
        "name": "勾配可変型",
        "items": {
          "085-001": {
            "name": "舗装幅5.0~8.5m"
          }
        }
      }
    }
  },
  "1013": {
    "name": "コンクリート簡易仕上機",
    "items": {
      "015": {
        "name": "エンジン駆動式",
        "items": {
          "050-001": {
            "name": "舗装幅3.5~5.0m"
          }
        }
      }
    }
  },
  "1014": {
    "name": "コンクリート横取機",
    "items": {
      "011": {
        "name": "ホイール型",
        "items": {
          "350-001": {
            "name": "最大供給能力350㎥/h"
          }
        }
      }
    }
  },
  "1015": {
    "name": "振動目地切機",
    "items": {
      "015": {
        "name": "舗装用",
        "items": {
          "085-001": {
            "name": "施工幅3.5~8.5m"
          }
        }
      }
    }
  },
  "1018": {
    "name": "インナバイブレータ",
    "items": {
      "015": {
        "name": "自走式",
        "items": {
          "085-001": {
            "name": "施工幅3.5~8.5m"
          }
        }
      }
    }
  },
  "1019": {
    "name": "アスファルトスプレヤ",
    "items": {
      "017": {
        "name": "ガソリンエンジン駆動・手押し式",
        "items": {
          "015-001": {
            "name": "散布能力15ℓ/min"
          },
          "025-001": {
            "name": "散布能力25ℓ/min"
          }
        }
      },
      "027": {
        "name": "ガソリンエンジン駆動・車載式",
        "items": {
          "015-001": {
            "name": "散布能力15ℓ/min"
          },
          "025-001": {
            "name": "散布能力25ℓ/min"
          }
        }
      }
    }
  },
  "1020": {
    "name": "アスファルトカーバ",
    "items": {
      "017": {
        "name": "ガソリンエンジン駆動式",
        "items": {
          "450-001": {
            "name": "能力4.0~4.5㎥/h"
          }
        }
      }
    }
  },
  "1101": {
    "name": "路面清掃車",
    "items": {
      "012": {
        "name": "ブラシ・三輪式",
        "items": {
          "020-001": {
            "name": "ホッパ容量2.2㎥"
          }
        }
      },
      "014": {
        "name": "ブラシ・四輪式",
        "items": {
          "015-001": {
            "name": "ホッパ容量1.5㎥"
          },
          "020-001": {
            "name": "ホッパ容量2.5~3.1㎥"
          }
        }
      },
      "015": {
        "name": "ブラシ・四輪式・路面切削工事用",
        "items": {
          "015-001": {
            "name": "ホッパ容量1.5㎥"
          },
          "025-001": {
            "name": "ホッパ容量2.5㎥"
          }
        }
      },
      "023": {
        "name": "真空・リヤダンプ式",
        "items": {
          "032-001": {
            "name": "ホッパ容量3.2㎥"
          },
          "045-001": {
            "name": "ホッパ容量4.5㎥"
          },
          "055-001": {
            "name": "ホッパ容量5.5~6.5㎥"
          },
          "080-001": {
            "name": "ホッパ容量8.0㎥"
          }
        }
      },
      "024": {
        "name": "真空・リヤリフト式",
        "items": {
          "035-001": {
            "name": "ホッパ容量3.5㎥"
          },
          "055-001": {
            "name": "ホッパ容量5.5~6.1㎥"
          }
        }
      },
      "026": {
        "name": "真空還流・リヤリフト式",
        "items": {
          "061-001": {
            "name": "ホッパ容量6.1㎥"
          }
        }
      }
    }
  },
  "1103": {
    "name": "ガードレール清掃車",
    "items": {
      "210": {
        "name": "トラック架装・両ブラシ式",
        "items": {
          "001-001": {
            "name": "-"
          }
        }
      },
      "250": {
        "name": "トラック架装・両ブラシ式・自動追従型・CNG型",
        "items": {
          "001-001": {
            "name": "-"
          }
        }
      }
    }
  },
  "1104": {
    "name": "トンネル清掃車",
    "items": {
      "250": {
        "name": "トラック架装・2本ブラシ式・自動追従型",
        "items": {
          "001-001": {
            "name": "-"
          }
        }
      }
    }
  },
  "1105": {
    "name": "側溝清掃車",
    "items": {
      "017": {
        "name": "ブロワ式",
        "items": {
          "030-020": {
            "name": "ホッパ容量3.0㎥　風量20㎥/min"
          },
          "030-040": {
            "name": "ホッパ容量2.8㎥　風量40㎥/min"
          },
          "045-040": {
            "name": "ホッパ容量4.5~5.0㎥　風量40㎥/min"
          },
          "050-040": {
            "name": "ホッパ容量5.1㎥　風量40㎥/min"
          },
          "090-040": {
            "name": "ホッパ容量9.0㎥　風量40㎥/min"
          },
          "100-040": {
            "name": "ホッパ容量10.3㎥　風量40㎥/min"
          }
        }
      }
    }
  },
  "1106": {
    "name": "排水管清掃車",
    "items": {
      "017": {
        "name": "高圧水洗浄式",
        "items": {
          "020-014": {
            "name": "タンク容量2.0㎥　圧力14MPa"
          },
          "022-054": {
            "name": "タンク容量2.2㎥　圧力54MPa"
          },
          "028-020": {
            "name": "タンク容量2.8㎥　圧力20MPa"
          },
          "053-012": {
            "name": "[ジェット式]タンク容量5.3~5.8㎥　圧力12MPa"
          }
        }
      }
    }
  },
  "1108": {
    "name": "散水車",
    "items": {
      "012": {
        "name": "トラック架装型",
        "items": {
          "018-001": {
            "name": "タンク容量1800ℓ"
          },
          "038-001": {
            "name": "タンク容量3800ℓ"
          },
          "065-001": {
            "name": "タンク容量5500~6500ℓ"
          },
          "080-001": {
            "name": "タンク容量7500~8500ℓ"
          },
          "100-001": {
            "name": "タンク容量10000ℓ"
          }
        }
      }
    }
  },
  "1121": {
    "name": "ラインマーカ",
    "items": {
      "150": {
        "name": "溶融・車載式",
        "items": {
          "030-001": {
            "name": "ライン幅15・20・30cm　ホッパ容量800kg"
          }
        }
      },
      "510": {
        "name": "ペイント・ハンドガイド式",
        "items": {
          "020-001": {
            "name": "ライン幅15・20cm　吐出量1.3ℓ/min"
          }
        }
      },
      "550": {
        "name": "ペイント・車載式",
        "items": {
          "045-001": {
            "name": "ライン幅15・20・30・40cm　吐出量8.0ℓ/min"
          }
        }
      }
    }
  },
  "1123": {
    "name": "高視認性区間線施工機",
    "items": {
      "100": {
        "name": "溶融式",
        "items": {
          "022-001": {
            "name": "-"
          }
        }
      },
      "200": {
        "name": "二液反応式",
        "items": {
          "300-001": {
            "name": "-"
          }
        }
      }
    }
  },
  "1126": {
    "name": "区画線消去機",
    "items": {
      "017": {
        "name": "ハンドガイド式",
        "items": {
          "010-001": {
            "name": "-"
          }
        }
      }
    }
  },
  "1131": {
    "name": "路面切削機",
    "items": {
      "151": {
        "name": "ホイール式・廃材積込装置機",
        "items": {
          "120-001": {
            "name": "切削幅×深さ　0.35m×10cm"
          }
        }
      },
      "153": {
        "name": "ホイール式・廃材積込装置機・排出ガス対策型（第2次基準値）",
        "items": {
          "035-001": {
            "name": "切削幅×深さ　0.5m×20cm"
          },
          "050-001": {
            "name": "切削幅×深さ　1.0m×10cm"
          },
          "100-001": {
            "name": "切削幅×深さ　1.2m×15cm"
          }
        }
      },
      "154": {
        "name": "ホイール式・廃材積込装置機・排出ガス対策型（第3次基準値）",
        "items": {
          "202-001": {
            "name": "切削幅×深さ　2.0m×23cm"
          }
        }
      },
      "251": {
        "name": "クローラ式・廃材積込装置機",
        "items": {
          "100-001": {
            "name": "切削幅×深さ　1.0m×32cm"
          },
          "120-001": {
            "name": "切削幅×深さ　1.2m×32cm"
          },
          "200-001": {
            "name": "切削幅×深さ　2.0m×32cm"
          },
          "210-001": {
            "name": "切削幅×深さ　2.1m×32cm"
          }
        }
      }
    }
  },
  "1133": {
    "name": "路上表層再生機",
    "items": {
      "011": {
        "name": "リミックス用",
        "items": {
          "405-001": {
            "name": "施工幅×かきおこし深さ2.3~4.0×5.0cm"
          },
          "410-001": {
            "name": "施工幅×かきおこし深さ2.5~4.0×9.5cm"
          }
        }
      },
      "021": {
        "name": "リペーブ用",
        "items": {
          "405-001": {
            "name": "施工幅×かきおこし深さ2.3~4.0×5.0cm"
          }
        }
      }
    }
  },
  "1134": {
    "name": "路面ヒータ（路上表層再生用）",
    "items": {
      "012": {
        "name": "間接加熱式",
        "items": {
          "034-001": {
            "name": "加熱面積13㎥　発熱量335万kJ/h"
          },
          "060-001": {
            "name": "加熱面積20~23㎥　発熱量502~586万kJ/h"
          },
          "100-001": {
            "name": "加熱面積38~40㎥　発熱量879~1047万kJ/h"
          }
        }
      },
      "022": {
        "name": "熱風循環式",
        "items": {
          "060-001": {
            "name": "加熱面積20~22㎥　発熱量500~600万kJ/h"
          }
        }
      }
    }
  },
  "1141": {
    "name": "路面安全溝切削機（グルーピング機械）",
    "items": {
      "012": {
        "name": "湿式",
        "items": {
          "020-001": {
            "name": "施工幅200mm"
          },
          "075-001": {
            "name": "施工幅750mm"
          },
          "090-001": {
            "name": "施工幅900mm"
          }
        }
      },
      "022": {
        "name": "乾式",
        "items": {
          "060-001": {
            "name": "施工幅600mm"
          },
          "080-001": {
            "name": "施工幅800mm"
          }
        }
      }
    }
  },
  "1144": {
    "name": "ガードレール支柱打込機",
    "items": {
      "012": {
        "name": "モンケン式",
        "items": {
          "600-001": {
            "name": "モンケン質量400~600kg"
          }
        }
      },
      "013": {
        "name": "エアブレーカ式",
        "items": {
          "070-001": {
            "name": "ブレーカ質量700kg級　打撃周波数530bpm"
          },
          "080-001": {
            "name": "ブレーカ質量800kg級　打撃周波数500"
          }
        }
      }
    }
  },
  "1151": {
    "name": "床版上面増厚機",
    "items": {
      "015": {
        "name": "オンレール式",
        "items": {
          "055-001": {
            "name": "施工幅3.0~5.5m"
          }
        }
      },
      "025": {
        "name": "オフレール式",
        "items": {
          "036-001": {
            "name": "施工幅2.5~3.6m"
          }
        }
      }
    }
  },
  "1153": {
    "name": "マイクロサーフェスマシン",
    "items": {
      "012": {
        "name": "自走式",
        "items": {
          "090-001": {
            "name": "積載質量9.0t"
          }
        }
      }
    }
  },
  "1158": {
    "name": "排水性舗装機能回復機",
    "items": {
      "012": {
        "name": "自走式",
        "items": {
          "021-001": {
            "name": "作業幅2.0~2,1m"
          }
        }
      }
    }
  },
  "1161": {
    "name": "コンクリートカッタ",
    "items": {
      "110": {
        "name": "手動式・湿式",
        "items": {
          "005-001": {
            "name": "切削深5cm級　ブレード径20cm"
          },
          "010-001": {
            "name": "切削深10cm級　ブレード径30cm"
          },
          "015-001": {
            "name": "切削深15cm級　ブレード径45cm"
          }
        }
      },
      "211": {
        "name": "バキューム式・湿式",
        "items": {
          "020-001": {
            "name": "切削深20cm級　ブレード径56cm"
          }
        }
      },
      "215": {
        "name": "バキューム式（超低騒音型）・湿式",
        "items": {
          "030-001": {
            "name": "切削深30cm級　ブレード径75cm"
          },
          "040-001": {
            "name": "切削深40cm級　ブレード径96cm"
          },
          "050-001": {
            "name": "切削深50cm級　ブレード径116cm"
          },
          "060-001": {
            "name": "切削深60cm級　ブレード径137cm"
          },
          "080-001": {
            "name": "切削深70~80cm級　ブレード径178cm"
          }
        }
      },
      "230": {
        "name": "乾式",
        "items": {
          "020-001": {
            "name": "切削深20cm級　ブレード径44~56cm"
          }
        }
      },
      "910": {
        "name": "人孔外周切断機",
        "items": {
          "180-001": {
            "name": "最大切断線直径1800mm"
          }
        }
      }
    }
  },
  "1201": {
    "name": "空気圧縮機",
    "items": {
      "031": {
        "name": "可搬式・エンジン駆動・スクリュ型",
        "items": {
          "255-024": {
            "name": "吐出量25.5㎥/min　吐出圧力2.41MPa"
          },
          "360-013": {
            "name": "吐出量36㎥/min　吐出圧力1.27/1.03MPa"
          }
        }
      },
      "032": {
        "name": "可搬式・エンジン駆動・スクリュ型・排出ガス対策型（第1次基準値）",
        "items": {
          "014-007": {
            "name": "吐出量1.4㎥/min　吐出圧力0.7MPa"
          },
          "020-007": {
            "name": "吐出量2.0㎥/min　吐出圧力0.7MPa"
          },
          "025-007": {
            "name": "吐出量2.5㎥/min　吐出圧力0.7MPa"
          },
          "142-007": {
            "name": "吐出量14.2㎥/min　吐出圧力0.7MPa"
          }
        }
      },
      "033": {
        "name": "可搬式・エンジン駆動・スクリュ型・排出ガス対策型（第2次基準値）",
        "items": {
          "037-007": {
            "name": "吐出量3.5~3.7㎥/min　吐出圧力0.7MPa"
          },
          "050-007": {
            "name": "吐出量5.0㎥/min　吐出圧力0.7MPa"
          },
          "078-007": {
            "name": "吐出量7.5~7.8㎥/min　吐出圧力0.7MPa"
          },
          "110-007": {
            "name": "吐出量10.5~11㎥/min　吐出圧力0.7MPa"
          },
          "190-007": {
            "name": "吐出量18~19㎥/min　吐出圧力0.7MPa"
          },
          "210-007": {
            "name": "吐出量20~21㎥/min　吐出圧力0.7MPa"
          }
        }
      },
      "042": {
        "name": "可搬式・エンジン駆動・スクリュ型（超低騒音型）・排出ガス対策型（第1次基準値）",
        "items": {
          "075-007": {
            "name": "吐出量7.5㎥/min　吐出圧力0.7MPa"
          }
        }
      },
      "043": {
        "name": "可搬式・エンジン駆動・スクリュ型（超低騒音型）・排出ガス対策型（第2次基準値）",
        "items": {
          "017-007": {
            "name": "吐出量1.7㎥/min　吐出圧力0.7MPa"
          },
          "020-007": {
            "name": "吐出量2.0㎥/min　吐出圧力0.7MPa"
          },
          "025-007": {
            "name": "吐出量2.5㎥/min　吐出圧力0.7MPa"
          },
          "051-007": {
            "name": "吐出量5.0~5.1㎥/min　吐出圧力0.7MPa"
          },
          "078-007": {
            "name": "吐出量7.5~7.8㎥/min　吐出圧力0.7MPa"
          },
          "110-007": {
            "name": "吐出量10.5~11㎥/min　吐出圧力0.7MPa"
          },
          "150-010": {
            "name": "吐出量15.0㎥/min　吐出圧力0.7MPa"
          },
          "170-007": {
            "name": "吐出量17.0㎥/min　吐出圧力0.7MPa"
          },
          "194-007": {
            "name": "吐出量19.4㎥/min　吐出圧力0.7MPa"
          },
          "227-007": {
            "name": "吐出量22.7㎥/min　吐出圧力0.7MPa"
          }
        }
      },
      "044": {
        "name": "可搬式・エンジン駆動・スクリュ型（超低騒音型）・排出ガス対策型（第3次基準値）",
        "items": {
          "017-007": {
            "name": "吐出量1.6~1.7㎥/min　吐出圧力0.7MPa"
          },
          "021-007": {
            "name": "吐出量2.0~2.1㎥/min　吐出圧力0.7MPa"
          },
          "028-007": {
            "name": "吐出量2.5~2.8㎥/min　吐出圧力0.7MPa"
          },
          "037-007": {
            "name": "吐出量3.5~3.7㎥/min　吐出圧力0.7MPa"
          },
          "050-007": {
            "name": "吐出量5.0㎥/min　吐出圧力0.7MPa"
          },
          "122-007": {
            "name": "吐出量12.2㎥/min　吐出圧力0.7MPa"
          },
          "255-007": {
            "name": "吐出量25.5㎥/min　吐出圧力0.7MPa"
          }
        }
      }
    }
  },
  "1301": {
    "name": "小型渦巻ポンプ",
    "items": {
      "037": {
        "name": "可搬・自吸・エンジン駆動型",
        "items": {
          "040-030": {
            "name": "口径Φ40mm全揚程30m"
          },
          "050-030": {
            "name": "口径Φ50mm全揚程30m"
          },
          "080-030": {
            "name": "口径Φ80mm全揚程30m"
          }
        }
      }
    }
  },
  "1510": {
    "name": "発動発電機",
    "items": {
      "017": {
        "name": "ガソリンエンジン駆動",
        "items": {
          "001-001": {
            "name": "定格容量1kVA"
          },
          "002-001": {
            "name": "定格容量2kVA"
          },
          "003-001": {
            "name": "定格容量3kVA"
          },
          "005-001": {
            "name": "定格容量5kVA"
          }
        }
      },
      "021": {
        "name": "ディーゼルエンジン",
        "items": {
          "001-003": {
            "name": "定格容量（50/60Hz）2.7/3kVA"
          },
          "001-005": {
            "name": "定格容量（50/60Hz）4.5/5kVA"
          },
          "010-060": {
            "name": "定格容量（50/60Hz）550/600kVA"
          },
          "010-080": {
            "name": "定格容量（50/60Hz）700/800kVA"
          },
          "010-110": {
            "name": "定格容量（50/60Hz）1000/1100kVA"
          }
        }
      },
      "022": {
        "name": "ディーゼルエンジン駆動・排出ガス対策型（第1次基準値）",
        "items": {
          "001-015": {
            "name": "定格容量（50/60Hz）13/15kVA"
          },
          "001-020": {
            "name": "定格容量（50/60Hz）17/20kVA"
          },
          "001-025": {
            "name": "定格容量（50/60Hz）20/25kVA"
          },
          "001-045": {
            "name": "定格容量（50/60Hz）37/45kVA"
          },
          "001-060": {
            "name": "定格容量（50/60Hz）50/60kVA"
          },
          "001-075": {
            "name": "定格容量（50/60Hz）65/75kVA"
          },
          "010-012": {
            "name": "定格容量（50/60Hz）100/125kVA"
          },
          "010-015": {
            "name": "定格容量（50/60Hz）125/150kVA"
          }
        }
      },
      "023": {
        "name": "ディーゼルエンジン駆動・排出ガス対策型（第2次基準値）",
        "items": {
          "010-050": {
            "name": "定格容量（50/60Hz）450/500kVA"
          }
        }
      },
      "024": {
        "name": "ディーゼルエンジン駆動・排出ガス対策型（第3次基準値）",
        "items": {
          "010-030": {
            "name": "定格容量（50/60Hz）270/300kVA"
          },
          "010-040": {
            "name": "定格容量（50/60Hz）350/400kVA"
          }
        }
      },
      "032": {
        "name": "ディーゼルエンジン駆動（超低騒音型）・排出ガス対策型（第1次基準値）",
        "items": {
          "001-035": {
            "name": "定格容量（50/60Hz）30/35kVA"
          },
          "001-075": {
            "name": "定格容量（50/60Hz）65/75kVA"
          }
        }
      },
      "034": {
        "name": "ディーゼルエンジン駆動（超低騒音型）・排出ガス対策型（第3次基準値）",
        "items": {
          "001-010": {
            "name": "定格容量（50/60Hz）10.5/13kVA"
          },
          "001-015": {
            "name": "定格容量（50/60Hz）13/15kVA"
          },
          "001-020": {
            "name": "定格容量（50/60Hz）17/20kVA"
          },
          "001-025": {
            "name": "定格容量（50/60Hz）20/25kVA"
          },
          "001-045": {
            "name": "定格容量（50/60Hz）37/45kVA"
          },
          "001-060": {
            "name": "定格容量（50/60Hz）50/60kVA"
          },
          "010-010": {
            "name": "定格容量（50/60Hz）80/100kVA"
          },
          "010-012": {
            "name": "定格容量（50/60Hz）100/125kVA"
          },
          "010-015": {
            "name": "定格容量（50/60Hz）125/150kVA"
          },
          "010-022": {
            "name": "定格容量（50/60Hz）200/220kVA"
          }
        }
      },
      "044": {
        "name": "ディーゼルエンジン駆動（超低騒音型・大容量タンク型）・排出ガス対策型（第3次基準値）",
        "items": {
          "001-010": {
            "name": "定格容量（50/60Hz）10.5/13kVA"
          },
          "001-025": {
            "name": "定格容量（50/60Hz）20/25kVA"
          },
          "001-045": {
            "name": "定格容量（50/60Hz）37/45kVA"
          },
          "001-060": {
            "name": "定格容量（50/60Hz）50/60kVA"
          },
          "010-010": {
            "name": "定格容量（50/60Hz）80/100kVA"
          },
          "010-012": {
            "name": "定格容量（50/60Hz）100/125kVA"
          },
          "010-015": {
            "name": "定格容量（50/60Hz）125/150kVA"
          },
          "010-022": {
            "name": "定格容量（50/60Hz）200/220kVA"
          }
        }
      }
    }
  },
  "1602": {
    "name": "ウインチ",
    "items": {
      "152": {
        "name": "開放型（エンジン駆動）・複胴",
        "items": {
          "150-001": {
            "name": "巻上能力1.5t×42m/min　巻取容量Φ12×850m+Φ2.12×1020m"
          }
        }
      }
    }
  },
  "1818": {
    "name": "多軸式特殊台車",
    "items": {
      "010": {
        "name": "自走式",
        "items": {
          "165-001": {
            "name": "積載能力165t"
          },
          "250-001": {
            "name": "積載能力250t"
          }
        }
      }
    }
  },
  "2005": {
    "name": "バイブレータ用電源装置",
    "items": {
      "100": {
        "name": "高周波発電機（ガソリンエンジン式）",
        "items": {
          "013-001": {
            "name": "定格容量1.3kVA　電圧48V　電流15.6A"
          },
          "020-001": {
            "name": "定格容量2.0kVA　電圧48V　電流23.0A"
          },
          "030-001": {
            "name": "定格容量3.0kVA　電圧48V　電流37.0A"
          }
        }
      }
    }
  },
  "2012": {
    "name": "コンクリート吹付機",
    "items": {
      "017": {
        "name": "湿式",
        "items": {
          "060-001": {
            "name": "能力6㎥/h　所要空気量10㎥/min"
          }
        }
      },
      "027": {
        "name": "乾式",
        "items": {
          "040-001": {
            "name": "能力4㎥/h　所要空気量10㎥/min"
          }
        }
      }
    }
  },
  "2015": {
    "name": "コンクリート穿孔機",
    "items": {
      "012": {
        "name": "油圧式コアボーリングマシン",
        "items": {
          "060-001": {
            "name": "最大穿孔径Φ60cm級"
          }
        }
      }
    }
  },
  "2021": {
    "name": "中小型トラック（ダブルキャブ）",
    "items": {
      "012": {
        "name": "ガソリンエンジン駆動",
        "items": {
          "608-001": {
            "name": "乗車定員6名　最大積載質量750kg"
          },
          "613-001": {
            "name": "乗車定員6名　最大積載質量1250kg"
          },
          "618-001": {
            "name": "乗車定員6名　最大積載質量1750kg"
          }
        }
      },
      "022": {
        "name": "ディーゼルエンジン駆動",
        "items": {
          "608-001": {
            "name": "乗車定員6名　最大積載質量750kg"
          },
          "613-001": {
            "name": "乗車定員6名　最大積載質量1250kg"
          },
          "618-001": {
            "name": "乗車定員6名　最大積載質量1750kg"
          },
          "620-001": {
            "name": "乗車定員6名　最大積載質量2000kg"
          }
        }
      }
    }
  },
  "2022": {
    "name": "ライトバン",
    "items": {
      "200": {
        "name": "二輪駆動",
        "items": {
          "015-001": {
            "name": "乗車定員5名　排気量1.5ℓ"
          },
          "020-001": {
            "name": "乗車定員5名　排気量2ℓ"
          }
        }
      },
      "400": {
        "name": "四輪駆動",
        "items": {
          "015-001": {
            "name": "乗車定員5名　排気量1.5ℓ"
          }
        }
      }
    }
  },
  "2031": {
    "name": "草刈機",
    "items": {
      "100": {
        "name": "肩掛式",
        "items": {
          "230-001": {
            "name": "カッタ径Φ230mm"
          },
          "255-001": {
            "name": "カッタ径Φ255mm"
          }
        }
      },
      "310": {
        "name": "ハンドガイド式・芝用",
        "items": {
          "060-001": {
            "name": "刈幅55~65cm"
          },
          "080-001": {
            "name": "刈幅77cm"
          }
        }
      },
      "510": {
        "name": "ハンドガイド式・笹/ヨシ等用",
        "items": {
          "070-001": {
            "name": "刈幅70cm"
          },
          "095-001": {
            "name": "刈幅95cm"
          },
          "150-001": {
            "name": "［簡易搭乗型］刈幅150cm"
          },
          "170-001": {
            "name": "［簡易搭乗型］刈幅170cm"
          }
        }
      },
      "535": {
        "name": "遠隔操縦式",
        "items": {
          "120-001": {
            "name": "刈幅120cm"
          },
          "185-001": {
            "name": "刈幅185cm"
          }
        }
      }
    }
  },
  "2032": {
    "name": "集草機",
    "items": {
      "510": {
        "name": "ハンドガイド式",
        "items": {
          "160-001": {
            "name": "集草幅160cm"
          },
          "200-001": {
            "name": "［簡易搭乗型］200cm"
          }
        }
      },
      "535": {
        "name": "遠隔操縦式",
        "items": {
          "180-001": {
            "name": "集草幅180cm"
          }
        }
      }
    }
  },
  "2033": {
    "name": "刈草梱包機械",
    "items": {
      "530": {
        "name": "ハンドガイド式",
        "items": {
          "100-070": {
            "name": "［簡易搭乗型］ディーゼルエンジン駆動　梱包系×幅Φ50×70cm"
          },
          "200-070": {
            "name": "［簡易搭乗型］ガソリンエンジン駆動　梱包系×幅Φ50×70cm"
          }
        }
      }
    }
  },
  "2035": {
    "name": "チェンソー",
    "items": {
      "017": {
        "name": "ガソリンエンジン",
        "items": {
          "035-001": {
            "name": "鋸長350mm　エンジン排気量0.034ℓ"
          },
          "050-001": {
            "name": "鋸長500mm　エンジン排気量0.06ℓ"
          },
          "060-001": {
            "name": "鋸長600mm　エンジン排気量0.08ℓ"
          }
        }
      }
    }
  },
  "2037": {
    "name": "薬剤散布機",
    "items": {
      "017": {
        "name": "背負式",
        "items": {
          "015-001": {
            "name": "1.5kW級"
          },
          "022-001": {
            "name": "2.2kW級"
          }
        }
      }
    }
  },
  "2038": {
    "name": "種子吹付機",
    "items": {
      "027": {
        "name": "車載式（種子専用）",
        "items": {
          "100-001": {
            "name": "タンク容量1.0㎥　搭載トラック1t車"
          },
          "200-001": {
            "name": "タンク容量2.0㎥　搭載トラック2t車"
          },
          "250-001": {
            "name": "タンク容量2.5㎥　搭載トラック3t車"
          },
          "300-001": {
            "name": "タンク容量3.0㎥　搭載トラック4t車"
          },
          "400-001": {
            "name": "タンク容量4.0㎥　搭載トラック4t車"
          }
        }
      },
      "037": {
        "name": "車載式（客土用）",
        "items": {
          "400-001": {
            "name": "タンク容量4.0㎥　搭載トラック4t車"
          }
        }
      },
      "047": {
        "name": "車載式（厚層植生基材吹付用）",
        "items": {
          "250-001": {
            "name": "タンク容量2.5+0.3㎥　搭載トラック4t車"
          },
          "460-001": {
            "name": "タンク容量4.6+0.4㎥　搭載トラック4t車"
          },
          "500-001": {
            "name": "タンク容量5.0+0.5㎥　搭載トラック4t車"
          }
        }
      }
    }
  },
  "2041": {
    "name": "トラクタ",
    "items": {
      "110": {
        "name": "ホイール式",
        "items": {
          "010-001": {
            "name": "機械質量1t級"
          }
        }
      }
    }
  },
  "2051": {
    "name": "自走式破砕機",
    "items": {
      "017": {
        "name": "ジョークラッシャー",
        "items": {
          "010-001": {
            "name": "機械質量10t級　供給口開き×幅325×600mm"
          },
          "020-001": {
            "name": "機械質量20t級　供給口開き×幅375×750mm"
          },
          "030-001": {
            "name": "機械質量30t級　供給口開き×幅450×925mm"
          },
          "050-001": {
            "name": "機械質量50t級　供給口開き×幅750×1100mm"
          }
        }
      }
    }
  },
  "2052": {
    "name": "自走式土質改良機",
    "items": {
      "017": {
        "name": "解砕・固化材混合式",
        "items": {
          "010-001": {
            "name": "機械質量10t級"
          },
          "020-001": {
            "name": "機械質量20t級"
          },
          "030-001": {
            "name": "機械質量30t級"
          }
        }
      }
    }
  },
  "2053": {
    "name": "自走式木材破砕機",
    "items": {
      "017": {
        "name": "タブ式",
        "items": {
          "150-001": {
            "name": "機関出力130~150kW"
          },
          "270-001": {
            "name": "機関出力230~270kW"
          },
          "300-001": {
            "name": "機関出力290~300kW"
          },
          "400-001": {
            "name": "機関出力370~440kW"
          }
        }
      },
      "027": {
        "name": "横入れ式",
        "items": {
          "100-001": {
            "name": "機関出力100kW"
          },
          "160-001": {
            "name": "機関出力130~160kW"
          },
          "270-001": {
            "name": "機関出力230~270kW"
          },
          "350-001": {
            "name": "機関出力330~350kW"
          },
          "400-001": {
            "name": "機関出力370~400kW"
          }
        }
      }
    }
  },
  "2061": {
    "name": "ベルトコンベヤ（ポータブル）",
    "items": {
      "017": {
        "name": "エンジン駆動",
        "items": {
          "007-001": {
            "name": "ベルト幅350mm　機長7m"
          }
        }
      }
    }
  },
  "2071": {
    "name": "高圧洗浄機",
    "items": {
      "021": {
        "name": "工事用・エンジン駆動",
        "items": {
          "070-015": {
            "name": "吐出量35~70ℓ/min　圧力14.7MPa"
          }
        }
      }
    }
  },
  "2072": {
    "name": "パッカー車",
    "items": {
      "011": {
        "name": "回転式",
        "items": {
          "040-001": {
            "name": "積載容量4㎥"
          },
          "080-001": {
            "name": "積載容量8㎥"
          }
        }
      }
    }
  },
  "2081": {
    "name": "電気溶接機",
    "items": {
      "510": {
        "name": "ガソリンエンジン駆動・直流アーク式",
        "items": {
          "135-001": {
            "name": "最大溶接電流135A"
          },
          "150-001": {
            "name": "最大溶接電流150A"
          },
          "180-001": {
            "name": "最大溶接電流180A"
          }
        }
      },
      "531": {
        "name": "ディーゼルエンジン駆動・直流アーク式",
        "items": {
          "180-001": {
            "name": "最大溶接電流180A"
          },
          "250-001": {
            "name": "最大溶接電流250A"
          },
          "300-001": {
            "name": "最大溶接電流300A"
          }
        }
      },
      "532": {
        "name": "ディーゼルエンジン駆動・直流アーク式・排出ガス対策型（第1次基準値）",
        "items": {
          "250-001": {
            "name": "最大溶接電流250A"
          },
          "300-001": {
            "name": "最大溶接電流300A"
          },
          "400-001": {
            "name": "最大溶接電流400A"
          },
          "500-001": {
            "name": "最大溶接電流500A"
          }
        }
      },
      "533": {
        "name": "ディーゼルエンジン駆動・直流アーク式・排出ガス対策型（第2次基準値）",
        "items": {
          "200-001": {
            "name": "最大溶接電流200A"
          },
          "300-001": {
            "name": "最大溶接電流300A"
          },
          "400-001": {
            "name": "最大溶接電流400A"
          },
          "500-001": {
            "name": "最大溶接電流500A"
          }
        }
      },
      "534": {
        "name": "ディーゼルエンジン駆動・直流アーク式・排出ガス対策型（第3次基準値）",
        "items": {
          "230-001": {
            "name": "最大溶接電流230A"
          },
          "300-001": {
            "name": "最大溶接電流300A"
          }
        }
      }
    }
  },
  "2088": {
    "name": "トラック式アースオーガ",
    "items": {
      "100": {
        "name": "建柱車",
        "items": {
          "450-020": {
            "name": "オーガΦ450mm　吊能力2.0t"
          },
          "450-030": {
            "name": "オーガΦ450mm　吊能力2.9t"
          }
        }
      }
    }
  },
  "5020": {
    "name": "除雪ドーザ（ホイール型）",
    "items": {
      "111": {
        "name": "プラウ・バケット兼用型",
        "items": {
          "050": {
            "name": "機械質量5t級　標準山積容量0.8㎥"
          },
          "060": {
            "name": "機械質量6t級　標準山積容量1㎥"
          },
          "070": {
            "name": "機械質量7t級　標準山積容量1.2㎥"
          }
        }
      },
      "112": {
        "name": "プラウ・バケット兼用型・排出ガス対策型（第1次基準値）",
        "items": {
          "130": {
            "name": "機械質量13t級　標準山積容量2.4~2.6㎥"
          },
          "131": {
            "name": "（中速型）機械質量13t級　標準山積容量1.9㎥"
          },
          "160": {
            "name": "機械質量16t級　標準山積容量3.1~3.3㎥"
          },
          "080": {
            "name": "機械質量8t級　標準山積容量1.3~1.4㎥"
          }
        }
      },
      "113": {
        "name": "プラウ・バケット兼用型・排出ガス対策型（第2次基準値）",
        "items": {
          "110": {
            "name": "機械質量11t級　標準山積容量2.1㎥"
          },
          "130": {
            "name": "機械質量13t級　標準山積容量2.4~2.6㎥"
          },
          "131": {
            "name": "（中速型）機械質量13t級　標準山積容量1.9㎥"
          },
          "190": {
            "name": "機械質量19t級　標準山積容量3.4~3.7㎥"
          },
          "080": {
            "name": "機械質量8t級　標準山積容量1.3~1.4㎥"
          }
        }
      },
      "114": {
        "name": "プラウ・バケット兼用型・排出ガス対策型（第3次基準値）",
        "items": {
          "110": {
            "name": "機械質量11t級　標準山積容量2.1㎥"
          },
          "130": {
            "name": "機械質量13t級　標準山積容量2.4~2.6㎥"
          },
          "190": {
            "name": "機械質量19t級　標準山積容量3.4~3.7㎥"
          },
          "080": {
            "name": "機械質量8t級　標準山積容量1.3~1.4㎥"
          }
        }
      },
      "115": {
        "name": "プラウ・バケット兼用型・排出ガス対策型（2011年規制）",
        "items": {
          "110": {
            "name": "機械質量11t級　標準山積容量2.1㎥"
          },
          "140": {
            "name": "機械質量14t級　標準山積容量2.5~3.0㎥"
          },
          "180": {
            "name": "機械質量18t級　標準山積容量3.3~3.7㎥"
          },
          "080": {
            "name": "機械質量8t級　標準山積容量1.3~1.4㎥"
          }
        }
      },
      "116": {
        "name": "プラウ・バケット兼用型・排出ガス対策型（2014年規制）",
        "items": {
          "110": {
            "name": "機械質量11t級　標準山積容量2.1㎥"
          },
          "140": {
            "name": "機械質量14t級　標準山積容量2.5~3.0㎥"
          },
          "180": {
            "name": "機械質量18t級　標準山積容量3.4~3.7㎥"
          }
        }
      },
      "211": {
        "name": "プラウ専用型",
        "items": {
          "190": {
            "name": "機械質量19t級"
          }
        }
      },
      "212": {
        "name": "プラウ専用型・排出ガス対策型（第1次基準値）",
        "items": {
          "190": {
            "name": "機械質量19t級"
          }
        }
      },
      "213": {
        "name": "プラウ専用型・排出ガス対策型（第2次基準値）",
        "items": {
          "190": {
            "name": "機械質量19t級"
          }
        }
      }
    }
  },
  "5029": {
    "name": "除雪ドーザ（ホイール型）用アタッチメント",
    "items": {
      "111": {
        "name": "ロータリ除雪装置（2ステージ・ユニット型）",
        "items": {
          "120": {
            "name": "機関出力90kW（120ps）級"
          },
          "080": {
            "name": "機関出力60kW（80ps）級"
          }
        }
      },
      "112": {
        "name": "ロータリ除雪装置（2ステージ・ユニット型）・排出ガス対策型（第1次基準値）",
        "items": {
          "120": {
            "name": "機関出力90kW（120ps）級"
          },
          "080": {
            "name": "機関出力60kW（80ps）級"
          }
        }
      },
      "113": {
        "name": "ロータリ除雪装置（2ステージ・ユニット型）・排出ガス対策型（第2次基準値）",
        "items": {
          "120": {
            "name": "機関出力90kW（120ps）級"
          },
          "080": {
            "name": "機関出力60kW（80ps）級"
          }
        }
      },
      "114": {
        "name": "ロータリ除雪装置（2ステージ・ユニット型）・排出ガス対策型（第3次基準値）",
        "items": {
          "150": {
            "name": "機関出力110kW（150ps）級"
          }
        }
      }
    }
  },
  "5030": {
    "name": "除雪トラック",
    "items": {
      "100": {
        "name": "ダンプ架装型",
        "items": {
          "100": {
            "name": "積載質量10t級　駆動方式6×4"
          },
          "102": {
            "name": "積載質量10t級　駆動方式6×4"
          },
          "020": {
            "name": "積載質量2t級　駆動方式4×4"
          },
          "040": {
            "name": "積載質量4t級　駆動方式4×4"
          },
          "060": {
            "name": "積載質量6t級　駆動方式4×4"
          },
          "070": {
            "name": "積載質量7t級　駆動方式4×4"
          }
        }
      },
      "200": {
        "name": "除雪専用型",
        "items": {
          "100": {
            "name": "積載質量10t級　駆動方式6×4"
          },
          "101": {
            "name": "積載質量10t級　駆動方式4×4"
          },
          "102": {
            "name": "積載質量10t級　駆動方式4×6"
          },
          "040": {
            "name": "積載質量4t級　駆動方式4×4"
          },
          "060": {
            "name": "積載質量6t級　駆動方式4×4"
          },
          "070": {
            "name": "積載質量7t級　駆動方式4×4"
          }
        }
      }
    }
  },
  "5040": {
    "name": "除雪グレーダ",
    "items": {
      "114": {
        "name": "排出ガス対策型（第3次基準値）",
        "items": {
          "310": {
            "name": "ブレード幅3.1m"
          },
          "370": {
            "name": "ブレード幅3.7m"
          },
          "400": {
            "name": "ブレード幅4.0m"
          },
          "430": {
            "name": "ブレード幅4.3m"
          }
        }
      },
      "116": {
        "name": "排出ガス対策型（2014年規制）",
        "items": {
          "400": {
            "name": "[ワンマンキャブ]ブレード幅3.7~4.3m"
          }
        }
      },
      "314": {
        "name": "自動ブレード敷・排出ガス対策型（第3次基準値）",
        "items": {
          "400": {
            "name": "ブレード幅4.0m"
          },
          "430": {
            "name": "ブレード幅4.3m"
          }
        }
      }
    }
  },
  "5050": {
    "name": "ロータリ式除雪機械",
    "items": {
      "212": {
        "name": "ロータリ除雪車（ホイール・2ステージ型）・排出ガス対策型（第1次基準値）",
        "items": {
          "330": {
            "name": "除雪幅2.6m級　機関出力240kW（330ps）級"
          }
        }
      },
      "213": {
        "name": "ロータリ除雪車（ホイール・2ステージ型）・排出ガス対策型（第2次基準値）",
        "items": {
          "500": {
            "name": "除雪幅2.6m級　機関出力360kW（500ps）級"
          }
        }
      },
      "214": {
        "name": "ロータリ除雪車（ホイール・2ステージ型）・排出ガス対策型（第3次基準値）",
        "items": {
          "100": {
            "name": "除雪幅1.5~1.8m級　機関出力75kW（100ps）級"
          },
          "130": {
            "name": "除雪幅1.5~1.8m級　機関出力90kW（130ps）級"
          },
          "250": {
            "name": "除雪幅2.2~2.6m級　機関出力180kW（250ps）級"
          },
          "300": {
            "name": "除雪幅2.6m級　機関出力220kW（300ps）級"
          },
          "400": {
            "name": "除雪幅2.6m級　機関出力290kW（400ps）級"
          },
          "600": {
            "name": "除雪幅2.6m級　機関出力440kW（600ps）級"
          },
          "040": {
            "name": "除雪幅1.0m級　機関出力30kW（40ps）級"
          },
          "080": {
            "name": "除雪幅1.3~1.5m級　機関出力60kW（80ps）級"
          }
        }
      },
      "312": {
        "name": "一車線積込除雪車・ロータリ式・排出ガス対策型（第1次基準値）",
        "items": {
          "175": {
            "name": "機関出力130kW（175ps）級"
          },
          "250": {
            "name": "機関出力180kW（250ps）級"
          }
        }
      },
      "313": {
        "name": "一車線積込除雪車・ロータリ式・排出ガス対策型（第2次基準値）",
        "items": {
          "250": {
            "name": "機関出力180kW（250ps）級"
          }
        }
      },
      "314": {
        "name": "一車線積込除雪車・ロータリ式・排出ガス対策型（第3次基準値）",
        "items": {
          "300": {
            "name": "機関出力220kW（300ps）級"
          }
        }
      },
      "514": {
        "name": "多機能型ロータリ除雪車・排出ガス対策型（第3次基準値）",
        "items": {
          "340": {
            "name": "除雪車（ロータリ/ブラウ）2.6/3.0m　機関出力250kW（340ps）級"
          }
        }
      }
    }
  },
  "5060": {
    "name": "小型ロータリ除雪機",
    "items": {
      "011": {
        "name": "クローラ・ハンドガイド型・ガソリンエンジン駆動",
        "items": {
          "006": {
            "name": "機関出力4kW（6ps）級"
          },
          "009": {
            "name": "機関出力7kW（9ps）級"
          },
          "011": {
            "name": "機関出力8kW（11ps）級"
          },
          "012": {
            "name": "機関出力9kW（12ps）級"
          },
          "016": {
            "name": "機関出力12kW（16ps）級"
          },
          "020": {
            "name": "機関出力15kW（20ps）級"
          },
          "030": {
            "name": "機関出力22kW（30ps）級"
          }
        }
      },
      "021": {
        "name": "クローラ・ハンドガイド型・ディーゼルエンジン駆動",
        "items": {
          "006": {
            "name": "機関出力4kW（6ps）級"
          },
          "009": {
            "name": "機関出力7kW（9ps）級"
          },
          "016": {
            "name": "機関出力12kW（16ps）級"
          },
          "025": {
            "name": "機関出力18kW（25ps）級"
          },
          "038": {
            "name": "機関出力28kW（38ps）級"
          }
        }
      }
    }
  },
  "5070": {
    "name": "凍結防止剤散布車",
    "items": {
      "110": {
        "name": "乾式",
        "items": {
          "325": {
            "name": "乾燥散布剤積載量3t級　ホッバ容量2.5㎥　シャシ（駆動方式）5.5t車以上（4×4）"
          },
          "435": {
            "name": "乾燥散布剤積載量4t級　ホッバ容量3.5㎥　シャシ（駆動方式）5.5t車以上（4×4）"
          },
          "540": {
            "name": "乾燥散布剤積載量5t級　ホッバ容量4.0㎥　シャシ（駆動方式）7t車以上（4×4）"
          }
        }
      },
      "120": {
        "name": "湿式",
        "items": {
          "325": {
            "name": "乾燥散布剤積載量3t級　ホッバ容量2.5㎥　シャシ（駆動方式）5.5t車以上（4×4）"
          },
          "435": {
            "name": "乾燥散布剤積載量4t級　ホッバ容量3.5㎥　シャシ（駆動方式）5.5t車以上（4×4）"
          },
          "540": {
            "name": "乾燥散布剤積載量5t級　ホッバ容量4.0㎥　シャシ（駆動方式）7t車以上（4×4）"
          },
          "760": {
            "name": "乾燥散布剤積載量7t級　ホッバ容量6.0㎥　シャシ（駆動方式）10t車以上（6×4）"
          }
        }
      },
      "130": {
        "name": "湿潤式",
        "items": {
          "325": {
            "name": "乾燥散布剤積載量3t級　ホッバ容量2.5㎥　シャシ（駆動方式）5.5t車以上（4×4）"
          },
          "434": {
            "name": "乾燥散布剤積載量4t級　ホッバ容量3.4㎥　シャシ（駆動方式）5.5t車以上（4×4）"
          },
          "650": {
            "name": "乾燥散布剤積載量6t級　ホッバ容量5.0㎥　シャシ（駆動方式）7t車以上（4×4）"
          }
        }
      }
    }
  },
  "5075": {
    "name": "凍結防止剤散布車用シャシ",
    "items": {
      "100": {
        "name": "10t級",
        "items": {
          "441": {
            "name": "駆動方式4×4"
          },
          "641": {
            "name": "駆動方式6×6"
          }
        }
      }
    }
  },
  "5099": {
    "name": "その他除雪用機械",
    "items": {
      "111": {
        "name": "雪上車（乗用・クローラ・ディーゼルエンジン）",
        "items": {
          "005": {
            "name": "5人乗"
          },
          "010": {
            "name": "10人乗"
          }
        }
      },
      "211": {
        "name": "多目的作業者（オンロード・ホイール型）",
        "items": {
          "147": {
            "name": "機関出力110kW（147ps）級駆動方式4×4"
          },
          "173": {
            "name": "機関出力130kW（173ps）級駆動方式4×4"
          },
          "088": {
            "name": "機関出力66kW（88ps）級駆動方式4×4"
          }
        }
      }
    }
  },
  "0101": {
    "name": "ブルドーザ",
    "items": {
      "126": {
        "name": "湿地・ＩＣＴ施工対応型・排出ガス対策型",
        "items": {
          "070-302": {
            "name": "7t級"
          },
          "160-302": {
            "name": "16t級"
          },
          "200-302": {
            "name": "20t級"
          }
        }
      },
      "014": {
        "name": "普通・排出ガス対策型",
        "items": {
          "030-001": {
            "name": "3t級"
          },
          "060-001": {
            "name": "6t級"
          },
          "090-001": {
            "name": "9t級"
          },
          "015-001": {
            "name": "15t級"
          },
          "018-001": {
            "name": "18t級"
          },
          "021-001": {
            "name": "21t級"
          },
          "032-001": {
            "name": "32t級"
          }
        }
      },
      "024": {
        "name": "湿地・排出ガス対策型",
        "items": {
          "040-001": {
            "name": "4t級"
          },
          "070-001": {
            "name": "7t級"
          },
          "100-001": {
            "name": "10t級"
          },
          "130-001": {
            "name": "13t級"
          },
          "160-001": {
            "name": "16t級"
          },
          "200-001": {
            "name": "20t級"
          },
          "280-001": {
            "name": "28t級"
          }
        }
      },
      "032": {
        "name": "超湿地・排出ガス対策型（第１次基準値）",
        "items": {
          "100-001": {
            "name": "10t級"
          }
        }
      },
      "034": {
        "name": "超湿地・排出ガス対策型（第３次基準値）",
        "items": {
          "040-001": {
            "name": "4t級"
          },
          "180-001": {
            "name": "18t級"
          }
        }
      },
      "044": {
        "name": "超々湿地・排出ガス対策型",
        "items": {
          "040-001": {
            "name": "4t級"
          },
          "100-001": {
            "name": "10t級"
          }
        }
      },
      "051": {
        "name": "リッパ装置付",
        "items": {
          "440-001": {
            "name": "44t級"
          },
          "630-001": {
            "name": "63t級"
          },
          "950-001": {
            "name": "95t級"
          }
        }
      },
      "054": {
        "name": "リッパ装置付・排出ガス対策型",
        "items": {
          "180-001": {
            "name": "18t級"
          },
          "210-001": {
            "name": "21t級"
          },
          "320-001": {
            "name": "32t級"
          },
          "440-001": {
            "name": "44t級"
          },
          "630-001": {
            "name": "63t級"
          }
        }
      }
    }
  },
  "0104": {
    "name": "スクレープドーザ",
    "items": {
      "011": {
        "name": "普通型",
        "items": {
          "268-001": {
            "name": "26t級"
          }
        }
      }
    }
  },
  "0201": {
    "name": "小型バックホウ（クローラ型）",
    "items": {
      "111": {
        "name": "標準型",
        "items": {
          "001-001": {
            "name": "標準バケット容量（山積／平積）0.001／0.008m3"
          },
          "002-001": {
            "name": "標準バケット容量（山積／平積）0.022／0.015m3"
          }
        }
      },
      "112": {
        "name": "標準型・排出ガス対策型",
        "items": {
          "003-001": {
            "name": "標準バケット容量（山積／平積）0.044／0.03m3"
          },
          "004-001": {
            "name": "標準バケット容量（山積／平積）0.055／0.44m3"
          },
          "006-001": {
            "name": "標準バケット容量（山積／平積）0.08／0.06m3"
          }
        }
      },
      "113": {
        "name": "標準型・排出ガス対策型",
        "items": {
          "006-001": {
            "name": "標準バケット容量（山積／平積）0.08／0.06m3"
          },
          "008-001": {
            "name": "標準バケット容量（山積／平積）0.11／0.08m3"
          },
          "010-001": {
            "name": "標準バケット容量（山積／平積）0.13／0.10m3"
          },
          "011-001": {
            "name": "標準バケット容量（山積／平積）0.16／0.11m3"
          }
        }
      },
      "123": {
        "name": "標準型・クレーン機能付き・排出ガス対策型",
        "items": {
          "008-001": {
            "name": "標準バケット容量（山積／平積）0.11／0.08m3"
          },
          "010-001": {
            "name": "標準バケット容量（山積／平積）0.13／0.10m3"
          },
          "011-001": {
            "name": "標準バケット容量（山積／平積）0.16／0.11m3"
          },
          "016-001": {
            "name": "標準バケット容量（山積／平積）0.22／0.16m3"
          }
        }
      },
      "132": {
        "name": "標準型・超低騒音型・排出ガス対策型（第１次基準値）",
        "items": {
          "003-001": {
            "name": "標準バケット容量（山積／平積）0.044／0.03m3"
          }
        }
      },
      "134": {
        "name": "標準型・超低騒音型・排出ガス対策型（第３次基準値）",
        "items": {
          "004-001": {
            "name": "標準バケット容量（山積／平積）0.055／0.44m3"
          },
          "006-001": {
            "name": "標準バケット容量（山積／平積）0.08／0.06m3"
          },
          "008-001": {
            "name": "標準バケット容量（山積／平積）0.09~0.11／0.07~0.08m3"
          },
          "010-001": {
            "name": "標準バケット容量（山積／平積）0.13／0.10m3"
          },
          "011-001": {
            "name": "標準バケット容量（山積／平積）0.16／0.11m3"
          }
        }
      },
      "143": {
        "name": "標準型・調停騒音型・クレーン機能付き・排出ガス対策型",
        "items": {
          "008-001": {
            "name": "標準バケット容量（山積／平積）0.11／0.08m3"
          },
          "010-001": {
            "name": "標準バケット容量（山積／平積）0.13~0.14／0.10m3"
          }
        }
      },
      "211": {
        "name": "後方超小旋回型",
        "items": {
          "001-001": {
            "name": "標準バケット容量（山積／平積）0.01／0.008m3"
          },
          "002-001": {
            "name": "標準バケット容量（山積／平積）0.022／0.015m3"
          }
        }
      },
      "213": {
        "name": "後方超小旋回型・排出ガス対策型（第２次基準値）",
        "items": {
          "010-001": {
            "name": "標準バケット容量（山積／平積）0.13／0.10m3"
          }
        }
      },
      "214": {
        "name": "後方超小旋回型・排出ガス対策型（第３次基準値）",
        "items": {
          "003-001": {
            "name": "標準バケット容量（山積／平積）0.044／0.03m3"
          },
          "005-001": {
            "name": "標準バケット容量（山積／平積）0.066／0.05m3"
          },
          "007-001": {
            "name": "標準バケット容量（山積／平積）0.09／0.07m3"
          },
          "012-001": {
            "name": "標準バケット容量（山積／平積）0.16／0.12m3"
          }
        }
      },
      "233": {
        "name": "後方超小旋回型・超低騒音型・排出ガス対策型（第２次基準値）",
        "items": {
          "004-001": {
            "name": "標準バケット容量（山積／平積）0.055／0.44m3"
          }
        }
      },
      "234": {
        "name": "後方超小旋回型・超低騒音型・排出ガス対策型（第３次基準値）",
        "items": {
          "002-001": {
            "name": "標準バケット容量（山積／平積）0.025／0.02m3"
          },
          "003-001": {
            "name": "標準バケット容量（山積／平積）0.044／0.03m3"
          },
          "005-001": {
            "name": "標準バケット容量（山積／平積）0.066／0.05m3"
          },
          "006-001": {
            "name": "標準バケット容量（山積／平積）0.08／0.06m3"
          },
          "007-001": {
            "name": "標準バケット容量（山積／平積）0.09／0.07m3"
          },
          "009-001": {
            "name": "標準バケット容量（山積／平積）0.11／0.09m3"
          },
          "010-001": {
            "name": "標準バケット容量（山積／平積）0.13／0.10m3"
          },
          "011-001": {
            "name": "標準バケット容量（山積／平積）0.14／0.11m3"
          },
          "012-001": {
            "name": "標準バケット容量（山積／平積）0.16／0.12m3"
          }
        }
      },
      "244": {
        "name": "後方超小旋回型・超低騒音型・クレーン機能付き・排出ガス対策型（第３次基準値）",
        "items": {
          "006-001": {
            "name": "標準バケット容量（山積／平積）0.08／0.06m3"
          },
          "007-001": {
            "name": "標準バケット容量（山積／平積）0.09／0.07m3"
          },
          "009-001": {
            "name": "標準バケット容量（山積／平積）0.11／0.09m3"
          },
          "011-001": {
            "name": "標準バケット容量（山積／平積）0.14／0.11m3"
          },
          "012-001": {
            "name": "標準バケット容量（山積／平積）0.16／0.12m3"
          }
        }
      },
      "313": {
        "name": "超小旋回型・排出ガス対策型（第2次基準値）",
        "items": {
          "006-001": {
            "name": "標準バケット容量（山積／平積）0.08／0.06m3"
          }
        }
      },
      "314": {
        "name": "超小旋回型・排出ガス対策型（第3次基準値）",
        "items": {
          "008-001": {
            "name": "標準バケット容量（山積／平積）0.11／0.08m3"
          },
          "016-001": {
            "name": "標準バケット容量（山積／平積）0.22／0.16m3"
          }
        }
      },
      "324": {
        "name": "超小旋回型・クレーン機能付き・排出ガス対策型（第3次基準値）",
        "items": {
          "016-001": {
            "name": "標準バケット容量（山積／平積）0.22／0.16m3"
          }
        }
      },
      "334": {
        "name": "超小旋回型・超低騒音型・排出ガス対策型（第3次基準値）",
        "items": {
          "003-001": {
            "name": "標準バケット容量（山積／平積）0.044／0.03m3"
          },
          "004-001": {
            "name": "標準バケット容量（山積／平積）0.055／0.04m3"
          },
          "005-001": {
            "name": "標準バケット容量（山積／平積）0.066／0.05m3"
          },
          "006-001": {
            "name": "標準バケット容量（山積／平積）0.08／0.06m3"
          },
          "007-001": {
            "name": "標準バケット容量（山積／平積）0.09／0.07m3"
          },
          "008-001": {
            "name": "標準バケット容量（山積／平積）0.11／0.08m3"
          },
          "012-001": {
            "name": "標準バケット容量（山積／平積）0.16／0.12m3"
          },
          "016-001": {
            "name": "標準バケット容量（山積／平積）0.22／0.16m3"
          }
        }
      },
      "344": {
        "name": "超小旋回型・超低騒音型・クレーン機能付き・排出ガス対策型（第3次基準値）",
        "items": {
          "005-001": {
            "name": "標準バケット容量（山積／平積）0.066／0.05m3"
          },
          "007-001": {
            "name": "標準バケット容量（山積／平積）0.09／0.07m3"
          },
          "009-001": {
            "name": "標準バケット容量（山積／平積）0.11／0.09m3"
          },
          "012-001": {
            "name": "標準バケット容量（山積／平積）0.16／0.12m3"
          }
        }
      }
    }
  },
  "0202": {
    "name": "バックホウ（クローラ型）",
    "items": {
      "111": {
        "name": "標準型",
        "items": {
          "730-001": {
            "name": "標準バケット容量（山積／平積）10.0／7.3m3"
          }
        }
      },
      "113": {
        "name": "標準型・排出ガス対策型（第2次基準値）",
        "items": {
          "035-001": {
            "name": "標準バケット容量（山積／平積）0.45／0.35m3"
          }
        }
      },
      "114": {
        "name": "標準型・排出ガス対策型（第3次基準値）",
        "items": {
          "020-001": {
            "name": "標準バケット容量（山積／平積）0.28／0.2m3"
          },
          "040-001": {
            "name": "標準バケット容量（山積／平積）0.5／0.4m3"
          },
          "050-001": {
            "name": "標準バケット容量（山積／平積）0.6／0.5m3"
          },
          "060-001": {
            "name": "標準バケット容量（山積／平積）0.8／0.6m3"
          },
          "070-001": {
            "name": "標準バケット容量（山積／平積）1.0／0.7m3"
          },
          "080-001": {
            "name": "標準バケット容量（山積／平積）1.1／0.8m3"
          },
          "100-001": {
            "name": "標準バケット容量（山積／平積）1.4／1.0m3"
          },
          "150-001": {
            "name": "標準バケット容量（山積／平積）1.9／1.4m3"
          },
          "210-001": {
            "name": "標準バケット容量（山積／平積）2.7／2.1m3"
          },
          "240-001": {
            "name": "標準バケット容量（山積／平積）3.1／2.4m3"
          },
          "260-001": {
            "name": "標準バケット容量（山積／平積）3.5／2.6m3"
          },
          "380-001": {
            "name": "標準バケット容量（山積／平積）5.0／3.8m3"
          }
        }
      },
      "123": {
        "name": "標準型・クレーン機能付き・排出ガス対策型（第2次基準値）",
        "items": {
          "020-001": {
            "name": "標準バケット容量（山積／平積）0.28／0.2m3"
          },
          "035-001": {
            "name": "標準バケット容量（山積／平積）0.45／0.35m3"
          },
          "040-001": {
            "name": "標準バケット容量（山積／平積）0.5／0.4m3"
          },
          "060-001": {
            "name": "標準バケット容量（山積／平積）0.8／0.6m3"
          }
        }
      },
      "124": {
        "name": "標準型・クレーン機能付き・排出ガス対策型（第3次基準値）",
        "items": {
          "060-001": {
            "name": "標準バケット容量（山積／平積）0.8／0.6m3"
          }
        }
      },
      "133": {
        "name": "標準型・超低騒音型・排出ガス対策型（第2次基準値）",
        "items": {
          "020-001": {
            "name": "標準バケット容量（山積／平積）0.28／0.2m3"
          },
          "045-001": {
            "name": "標準バケット容量（山積／平積）0.6／0.45m3"
          },
          "070-001": {
            "name": "標準バケット容量（山積／平積）1.0／0.7m3"
          }
        }
      },
      "134": {
        "name": "標準型・超低騒音型・排出ガス対策型（第3次基準値）",
        "items": {
          "035-001": {
            "name": "標準バケット容量（山積／平積）0.45／0.35m3"
          },
          "040-001": {
            "name": "標準バケット容量（山積／平積）0.5／0.4m3"
          },
          "060-001": {
            "name": "標準バケット容量（山積／平積）0.8／0.6m3"
          }
        }
      },
      "144": {
        "name": "標準型・超低騒音型・クレーン機能付き・排出ガス対策型（第3次基準値）",
        "items": {
          "060-001": {
            "name": "標準バケット容量（山積／平積）0.8／0.6m3"
          }
        }
      },
      "214": {
        "name": "後方超小旋回型・排出ガス対策型（第3次基準値）",
        "items": {
          "020-001": {
            "name": "標準バケット容量（山積／平積）0.28／0.2m3"
          },
          "035-001": {
            "name": "標準バケット容量（山積／平積）0.45／0.35m3"
          },
          "040-001": {
            "name": "標準バケット容量（山積／平積）0.5／0.4m3"
          },
          "060-001": {
            "name": "標準バケット容量（山積／平積）0.8／0.6m3"
          }
        }
      },
      "224": {
        "name": "後方超小旋回型・クレーン機能付き・排出ガス対策型（第3次基準値）",
        "items": {
          "020-001": {
            "name": "標準バケット容量（山積／平積）0.28／0.2m3"
          },
          "035-001": {
            "name": "標準バケット容量（山積／平積）0.45／0.35m3"
          },
          "040-001": {
            "name": "標準バケット容量（山積／平積）0.5／0.4m3"
          },
          "060-001": {
            "name": "標準バケット容量（山積／平積）0.8／0.6m3"
          }
        }
      },
      "234": {
        "name": "後方超小旋回型・超低騒音型・排出ガス対策型（第3次基準値）",
        "items": {
          "020-001": {
            "name": "標準バケット容量（山積／平積）0.28／0.2m3"
          },
          "035-001": {
            "name": "標準バケット容量（山積／平積）0.45／0.35m3"
          },
          "040-001": {
            "name": "標準バケット容量（山積／平積）0.5／0.4m3"
          },
          "060-001": {
            "name": "標準バケット容量（山積／平積）0.8／0.6m3"
          }
        }
      },
      "245": {
        "name": "後方超小旋回型・超低騒音型・クレーン機能付き・排出ガス対策型（2011年規制）",
        "items": {
          "035-001": {
            "name": "標準バケット容量（山積／平積）0.45／0.35m3"
          },
          "040-001": {
            "name": "標準バケット容量（山積／平積）0.5／0.4m3"
          },
          "060-001": {
            "name": "標準バケット容量（山積／平積）0.8／0.6m3"
          }
        }
      },
      "314": {
        "name": "超小旋回型・排出ガス対策型（第3次基準値）",
        "items": {
          "020-001": {
            "name": "標準バケット容量（山積／平積）0.28／0.2m3"
          },
          "035-001": {
            "name": "標準バケット容量（山積／平積）0.45／0.35m3"
          }
        }
      },
      "324": {
        "name": "超小旋回型・クレーン機能付き・排出ガス対策型（第3次基準値）",
        "items": {
          "020-001": {
            "name": "標準バケット容量（山積／平積）0.28／0.2m3"
          },
          "035-001": {
            "name": "標準バケット容量（山積／平積）0.45／0.35m3"
          }
        }
      },
      "414": {
        "name": "超ロングアーム型・排出ガス対策型（第3次基準値）",
        "items": {
          "030-001": {
            "name": "バケット容量（山積／平積）0.4／0.3m3"
          }
        }
      },
      "714": {
        "name": "ディーゼル／電気ハイブリット型・排出ガス対策型（第3次基準値）",
        "items": {
          "060-001": {
            "name": "標準バケット容量（山積／平積）0.8／0.6m3"
          }
        }
      },
      "825": {
        "name": "標準型・ＩＣＴ施工対応型・超低騒音型・クレーン機能付き・排出ガス対策型（第3次基準値）",
        "items": {
          "060-302": {
            "name": "標準バケット容量（山積／平積）0.8／0.6m3"
          }
        }
      }
    }
  },
  "0203": {
    "name": "その他バックホウ",
    "items": {
      "122": {
        "name": "ホイール型・抽出ガス対策型（第1次基準値）",
        "items": {
          "020-001": {
            "name": "標準バケット容量（山積／平積）0.28／0.2m3"
          }
        }
      },
      "123": {
        "name": "ホイール型・抽出ガス対策型（第2次基準値）",
        "items": {
          "035-001": {
            "name": "標準バケット容量（山積／平積）0.45／0.35m3"
          },
          "045-001": {
            "name": "標準バケット容量（山積／平積）0.6／0.45m3"
          }
        }
      },
      "124": {
        "name": "ホイール型・抽出ガス対策型（第3次基準値）",
        "items": {
          "040-001": {
            "name": "標準バケット容量（山積／平積）0.5／0.4m3"
          }
        }
      }
    }
  },
  "0204": {
    "name": "ドラグライン及びクラムシェル",
    "items": {
      "021": {
        "name": "油圧ローブ式・クローラ型",
        "items": {
          "060-001": {
            "name": "バケット容量（平積）0.6m3"
          },
          "080-001": {
            "name": "バケット容量（平積）0.8m3"
          },
          "100-001": {
            "name": "バケット容量（平積）1.0m3"
          }
        }
      },
      "031": {
        "name": "油圧クラムシェル・クローラ型",
        "items": {
          "030-001": {
            "name": "バケット容量（平積）0.3m3"
          },
          "061-001": {
            "name": "バケット容量（平積）0.6m3"
          },
          "062-001": {
            "name": "バケット容量（平積）[深堀用]0.6m3"
          }
        }
      },
      "051": {
        "name": "油圧クラムシェル・ホイール型",
        "items": {
          "030-001": {
            "name": "バケット容量（平積）0.3m3"
          }
        }
      },
      "062": {
        "name": "油圧クラムシェル・テレスコピック型・排出ガス対策型（第1次基準値）",
        "items": {
          "020-001": {
            "name": "バケット容量（平積）0.15／0.2m3"
          },
          "025-001": {
            "name": "バケット容量（平積）0.25m3"
          },
          "030-001": {
            "name": "バケット容量（平積）0.26~0.3m3"
          },
          "040-001": {
            "name": "バケット容量（平積）0.4m3"
          },
          "060-001": {
            "name": "バケット容量（平積）0.6m3"
          },
          "130-001": {
            "name": "バケット容量（平積）1.0~1.3m3"
          }
        }
      }
    }
  },
  "0205": {
    "name": "泥上掘削機",
    "items": {
      "021": {
        "name": "フロート構造トラック・バックホウ型",
        "items": {
          "027-040": {
            "name": "バケット容量（平積）×最大作業範囲0.4m3×11m"
          },
          "027-070": {
            "name": "バケット容量（平積）×最大作業範囲0.7m3×11m"
          }
        }
      },
      "024": {
        "name": "フロート構造トラック・バックホウ型・排出ガス対策型（第3次基準値）",
        "items": {
          "042-070": {
            "name": "バケット容量（平積）×最大作業範囲0.7m3×13m"
          }
        }
      }
    }
  },
  "0206": {
    "name": "クローラローダ（トラクタショベル）",
    "items": {
      "011": {
        "name": "普通型",
        "items": {
          "190-001": {
            "name": "標準バケット容量（山積）1.8~1.9m3"
          }
        }
      }
    }
  },
  "0207": {
    "name": "ホイールローダ（トラクタショベル）",
    "items": {
      "061": {
        "name": "普通型",
        "items": {
          "999-001": {
            "name": "標準バケット容量（山積）11~12m3"
          }
        }
      },
      "062": {
        "name": "普通・排出ガス対策型（第1次基準値）",
        "items": {
          "034-001": {
            "name": "標準バケット容量（山積）0.34~0.35m3"
          },
          "080-001": {
            "name": "標準バケット容量（山積）0.8m3"
          },
          "120-001": {
            "name": "標準バケット容量（山積）1.2m3"
          }
        }
      },
      "063": {
        "name": "普通・排出ガス対策型（第2次基準値）",
        "items": {
          "060-001": {
            "name": "標準バケット容量（山積）0.6m3"
          }
        }
      },
      "064": {
        "name": "普通・排出ガス対策型（第3次基準値）",
        "items": {
          "030-001": {
            "name": "標準バケット容量（山積）0.3m3"
          },
          "040-001": {
            "name": "標準バケット容量（山積）0.4m3"
          },
          "050-001": {
            "name": "標準バケット容量（山積）0.5m3"
          },
          "100-001": {
            "name": "標準バケット容量（山積）0.9~1.0m3"
          },
          "140-001": {
            "name": "標準バケット容量（山積）1.3~1.4m3"
          },
          "160-001": {
            "name": "標準バケット容量（山積）1.5~1.6m3"
          },
          "220-001": {
            "name": "標準バケット容量（山積）1.9~2.2m3"
          },
          "300-001": {
            "name": "標準バケット容量（山積）2.5~3.0m3"
          },
          "340-001": {
            "name": "標準バケット容量（山積）3.2~3.4m3"
          },
          "370-001": {
            "name": "標準バケット容量（山積）3.5~3.7m3"
          },
          "410-001": {
            "name": "標準バケット容量（山積）4.0~4.1m3"
          },
          "460-001": {
            "name": "標準バケット容量（山積）4.5~4.6m3"
          },
          "560-001": {
            "name": "標準バケット容量（山積）5.0~5.6m3"
          },
          "700-001": {
            "name": "標準バケット容量（山積）6.0~7.0m3"
          }
        }
      },
      "074": {
        "name": "普通・排出ガス対策型（第3次基準値）",
        "items": {
          "030-001": {
            "name": "標準バケット容量（山積）0.3m3"
          },
          "040-001": {
            "name": "標準バケット容量（山積）0.4m3"
          },
          "050-001": {
            "name": "標準バケット容量（山積）0.5m3"
          },
          "060-001": {
            "name": "標準バケット容量（山積）0.6m3"
          },
          "100-001": {
            "name": "標準バケット容量（山積）0.9~1.0m3"
          },
          "140-001": {
            "name": "標準バケット容量（山積）1.3~1.4m3"
          }
        }
      }
    }
  },
  "0301": {
    "name": "ダンプトラック",
    "items": {
      "011": {
        "name": "オンロード・ディーゼル",
        "items": {
          "020-001": {
            "name": "2t積級"
          },
          "030-001": {
            "name": "3t積級"
          },
          "040-001": {
            "name": "4t積級"
          },
          "070-001": {
            "name": "6~7t積級"
          },
          "080-001": {
            "name": "8t積級"
          },
          "110-001": {
            "name": "10t積級"
          },
          "120-001": {
            "name": "12t積級"
          }
        }
      },
      "031": {
        "name": "オフロード・リジッドフレーム式",
        "items": {
          "200-001": {
            "name": "20t積級"
          },
          "780-001": {
            "name": "78~95t積級"
          }
        }
      },
      "032": {
        "name": "オフロード・リジッドフレーム式・排出ガス対策型（第1次基準値）",
        "items": {
          "250-001": {
            "name": "25t積級"
          }
        }
      },
      "033": {
        "name": "オフロード・リジッドフレーム式・排出ガス対策型（第2次基準値）",
        "items": {
          "250-001": {
            "name": "25t積級"
          }
        }
      },
      "034": {
        "name": "オフロード・リジッドフレーム式・排出ガス対策型（第3次基準値）",
        "items": {
          "320-001": {
            "name": "32~37t積級"
          },
          "460-001": {
            "name": "46~55t積級"
          }
        }
      },
      "074": {
        "name": "オフロード・アーティキューレート式・排出ガス対策型（第3次基準値）",
        "items": {
          "225-001": {
            "name": "22~24t積級"
          },
          "270-001": {
            "name": "27~28t積級"
          },
          "320-001": {
            "name": "32~34t積級"
          },
          "370-001": {
            "name": "36~39t積級"
          }
        }
      },
      "075": {
        "name": "オフロード・アーティキューレート式・排出ガス対策型（2011年規制）",
        "items": {
          "370-001": {
            "name": "36~41t積級"
          }
        }
      }
    }
  },
  "0302": {
    "name": "トラック",
    "items": {
      "011": {
        "name": "普通型",
        "items": {
          "015-001": {
            "name": "1.5t積"
          },
          "020-001": {
            "name": "2t積"
          },
          "035-001": {
            "name": "3~3.5t積"
          },
          "045-001": {
            "name": "4~4.5t積"
          },
          "055-001": {
            "name": "5~5.5t積"
          },
          "065-001": {
            "name": "6~6.5t積"
          },
          "080-001": {
            "name": "8t積"
          },
          "110-001": {
            "name": "11t積"
          },
          "150-001": {
            "name": "15t積"
          }
        }
      },
      "021": {
        "name": "クレーン装置付き",
        "items": {
          "022-001": {
            "name": "ベーストラック2t級"
          },
          "023-001": {
            "name": "ベーストラック2t級"
          },
          "033-001": {
            "name": "ベーストラック3t級"
          },
          "042-001": {
            "name": "ベーストラック4t級"
          },
          "043-001": {
            "name": "ベーストラック4t級"
          },
          "053-001": {
            "name": "ベーストラック5t級"
          },
          "063-001": {
            "name": "ベーストラック6t級"
          },
          "073-001": {
            "name": "ベーストラック7t級"
          },
          "083-001": {
            "name": "ベーストラック8t級"
          },
          "103-001": {
            "name": "ベーストラック10t級"
          }
        }
      }
    }
  },
  "0303": {
    "name": "トレーラ",
    "items": {
      "011": {
        "name": "セミ",
        "items": {
          "150-001": {
            "name": "15t積"
          },
          "200-001": {
            "name": "20t積"
          },
          "250-001": {
            "name": "25t積"
          },
          "280-001": {
            "name": "28t積"
          },
          "320-001": {
            "name": "32t積"
          },
          "400-001": {
            "name": "40t積"
          },
          "500-001": {
            "name": "50t積"
          }
        }
      }
    }
  },
  "0308": {
    "name": "不整地運搬車",
    "items": {
      "011": {
        "name": "クローラ型・ダンプ式",
        "items": {
          "030-001": {
            "name": "3t積"
          },
          "035-001": {
            "name": "3.5t積"
          },
          "040-001": {
            "name": "4t積"
          },
          "050-001": {
            "name": "5t積"
          }
        }
      },
      "012": {
        "name": "クローラ型・ダンプ式・排出ガス対策型（第1次基準値）",
        "items": {
          "020-001": {
            "name": "2t積"
          },
          "035-001": {
            "name": "3.3~3.5t積"
          },
          "070-001": {
            "name": "6.3~7t積"
          },
          "110-001": {
            "name": "8~11t積"
          },
          "150-001": {
            "name": "12.5~15t積"
          }
        }
      },
      "013": {
        "name": "クローラ型・ダンプ式・排出ガス対策型（第2次基準値）",
        "items": {
          "010-001": {
            "name": "1t積"
          },
          "015-001": {
            "name": "1.5t積"
          },
          "050-001": {
            "name": "4~5t積"
          },
          "070-001": {
            "name": "7t積"
          },
          "100-001": {
            "name": "10t積"
          }
        }
      },
      "014": {
        "name": "クローラ型・ダンプ式・排出ガス対策型（第3次基準値）",
        "items": {
          "018-001": {
            "name": "1.8t積"
          },
          "025-001": {
            "name": "2.5t積"
          },
          "038-001": {
            "name": "3.8t積"
          }
        }
      },
      "016": {
        "name": "クローラ型・ダンプ式・排出ガス対策型（2014年規制）",
        "items": {
          "050-001": {
            "name": "5t積"
          },
          "070-001": {
            "name": "6~7t積"
          },
          "110-001": {
            "name": "11t積"
          }
        }
      },
      "021": {
        "name": "クローラ型・カーゴ式・クレーン装置付",
        "items": {
          "171-001": {
            "name": "1.7t積"
          },
          "201-001": {
            "name": "2t積"
          },
          "252-001": {
            "name": "2.5t積"
          },
          "352-001": {
            "name": "3.5t積"
          }
        }
      },
      "063": {
        "name": "クローラ型・ダンプ・全旋回式・排出ガス対策型（第2次基準値）",
        "items": {
          "010-001": {
            "name": "1t積"
          },
          "030-001": {
            "name": "3t積"
          },
          "040-001": {
            "name": "4t積"
          },
          "065-001": {
            "name": "6~7t積"
          },
          "110-001": {
            "name": "10~11t積"
          }
        }
      }
    }
  },
  "0401": {
    "name": "クローラクレーン",
    "items": {
      "011": {
        "name": "機会駆動式ウインチ・ラチスジブ型",
        "items": {
          "016-001": {
            "name": "16t吊"
          },
          "020-001": {
            "name": "22.5t吊"
          },
          "040-001": {
            "name": "35~40t吊"
          },
          "050-001": {
            "name": "45~50t吊"
          },
          "080-001": {
            "name": "80t吊"
          },
          "100-001": {
            "name": "100t吊"
          },
          "150-001": {
            "name": "150t吊"
          }
        }
      },
      "022": {
        "name": "油圧駆動式ウインチ・ラチスジブ型・排出ガス対策型（第1次基準値）",
        "items": {
          "065-001": {
            "name": "60~65t吊"
          },
          "150-001": {
            "name": "150t吊"
          },
          "300-001": {
            "name": "300t吊"
          },
          "650-001": {
            "name": "650t吊"
          }
        }
      },
      "023": {
        "name": "油圧駆動式ウインチ・ラチスジブ型・排出ガス対策型（第2次基準値）",
        "items": {
          "035-001": {
            "name": "30~35t吊"
          }
        }
      },
      "024": {
        "name": "油圧駆動式ウインチ・ラチスジブ型・排出ガス対策型（第3次基準値）",
        "items": {
          "045-001": {
            "name": "40~45t吊"
          },
          "055-001": {
            "name": "50~55t吊"
          },
          "070-001": {
            "name": "70t吊"
          },
          "080-001": {
            "name": "80t吊"
          },
          "090-001": {
            "name": "90t吊"
          },
          "100-001": {
            "name": "100t吊"
          },
          "120-001": {
            "name": "120t吊"
          },
          "200-001": {
            "name": "200t吊"
          },
          "350-001": {
            "name": "350t吊"
          },
          "500-001": {
            "name": "500t吊"
          }
        }
      },
      "043": {
        "name": "油圧駆動式ウインチ・タワー型・排出ガス対策型（第2次基準値）",
        "items": {
          "011-050": {
            "name": "タワー型能力11.4t吊ベースマシン50t吊"
          }
        }
      },
      "044": {
        "name": "油圧駆動式ウインチ・タワー型・排出ガス対策型（第3次基準値）",
        "items": {
          "011-055": {
            "name": "タワー型能力11.5t吊ベースマシン55t吊"
          },
          "013-070": {
            "name": "タワー型能力13t吊ベースマシン70t吊"
          },
          "015-090": {
            "name": "タワー型能力15t吊ベースマシン90t吊"
          },
          "020-120": {
            "name": "タワー型能力20t吊ベースマシン120t吊"
          },
          "025-200": {
            "name": "タワー型能力25t吊ベースマシン200t吊"
          },
          "100-350": {
            "name": "タワー型能力100t吊ベースマシン350t吊"
          },
          "210-500": {
            "name": "タワー型能力210t吊ベースマシン500t吊"
          }
        }
      },
      "052": {
        "name": "油圧伸縮ジブ型・排出ガス対策型（第1次基準値）",
        "items": {
          "035-001": {
            "name": "35t吊"
          },
          "055-001": {
            "name": "55t吊"
          }
        }
      },
      "053": {
        "name": "油圧伸縮ジブ型・排出ガス対策型（第2次基準値）",
        "items": {
          "055-001": {
            "name": "50~55t吊"
          },
          "075-001": {
            "name": "75t吊"
          }
        }
      },
      "054": {
        "name": "油圧伸縮ジブ型・排出ガス対策型（第3次基準値）",
        "items": {
          "005-001": {
            "name": "4.9t吊"
          },
          "040-001": {
            "name": "40t吊"
          }
        }
      },
      "055": {
        "name": "油圧伸縮ジブ型・排出ガス対策型（2011年規制）",
        "items": {
          "065-001": {
            "name": "65t吊"
          }
        }
      },
      "061": {
        "name": "油圧伸縮ジブ型・4脚式ミニクレーン",
        "items": {
          "280-140": {
            "name": "2.8t×1.4m級"
          },
          "300-250": {
            "name": "3t×2.5m級"
          },
          "300-350": {
            "name": "3t×3.5m級"
          }
        }
      }
    }
  },
  "0402": {
    "name": "トラッククレーン",
    "items": {
      "022": {
        "name": "トラッククレーン・油圧伸縮ジブ型",
        "items": {
          "005-001": {
            "name": "4.9t吊"
          },
          "007-001": {
            "name": "7.0t吊"
          },
          "016-001": {
            "name": "16t吊"
          },
          "020-001": {
            "name": "20t吊"
          },
          "025-001": {
            "name": "25t吊"
          },
          "030-001": {
            "name": "30t吊"
          },
          "035-001": {
            "name": "35t吊"
          },
          "045-001": {
            "name": "40~45t吊"
          },
          "050-001": {
            "name": "50t吊"
          },
          "080-001": {
            "name": "80t吊"
          },
          "100-001": {
            "name": "100t吊"
          },
          "120-001": {
            "name": "120t吊"
          },
          "160-001": {
            "name": "160t吊"
          },
          "360-001": {
            "name": "360t吊"
          },
          "500-001": {
            "name": "500t吊"
          }
        }
      },
      "032": {
        "name": "オールテレーンクレーン・油圧伸縮ジブ型",
        "items": {
          "100-001": {
            "name": "100t吊"
          },
          "130-001": {
            "name": "120~130t吊"
          },
          "170-001": {
            "name": "150~170t吊"
          },
          "250-001": {
            "name": "200~250t吊"
          },
          "300-001": {
            "name": "300t吊"
          },
          "360-001": {
            "name": "360t吊"
          },
          "400-001": {
            "name": "400t吊"
          },
          "550-001": {
            "name": "550t吊"
          },
          "650-001": {
            "name": "600t吊"
          }
        }
      }
    }
  },
  "0403": {
    "name": "ラフテレーンクレーン",
    "items": {
      "012": {
        "name": "油圧伸縮ジブ型・排出ガス対策型（第1次基準値）",
        "items": {
          "007-001": {
            "name": "7t吊"
          },
          "010-001": {
            "name": "10t吊"
          },
          "022-001": {
            "name": "22t吊"
          }
        }
      },
      "013": {
        "name": "油圧伸縮ジブ型・排出ガス対策型（第2次基準値）",
        "items": {
          "020-001": {
            "name": "20t吊"
          },
          "030-001": {
            "name": "30t吊"
          },
          "051-001": {
            "name": "50~51t吊"
          },
          "065-001": {
            "name": "60~65t吊"
          }
        }
      },
      "014": {
        "name": "油圧伸縮ジブ型・排出ガス対策型（第3次基準値）",
        "items": {
          "005-001": {
            "name": "4.9t吊"
          },
          "013-001": {
            "name": "12~13t吊"
          },
          "016-001": {
            "name": "16t吊"
          },
          "025-001": {
            "name": "25t吊"
          },
          "035-001": {
            "name": "35t吊"
          },
          "065-001": {
            "name": "60~70t吊"
          }
        }
      },
      "015": {
        "name": "油圧伸縮ジブ型・排出ガス対策型（2011年規制）",
        "items": {
          "065-001": {
            "name": "60~75t吊"
          }
        }
      },
      "016": {
        "name": "油圧伸縮ジブ型・排出ガス対策型（2014年規制）",
        "items": {
          "080-001": {
            "name": "80t吊"
          }
        }
      }
    }
  },
  "0431": {
    "name": "フォークリフト",
    "items": {
      "012": {
        "name": "エンジン駆動",
        "items": {
          "009-001": {
            "name": "最大積載荷重0.9t級"
          },
          "015-001": {
            "name": "最大積載荷重1.5t級"
          },
          "020-001": {
            "name": "最大積載荷重2.0t級"
          },
          "025-001": {
            "name": "最大積載荷重2.5t級"
          }
        }
      }
    }
  },
  "0433": {
    "name": "高所作業車",
    "items": {
      "110": {
        "name": "トラック架装・伸縮ブーム・バスケット型",
        "items": {
          "100-020": {
            "name": "作業床高9.7m 積載荷重200kg"
          },
          "120-020": {
            "name": "作業床高12.0m 積載荷重200kg"
          },
          "140-020": {
            "name": "作業床高14.0m 積載荷重200kg"
          },
          "170-020": {
            "name": "作業床高17.0m 積載荷重200kg"
          },
          "230-020": {
            "name": "作業床高22.0m 積載荷重200kg"
          }
        }
      },
      "150": {
        "name": "トラック架装・伸縮ブーム・プラットフォーム型",
        "items": {
          "100-011": {
            "name": "作業床高9.9m 積載荷重1000kg"
          },
          "120-011": {
            "name": "作業床高12.0m 積載荷重1000kg"
          },
          "150-100": {
            "name": "作業床高14.8m 積載荷重1000kg"
          },
          "200-100": {
            "name": "作業床高19.7m 積載荷重1000kg"
          }
        }
      },
      "250": {
        "name": "トラック架装・垂直昇降・プラットフォーム型",
        "items": {
          "100-100": {
            "name": "作業床高9.9m 積載荷重1000kg"
          },
          "100-130": {
            "name": "作業床高13.2m 積載荷重1000kg"
          },
          "170-005": {
            "name": "揚程5m 積載荷重1700kg"
          },
          "320-005": {
            "name": "揚程5m 積載荷重3200kg"
          }
        }
      }
    }
  },
  "0502": {
    "name": "油圧ハンマ（単体）",
    "items": {
      "017": {
        "name": "直抗用",
        "items": {
          "020-002": {
            "name": "ラム質量2t"
          },
          "040-002": {
            "name": "ラム質量4~4.5t"
          },
          "065-002": {
            "name": "ラム質量6.5~8.0t"
          },
          "125-002": {
            "name": "ラム質量10~12.5t"
          }
        }
      },
      "018": {
        "name": "直抗用・斜坑兼用",
        "items": {
          "012-002": {
            "name": "ラム質量11.5~12.5t"
          },
          "015-002": {
            "name": "ラム質量15t"
          }
        }
      }
    }
  },
  "0503": {
    "name": "パイプロハンマ（単体）",
    "items": {
      "034": {
        "name": "油圧式・可変高周波型・排出ガス対策型（第3次基準値）",
        "items": {
          "070-002": {
            "name": "[振り子式]最大起振力700kN 振動周波数20-38Hz"
          }
        }
      },
      "042": {
        "name": "油圧式・可変超高周波型・排出ガス対策型（第1次基準値）",
        "items": {
          "016-002": {
            "name": "[ピストン式]最大起振力157kN 振動周波数20-60Hz"
          },
          "025-002": {
            "name": "[ピストン式]最大起振力245kN 振動周波数20-60Hz"
          },
          "029-002": {
            "name": "[振り子式]最大起振力284kN 振動周波数20-60Hz"
          },
          "032-002": {
            "name": "[ピストン式]最大起振力314kN 振動周波数20-60Hz"
          },
          "045-002": {
            "name": "[振り子式]最大起振力441kN 振動周波数20-60Hz"
          }
        }
      },
      "043": {
        "name": "油圧式・可変超高周波型・排出ガス対策型（第2次基準値）",
        "items": {
          "035-002": {
            "name": "[振り子式]最大起振力347kN 振動周波数20-60Hz"
          }
        }
      },
      "044": {
        "name": "油圧式・可変超高周波型・排出ガス対策型（第3次基準値）",
        "items": {
          "048-002": {
            "name": "[振り子式]最大起振力4473kN 振動周波数20-60Hz"
          }
        }
      },
      "055": {
        "name": "油圧ショベル装着式・可変超高周波型",
        "items": {
          "005-002": {
            "name": "[ピストン式]最大起振力49.0kN 振動周波数20-60Hz"
          },
          "010-002": {
            "name": "[ピストン式]最大起振力98.1kN 振動周波数20-60Hz"
          }
        }
      },
      "058": {
        "name": "油圧ショベル装着式（超低騒音型）",
        "items": {
          "060-002": {
            "name": "最大起振力58.8kN 振動周波数27-36Hz"
          },
          "090-002": {
            "name": "最大起振力88.3kN 振動周波数27-36Hz"
          },
          "130-002": {
            "name": "最大起振力128kN 振動周波数27-36Hz"
          },
          "160-002": {
            "name": "最大起振力160kN 振動周波数27-36Hz"
          },
          "200-002": {
            "name": "最大起振力200kN 振動周波数27-36Hz"
          }
        }
      }
    }
  },
  "0504": {
    "name": "杭打ち用ウォータジェット",
    "items": {
      "022": {
        "name": "エンジン式・排出ガス対策型（第1次基準値）",
        "items": {
          "147-033": {
            "name": "圧力14.7MPa吐出量325ℓ/min"
          },
          "147-090": {
            "name": "圧力14.7MPa吐出量896ℓ/min"
          }
        }
      },
      "023": {
        "name": "エンジン式・排出ガス対策型（第2次基準値）",
        "items": {
          "100-060": {
            "name": "圧力100MPa吐出量60~600ℓ/min"
          }
        }
      },
      "024": {
        "name": "エンジン式・排出ガス対策型（第3次基準値）",
        "items": {
          "147-033": {
            "name": "圧力14.7MPa吐出量325ℓ/min"
          },
          "147-090": {
            "name": "圧力14.7MPa吐出量900ℓ/min"
          }
        }
      }
    }
  },
  "0509": {
    "name": "クローラ式杭打機（ベースマシン）",
    "items": {
      "011": {
        "name": "直結三点支持式",
        "items": {
          "040-001": {
            "name": "リーダ長11.5~15.5m全装備質量30~40t"
          },
          "055-001": {
            "name": "リーダ長18~21m全装備質量50~55t"
          },
          "065-001": {
            "name": "リーダ長18~21m全装備質量60~65t"
          },
          "085-001": {
            "name": "リーダ長21~24m全装備質量80~85t"
          },
          "095-001": {
            "name": "リーダ長21~30m全装備質量90~95t"
          },
          "110-001": {
            "name": "リーダ長21~33m全装備質量100~110t"
          },
          "125-001": {
            "name": "リーダ長21~33m全装備質量120~125t"
          },
          "145-001": {
            "name": "リーダ長21~36m全装備質量135~145t"
          },
          "165-001": {
            "name": "リーダ長21~39m全装備質量150~165t"
          },
          "180-001": {
            "name": "リーダ長21~36m全装備質量170~180t"
          }
        }
      },
      "031": {
        "name": "多関節バックホウ・リーダレス型（軌跡制御機能付）",
        "items": {
          "160-001": {
            "name": "適応パイプロハンマ：油圧式起振力160kN級適応アースオーガ：油圧式最大掘削トルク26kN・m級"
          },
          "200-001": {
            "name": "適応パイプロハンマ：油圧式起振力200kN級適応アースオーガ：油圧式最大掘削トルク60kN・m級"
          }
        }
      }
    }
  },
  "0511": {
    "name": "クローラ式杭打機",
    "items": {
      "410": {
        "name": "パイプロハンマ及びアースオーガ併用・直結三点支持式",
        "items": {
          "226-001": {
            "name": "パイプロ出力22kWオーガ径Φ320~600mm/出力30kWリーダ長18~21m"
          },
          "306-001": {
            "name": "パイプロ出力30kWオーガ径Φ320~600mm/出力30kWリーダ長18~21m"
          },
          "456-001": {
            "name": "パイプロ出力45kWオーガ径Φ320~600mm/出力30kWリーダ長18~21m"
          },
          "606-001": {
            "name": "パイプロ出力60kWオーガ径Φ320~600mm/出力30kWリーダ長18~21m"
          }
        }
      },
      "510": {
        "name": "モンケン及びアースオーガ併用・直結三点支持式",
        "items": {
          "206-001": {
            "name": "モンケン質量2tオーガ径Φ320~600mm/出力30kWリーダ長11.5~15.5m"
          },
          "208-001": {
            "name": "モンケン質量2tオーガ径Φ350~800mm/出力45kWリーダ長18~21m"
          }
        }
      },
      "610": {
        "name": "油圧ハンマ・直結三点支持式",
        "items": {
          "020-001": {
            "name": "ラム質量2tリーダ長11.5~15.5m吊能力35~40t"
          },
          "045-001": {
            "name": "ラム質量4~4.5tリーダ長18~21m吊能力35~40t"
          },
          "080-001": {
            "name": "ラム質量6.5~8tリーダ長21~24m吊能力35~40t"
          },
          "125-001": {
            "name": "ラム質量10~12.5tリーダ長21~33m吊能力35~40t"
          }
        }
      },
      "620": {
        "name": "直/斜杭打ち兼用油圧ハンマ・直結三点支持式",
        "items": {
          "115-001": {
            "name": "ラム質量11.5~12.5tリーダ長21~33m吊能力60~65t"
          },
          "150-001": {
            "name": "ラム質量15tリーダ長21~36m吊能力80t"
          }
        }
      },
      "710": {
        "name": "鋼管ソイルセメント杭打機",
        "items": {
          "110-001": {
            "name": "杭径900~1500mm最大施工深度70mオーガ出力110~150kW"
          }
        }
      },
      "810": {
        "name": "鋼管回転圧入機",
        "items": {
          "009-001": {
            "name": "全装備質量6~9t掘削トルク43.7kN・m（4.5t・m）最大適合管長6m"
          },
          "016-001": {
            "name": "全装備質量11~16t掘削トルク67.9kN・m（6.9t・m）最大適合管長6m"
          },
          "030-001": {
            "name": "全装備質量25~30t掘削トルク274kN・m（28.1t・m）最大適合管長10m"
          },
          "055-001": {
            "name": "全装備質量50~55t掘削トルク548kN・m（4.5t・m）最大適合管長10m"
          }
        }
      },
      "011": {
        "name": "ディーゼルハンマ・直結三点支持式",
        "items": {
          "350-001": {
            "name": "ラム質量3.5tリーダ長18~21m吊能力35~40t"
          }
        }
      },
      "031": {
        "name": "ディーゼルハンマ・ブーム式",
        "items": {
          "130-001": {
            "name": "ラム質量1.3tリーダ長18m吊能力16t"
          },
          "250-001": {
            "name": "ラム質量2.5tリーダ長19m吊能力25t"
          }
        }
      },
      "041": {
        "name": "ディーゼルハンマ及びアースオーガ併用・直結三点支持式",
        "items": {
          "136-001": {
            "name": "ラム質量1.3tオーガ径Φ320~600mm/出力30kWリーダ長18~21m"
          },
          "138-001": {
            "name": "ラム質量1.3tオーガ径Φ320~800mm/出力45kWリーダ長18~21m"
          }
        }
      }
    }
  },
  "0512": {
    "name": "クローラ式アースオーガ",
    "items": {
      "111": {
        "name": "単軸式・直結三点支持式",
        "items": {
          "045-001": {
            "name": "オーガ出力45kW掘削径Φ350~800mmリーダ長18~21m"
          },
          "055-001": {
            "name": "オーガ出力55kW掘削径Φ450~1000mmリーダ長18~21m"
          },
          "075-001": {
            "name": "オーガ出力75kW掘削径Φ450~1000mmリーダ長21~30m"
          },
          "090-001": {
            "name": "オーガ出力90kW掘削径Φ450~1200mmリーダ長21~33m"
          },
          "110-001": {
            "name": "オーガ出力110kW掘削径Φ450~1200mmリーダ長21~33m"
          },
          "150-001": {
            "name": "オーガ出力150kW掘削径Φ600~1200mmリーダ長21~36m"
          },
          "180-001": {
            "name": "オーガ出力180kW掘削径Φ600~1800mmリーダ長21~36m"
          }
        }
      },
      "115": {
        "name": "単軸（油圧）式・直結三点支持式",
        "items": {
          "035-001": {
            "name": "掘削トルク29~35kN・m掘削径Φ260~600mmリーダ長18~21m"
          }
        }
      },
      "121": {
        "name": "二軸同軸式・直結三点支持式",
        "items": {
          "055-001": {
            "name": "オーガ出力55kWリーダ長21~30m掘削径Φ320~600mm"
          },
          "090-001": {
            "name": "オーガ出力90kWリーダ長21~33m掘削径Φ400~800mm"
          },
          "110-001": {
            "name": "オーガ出力110kWリーダ長21~33m掘削径Φ800~1200mm"
          },
          "150-001": {
            "name": "オーガ出力150kWリーダ長21~36m掘削径Φ800~1200mm"
          }
        }
      },
      "310": {
        "name": "三軸式・直結三点支持式",
        "items": {
          "090-001": {
            "name": "オーガ出力90kW掘削径Φ500~600mm吊能力50~55tリーダ長21~33m"
          },
          "110-001": {
            "name": "オーガ出力110kW掘削径Φ500~600mm吊能力60~65tリーダ長21~33m"
          },
          "150-001": {
            "name": "オーガ出力150kW掘削径Φ650~850mm吊能力60~65tリーダ長21~36m"
          },
          "180-001": {
            "name": "オーガ出力180kW掘削径Φ800~900mm吊能力80tリーダ長21~36m"
          }
        }
      },
      "410": {
        "name": "アースオーガ中掘機・直結三点支持式",
        "items": {
          "045-001": {
            "name": "オーガ出力45kW公称杭径Φ400~1000mmリーダ長21~24m"
          },
          "055-001": {
            "name": "オーガ出力55kW公称杭径Φ400~1200mmリーダ長21~33m"
          },
          "090-001": {
            "name": "オーガ出力90kW公称杭径Φ400~1200mmリーダ長21~33m"
          },
          "110-001": {
            "name": "オーガ出力110kW公称杭径Φ600~1200mmリーダ長21~36m"
          }
        }
      },
      "510": {
        "name": "アースオーガ併用圧入杭打機",
        "items": {
          "045-001": {
            "name": "オーガ出力45kW適応鋼矢板Ⅱ~Ⅴ型リーダ長21~24m"
          },
          "046-001": {
            "name": "オーガ出力45kW適応鋼矢板Ⅱ~Ⅴ型リーダ長21~30m"
          },
          "055-001": {
            "name": "オーガ出力55kW適応鋼矢板Ⅱ~Ⅴ型リーダ長21~33m"
          },
          "090-001": {
            "name": "オーガ出力90kW適応鋼矢板Ⅱ~Ⅴ型リーダ長21~33m"
          }
        }
      },
      "540": {
        "name": "アースオーガ（油圧式）併用圧入杭打機",
        "items": {
          "021-001": {
            "name": "掘削トルク21kN・mリーダ長11.5~15.5m"
          },
          "034-001": {
            "name": "掘削トルク34kN・mリーダ長18~21m"
          }
        }
      }
    }
  },
  "0513": {
    "name": "アースドリル",
    "items": {
      "100": {
        "name": "クローラ型",
        "items": {
          "150-002": {
            "name": "最大掘削径Φ1500mm最大掘削長35~43"
          },
          "170-002": {
            "name": "最大掘削径Φ1700mm最大掘削長43~65"
          },
          "200-002": {
            "name": "最大掘削径Φ2000mm最大掘削長41~58"
          },
          "220-002": {
            "name": "最大掘削径Φ2200mm最大掘削長54~63"
          },
          "300-002": {
            "name": "最大掘削径Φ3000mm最大掘削長60~71"
          }
        }
      }
    }
  },
  "0515": {
    "name": "ラフテレーンクレーン装着式アースオーガ",
    "items": {
      "012": {
        "name": "アースオーガ（油圧式）及びモンケン架装",
        "items": {
          "160-001": {
            "name": "ベースマシン16t吊　オーガトルク22kN・m　リーダ長16.4m　モンケン質量1.2t"
          },
          "250-001": {
            "name": "ベースマシン25t吊　オーガトルク35kN・m　リーダ長17.5m　モンケン質量2.0t"
          },
          "350-001": {
            "name": "ベースマシン35t吊　オーガトルク43kN・m　リーダ長22.0m　モンケン質量2.0t"
          },
          "500-001": {
            "name": "ベースマシン50t吊　オーガトルク60kN・m　リーダ長27.5m　モンケン質量2.0t"
          }
        }
      },
      "024": {
        "name": "アースオーガ併用油圧圧入式",
        "items": {
          "166-001": {
            "name": "ベースマシン16t吊　オーガ径Φ600mm　リーダ長16.2m　圧入力196kN"
          },
          "206-001": {
            "name": "ベースマシン20t吊　オーガ径Φ600mm　リーダ長16.2m　圧入力196kN"
          },
          "207-001": {
            "name": "ベースマシン20t吊　オーガ径Φ700mm　リーダ長17.5m　圧入力274kN"
          },
          "257-001": {
            "name": "ベースマシン25t吊　オーガ径Φ700mm　リーダ長17.5m　圧入力274kN"
          },
          "258-001": {
            "name": "ベースマシン25t吊　オーガ径Φ750mm　リーダ長17.5m　圧入力274kN"
          },
          "358-001": {
            "name": "ベースマシン35t吊　オーガ径Φ750mm　リーダ長17.5m　圧入力274kN"
          },
          "508-001": {
            "name": "ベースマシン50t吊　オーガ径Φ800mm　リーダ長22.0m　圧入力274kN"
          },
          "508-002": {
            "name": "ベースマシン50t吊　オーガ径Φ800mm　リーダ長26.0m　圧入力274kN"
          }
        }
      }
    }
  },
  "0522": {
    "name": "油圧式杭圧入引抜機",
    "items": {
      "022": {
        "name": "エンジン式ユニット・排出ガス対策型（第1次基準値）",
        "items": {
          "030-001": {
            "name": "[軽量鋼矢板用]圧入/引抜力294/392kN"
          },
          "080-001": {
            "name": "[軽量鋼矢板用]圧入/引抜力736~882/785~980kN"
          },
          "150-001": {
            "name": "[軽量鋼矢板用]圧入/引抜力981~1471/1079~1569kN"
          },
          "152-001": {
            "name": "[広幅鋼矢板用]圧入/引抜力981~1471/1079~1569kN"
          }
        }
      },
      "024": {
        "name": "エンジン式ユニット・排出ガス対策型（第3次基準値）",
        "items": {
          "080-001": {
            "name": "圧入/引抜力800/900kN"
          },
          "100-001": {
            "name": "圧入/引抜力1000/1100kN"
          },
          "101-001": {
            "name": "[ハット形鋼矢板900mm用]圧入/引抜力1000/1100kN"
          },
          "102-001": {
            "name": "[広幅鋼矢板用]圧入/引抜力1000/1100kN"
          }
        }
      },
      "026": {
        "name": "エンジン式ユニット・排出ガス対策型（2014年規制）",
        "items": {
          "152-001": {
            "name": "[広幅鋼矢板用]圧入/引抜力1500/1600kN"
          }
        }
      },
      "033": {
        "name": "エンジン式ユニット（硬質地盤専用）・排出ガス対策型（第2次基準値）",
        "items": {
          "082-001": {
            "name": "[広幅鋼矢板用]圧入/引抜力800/900kN"
          }
        }
      },
      "034": {
        "name": "エンジン式ユニット（硬質地盤専用）・排出ガス対策型（第3次基準値）",
        "items": {
          "080-001": {
            "name": "[普通鋼矢板用]圧入/引抜力800/900kN"
          },
          "082-001": {
            "name": "[広幅鋼矢板用]圧入/引抜力800/1000kN"
          }
        }
      },
      "036": {
        "name": "エンジン式ユニット（硬質地盤専用）・排出ガス対策型（2014年規制）",
        "items": {
          "101-001": {
            "name": "[ハット形鋼矢板900mm用]圧入/引抜力1000/1200kN"
          }
        }
      }
    }
  },
  "0532": {
    "name": "全回転型オールケーシング掘削機",
    "items": {
      "110": {
        "name": "ケーシングドライバ（クローラ式・ディーゼル/油圧駆動）",
        "items": {
          "150-001": {
            "name": "最大掘削径Φ1500mm"
          },
          "200-001": {
            "name": "最大掘削径Φ2000mm"
          }
        }
      },
      "150": {
        "name": "ケーシングドライバ（スキッド式・ディーゼル/油圧駆動）",
        "items": {
          "150-001": {
            "name": "最大掘削径Φ1500mm"
          },
          "200-001": {
            "name": "最大掘削径Φ2000mm"
          },
          "260-001": {
            "name": "最大掘削径Φ2600mm"
          },
          "300-001": {
            "name": "最大掘削径Φ3000mm"
          }
        }
      },
      "200": {
        "name": "ケーシングドライバ（スキッド式・ディーゼル/油圧駆動・回転杭用）・排出ガス対策型（第3次基準値）",
        "items": {
          "200-001": {
            "name": "最大掘削径Φ2000mm"
          }
        }
      }
    }
  },
  "0551": {
    "name": "地下連続壁施工機",
    "items": {
      "110": {
        "name": "回転水平多軸・クローラクレーン装着式",
        "items": {
          "150-100": {
            "name": "壁厚630~1500mm　掘削長100m　カッタトルク×台数4t・m×2台"
          },
          "150-150": {
            "name": "壁厚650~1500mm　掘削長150m　カッタトルク×台数8t・m×2台"
          },
          "240-150": {
            "name": "壁厚1200~2400mm　掘削長150m　カッタトルク×台数5t・m×2台"
          },
          "320-150": {
            "name": "壁厚1500~3200mm　掘削長150m　カッタトルク×台数13.5t・m×2台"
          }
        }
      },
      "120": {
        "name": "回転水平多軸（輸入）・クローラクレーン装着式",
        "items": {
          "280-150": {
            "name": "壁厚640~2800mm　掘削長150m　カッタトルク×台数8t・m×2台"
          }
        }
      },
      "010": {
        "name": "クローラクレーン（地下連続壁施工機用）",
        "items": {
          "100-001": {
            "name": "吊上能力100t"
          },
          "150-001": {
            "name": "吊上能力150t"
          }
        }
      }
    }
  },
  "0561": {
    "name": "深層混合処理機（スラリー式）",
    "items": {
      "100": {
        "name": "単軸式",
        "items": {
          "045-161": {
            "name": "モータ出力45kW×1　杭径Φ1000~1600mm　最大施工深度10m"
          },
          "110-162": {
            "name": "モータ出力90~110kW×1　杭径Φ1000~1600mm　最大施工深度20m"
          },
          "110-163": {
            "name": "モータ出力90~110kW×1　杭径Φ1000~1600mm　最大施工深度30m"
          },
          "180-203": {
            "name": "モータ出力90kW×2　杭径Φ1800~2000mm　最大施工深度27m"
          }
        }
      },
      "200": {
        "name": "二軸式",
        "items": {
          "090-101": {
            "name": "モータ出力45kW×2　杭径Φ1000mm　最大施工深度10m"
          },
          "120-102": {
            "name": "モータ出力55~60kW×2　杭径Φ1000mm　最大施工深度20m"
          },
          "180-103": {
            "name": "モータ出力75~90kW×2　杭径Φ1000mm　最大施工深度30m"
          },
          "180-104": {
            "name": "モータ出力90kW×2　杭径Φ1000mm　最大施工深度40m"
          },
          "180-105": {
            "name": "モータ出力90kW×2　杭径Φ1000mm　最大施工深度45m"
          },
          "180-121": {
            "name": "モータ出力75~90kW×2　杭径Φ1200mm　最大施工深度10m"
          },
          "180-122": {
            "name": "モータ出力90kW×2　杭径Φ1200mm　最大施工深度20m"
          },
          "180-131": {
            "name": "モータ出力90kW×2　杭径Φ1300mm　最大施工深度10m"
          },
          "220-123": {
            "name": "モータ出力90~110kW×2　杭径Φ1200mm　最大施工深度30m"
          },
          "220-124": {
            "name": "モータ出力90~110kW×2　杭径Φ1200mm　最大施工深度40m"
          },
          "230-132": {
            "name": "モータ出力90~110kW×2　杭径Φ1300mm　最大施工深度20m"
          },
          "220-133": {
            "name": "モータ出力90~110kW×2　杭径Φ1300mm　最大施工深度30m"
          }
        }
      },
      "300": {
        "name": "二軸式・変異低減型",
        "items": {
          "180-161": {
            "name": "モータ出力90kW×2　杭径Φ1600mm　最大施工深度10m"
          },
          "180-162": {
            "name": "モータ出力90kW×2　杭径Φ1600mm　最大施工深度20m"
          },
          "180-163": {
            "name": "モータ出力90kW×2　杭径Φ1600mm　最大施工深度26m"
          },
          "180-164": {
            "name": "モータ出力90kW×2　杭径Φ1600mm　最大施工深度36m"
          }
        }
      },
      "500": {
        "name": "単軸式・小型地盤改良機",
        "items": {
          "009-001": {
            "name": "全装備質量6~9t　掘削トルク11.2kN・m　改良径Φ600~800mm"
          },
          "011-001": {
            "name": "全装備質量11t　掘削トルク22.2kN・m　改良径Φ800~1000mm"
          },
          "013-001": {
            "name": "全装備質量13t　掘削トルク27.4kN・m　改良径Φ800~1300mm"
          },
          "015-001": {
            "name": "全装備質量17.6t　掘削トルク39.0kN・m　改良径Φ1000~1300mm"
          },
          "030-001": {
            "name": "全装備質量25~30t　掘削トルク71.1kN・m　改良径Φ1200~1400mm"
          }
        }
      }
    }
  },
  "0563": {
    "name": "粉体噴射攪拌機",
    "items": {
      "120": {
        "name": "単軸（油圧）・スキッド式",
        "items": {
          "075-001": {
            "name": "攪拌モータ（トルク×台数）19.6kN・m×1台　最大改良深度20m"
          }
        }
      },
      "250": {
        "name": "二軸（電動）・クローラ式",
        "items": {
          "055-001": {
            "name": "攪拌モータ（出力×台数）55kW×2台　最大改良深度26m"
          },
          "090-001": {
            "name": "攪拌モータ（出力×台数）90kW×2台　最大改良深度33m"
          },
          "110-001": {
            "name": "攪拌モータ（出力×台数）110kW×2台　最大改良深度33m"
          }
        }
      },
      "255": {
        "name": "二軸（電動・軸間拡大）・クローラ式",
        "items": {
          "090-001": {
            "name": "攪拌モータ（出力×台数）90kW×2台　最大改良深度20m"
          },
          "110-001": {
            "name": "攪拌モータ（出力×台数）110kW×2台　最大改良深度33m"
          }
        }
      }
    }
  },
  "0564": {
    "name": "クローラ式サンドパイル打機",
    "items": {
      "110": {
        "name": "バイブロ式",
        "items": {
          "083-001": {
            "name": "バイブロ出力75kW　リーダ長30m　クレーン能力35~37t"
          },
          "123-001": {
            "name": "バイブロ出力120kW　リーダ長30m　クレーン能力40t"
          },
          "124-001": {
            "name": "バイブロ出力120kW　リーダ長45m　クレーン能力40t"
          },
          "153-001": {
            "name": "バイブロ出力150kW　リーダ長35m　クレーン能力70t"
          },
          "185-001": {
            "name": "バイブロ出力180kW　リーダ長55m　クレーン能力150t"
          }
        }
      },
      "210": {
        "name": "袋詰式・サンドドレーン用",
        "items": {
          "006-001": {
            "name": "[標準クローラ]バイブロ出力60kW　リーダ長30m　クレーン能力35~37t"
          },
          "007-001": {
            "name": "[湿地クローラ]バイブロ出力60kW　リーダ長30m　クレーン能力35~37t"
          },
          "009-001": {
            "name": "[湿地クローラ]バイブロ出力60~90kW　リーダ長35~40m　クレーン能力40~60t"
          }
        }
      }
    }
  },
  "0565": {
    "name": "ペーパードレーン打機",
    "items": {
      "017": {
        "name": "湿地型",
        "items": {
          "030-001": {
            "name": "打設長~30m"
          },
          "040-001": {
            "name": "打設長30~40m"
          }
        }
      }
    }
  },
  "0593": {
    "name": "汚泥吸排車",
    "items": {
      "012": {
        "name": "トラック架装型",
        "items": {
          "035-001": {
            "name": "積載質量3.1~3.5t　吸入管径Φ75mm"
          },
          "055-001": {
            "name": "積載質量5.5t　吸入管径Φ75mm"
          },
          "080-001": {
            "name": "積載質量8.0t　吸入管径Φ75mm"
          },
          "095-001": {
            "name": "積載質量9.5t　吸入管径Φ75mm"
          }
        }
      }
    }
  },
  "0601": {
    "name": "ボーリングマシン",
    "items": {
      "11": {
        "name": "油圧式",
        "items": {
          "022-001": {
            "name": "2.2kW級"
          },
          "037-001": {
            "name": "3.7kW級"
          },
          "055-001": {
            "name": "5.5kW級"
          },
          "075-001": {
            "name": "7.5kW級"
          },
          "110-001": {
            "name": "11kW級"
          },
          "150-001": {
            "name": "15kW級"
          }
        }
      },
      "210": {
        "name": "ロータリパーカッション式・スキッド型",
        "items": {
          "550-001": {
            "name": "55kW級"
          }
        }
      },
      "250": {
        "name": "ロータリパーカッション式・クローラ型",
        "items": {
          "015-001": {
            "name": "15kW級"
          },
          "081-001": {
            "name": "81kW級"
          }
        }
      }
    }
  },
  "0605": {
    "name": "クローラドリル",
    "items": {
      "031": {
        "name": "油圧式",
        "items": {
          "100-001": {
            "name": "[搭乗式]ドリフタ質量100kg級"
          },
          "150-001": {
            "name": "[搭乗式]ドリフタ質量150kg級"
          },
          "180-001": {
            "name": "[搭乗式]ドリフタ質量180kg級"
          },
          "220-001": {
            "name": "[搭乗式]ドリフタ質量220kg級"
          },
          "250-001": {
            "name": "[搭乗式]ドリフタ質量250kg級"
          }
        }
      }
    }
  },
  "0610": {
    "name": "大型ブレーカ（ベースマシン含む）",
    "items": {
      "072": {
        "name": "排出ガス対策型（第1次基準値）",
        "items": {
          "220-001": {
            "name": "ブレーカー　油圧式2000kg級　ベースマシン30t級"
          },
          "230-001": {
            "name": "ブレーカー　油圧式3000kg級　ベースマシン30t級"
          },
          "240-001": {
            "name": "ブレーカー　油圧式4000kg級　ベースマシン46t級"
          }
        }
      },
      "074": {
        "name": "排出ガス対策型（第3次基準値）",
        "items": {
          "208-001": {
            "name": "ブレーカー　油圧式600~800kg級　ベースマシン12t級"
          },
          "213-001": {
            "name": "ブレーカー　油圧式1300kg級　ベースマシン20t級"
          }
        }
      }
    }
  },
  "0611": {
    "name": "ドリルジャンボ",
    "items": {
      "011": {
        "name": "レール式",
        "items": {
          "210-001": {
            "name": "形式　2ブーム　ドリフタ質量100kg級"
          }
        }
      },
      "032": {
        "name": "ホイール式・排出ガス対策型（第1次基準値）",
        "items": {
          "210-001": {
            "name": "形式　2ブーム・1バスケット　ドリフタ質量100kg級"
          },
          "215-001": {
            "name": "形式　2ブーム・1バスケット　ドリフタ質量150kg級"
          },
          "215-002": {
            "name": "形式　2ブーム・2バスケット　ドリフタ質量150kg級"
          },
          "315-002": {
            "name": "形式　3ブーム・2バスケット　ドリフタ質量150kg級"
          },
          "317-002": {
            "name": "形式　3ブーム・2バスケット　ドリフタ質量170kg超級"
          }
        }
      },
      "033": {
        "name": "ホイール式・排出ガス対策型（第2次基準値）",
        "items": {
          "217-002": {
            "name": "形式　2ブーム・2バスケット　ドリフタ質量170kg超級"
          }
        }
      },
      "034": {
        "name": "ホイール式・排出ガス対策型（第3次基準値）",
        "items": {
          "217-001": {
            "name": "形式　2ブーム・1バスケット　ドリフタ質量170kg超級"
          },
          "217-002": {
            "name": "形式　2ブーム・2バスケット　ドリフタ質量170kg超級"
          },
          "317-002": {
            "name": "形式　3ブーム・2バスケット　ドリフタ質量170kg超級"
          }
        }
      }
    }
  },
  "0613": {
    "name": "バックホウ（トンネル専用機）",
    "items": {
      "022": {
        "name": "標準型・排出ガス対策型（第1次基準値）",
        "items": {
          "020-001": {
            "name": "標準パケット容量（山積/平積）0.28/0.2㎥"
          },
          "035-001": {
            "name": "標準パケット容量（山積/平積）0.45/0.35㎥"
          }
        }
      },
      "023": {
        "name": "標準型・排出ガス対策型（第2次基準値）",
        "items": {
          "040-001": {
            "name": "標準パケット容量（山積/平積）0.5/0.4㎥"
          },
          "060-001": {
            "name": "標準パケット容量（山積/平積）0.8/0.6㎥"
          }
        }
      },
      "034": {
        "name": "後方小旋回型・排出ガス対策型（第3次基準値）",
        "items": {
          "060-001": {
            "name": "標準パケット容量（山積/平積）0.8/0.6㎥"
          }
        }
      },
      "044": {
        "name": "後方超小旋回型・排出ガス対策型（第3次基準値）",
        "items": {
          "020-001": {
            "name": "標準パケット容量（山積/平積）0.28/0.2㎥"
          },
          "035-001": {
            "name": "標準パケット容量（山積/平積）0.45/0.35㎥"
          },
          "040-001": {
            "name": "標準パケット容量（山積/平積）0.5/0.4㎥"
          },
          "060-001": {
            "name": "標準パケット容量（山積/平積）0.8/0.6㎥"
          },
          "085-001": {
            "name": "標準パケット容量（山積/平積）1.2/0.85㎥"
          }
        }
      }
    }
  },
  "0615": {
    "name": "クローラローダ（トンネル専用機）",
    "items": {
      "042": {
        "name": "サイドダンプ式・排出ガス対策型（第1次基準値）",
        "items": {
          "160-001": {
            "name": "パケット容量（山積）1.5~1.6㎥"
          }
        }
      }
    }
  },
  "0616": {
    "name": "ホイールローダ（トンネル専用機）",
    "items": {
      "053": {
        "name": "サイドダンプ式・排出ガス対策型（第2次基準値）",
        "items": {
          "190-001": {
            "name": "パケット容量（山積）1.9㎥"
          },
          "230-001": {
            "name": "パケット容量（山積）2.3㎥"
          }
        }
      },
      "054": {
        "name": "サイドダンプ式・排出ガス対策型（第3次基準値）",
        "items": {
          "250-001": {
            "name": "パケット容量（山積）2.5㎥"
          },
          "300-001": {
            "name": "パケット容量（山積）3.0㎥"
          }
        }
      }
    }
  },
  "0618": {
    "name": "ズリ積込・運搬機",
    "items": {
      "071": {
        "name": "ロードホウルダンプ",
        "items": {
          "170-001": {
            "name": "パケット容量（山積）1.7㎥"
          },
          "200-001": {
            "name": "パケット容量（山積）2.0㎥"
          },
          "300-001": {
            "name": "パケット容量（山積）3.0㎥"
          },
          "380-001": {
            "name": "パケット容量（山積）3.8㎥"
          }
        }
      }
    }
  },
  "0619": {
    "name": "ダンプトラック（トンネル工事用）",
    "items": {
      "063": {
        "name": "オフロード・排出ガス対策型（第2次基準値）",
        "items": {
          "250-001": {
            "name": "23~25t積"
          },
          "270-001": {
            "name": "27t積"
          }
        }
      },
      "064": {
        "name": "オフロード・排出ガス対策型（第3次基準値）",
        "items": {
          "100-001": {
            "name": "10t積"
          },
          "160-001": {
            "name": "16t積"
          },
          "200-001": {
            "name": "20t積"
          }
        }
      },
      "065": {
        "name": "オフロード・排出ガス対策型（2011年規制）",
        "items": {
          "300-001": {
            "name": "30t積"
          }
        }
      },
      "072": {
        "name": "コンテナ着脱式・排出ガス対策型（第1次基準値）",
        "items": {
          "250-001": {
            "name": "積載質量25t　コンテナ容量（山積）15㎥"
          }
        }
      }
    }
  },
  "0620": {
    "name": "トラック（トンネル工事用）",
    "items": {
      "012": {
        "name": "普通型",
        "items": {
          "020-001": {
            "name": "2t積"
          }
        }
      },
      "022": {
        "name": "クレーン装置付",
        "items": {
          "043-001": {
            "name": "ベーストラック4t積級　吊能力2.9t"
          }
        }
      }
    }
  },
  "0625": {
    "name": "コンクリート吹付機",
    "items": {
      "072": {
        "name": "湿式吹付・R一体・C搭載・排出ガス対策型（第1次基準値）",
        "items": {
          "220-001": {
            "name": "吐出量8~22㎥/h級　吹付半径7m級"
          }
        }
      },
      "073": {
        "name": "湿式吹付・R一体・C搭載・排出ガス対策型（第2次基準値）",
        "items": {
          "220-001": {
            "name": "吐出量6~22㎥/h級　吹付半径7m級"
          }
        }
      },
      "082": {
        "name": "湿式吹付・R一体・エレクタ型・排出ガス対策型（第1次基準値）",
        "items": {
          "220-001": {
            "name": "吐出量6~22㎥/h級　吹付半径7m級"
          }
        }
      },
      "094": {
        "name": "湿式吹付・R一体・C搭載・エレクタ型・排出ガス対策型（第3次基準値）",
        "items": {
          "220-001": {
            "name": "吐出量6~22㎥/h級　吹付半径7m級"
          }
        }
      }
    }
  },
  "0626": {
    "name": "支保工建込エレクタ",
    "items": {
      "011": {
        "name": "クローラ式",
        "items": {
          "010-001": {
            "name": "1.0t×2ブーム"
          }
        }
      },
      "021": {
        "name": "ホイール式",
        "items": {
          "010-001": {
            "name": "1.0t×2ブーム"
          }
        }
      }
    }
  },
  "0701": {
    "name": "モータグレーダ",
    "items": {
      "012": {
        "name": "土工用・排出ガス対策型（第1次基準値）",
        "items": {
          "400-001": {
            "name": "ブレード幅4.0m"
          }
        }
      },
      "014": {
        "name": "土工用・排出ガス対策型（第3次基準値）",
        "items": {
          "310-001": {
            "name": "ブレード幅3.1m"
          },
          "340-001": {
            "name": "ブレード幅3.4m"
          },
          "370-001": {
            "name": "ブレード幅3.7m"
          }
        }
      },
      "016": {
        "name": "土工用・排出ガス対策型（2014規制型）",
        "items": {
          "430-001": {
            "name": "ブレード幅3.7~4.3m"
          }
        }
      }
    }
  },
  "0702": {
    "name": "スタビライザ",
    "items": {
      "012": {
        "name": "路床改良用",
        "items": {
          "312-001": {
            "name": "処理深さ×幅0.3×1.2m"
          },
          "616-001": {
            "name": "処理深さ×幅0.6×1.6m"
          },
          "620-001": {
            "name": "処理深さ×幅0.6×2.0m"
          },
          "720-001": {
            "name": "処理深さ×幅0.7×2.0m"
          },
          "920-001": {
            "name": "処理深さ×幅1.2×2.0m"
          }
        }
      },
      "013": {
        "name": "路床改良用・排出ガス対策型（第2次基準値）",
        "items": {
          "620-001": {
            "name": "処理深さ×幅0.6×2.0m"
          },
          "920-001": {
            "name": "処理深さ×幅1.2×2.0m"
          }
        }
      },
      "022": {
        "name": "路盤再生用",
        "items": {
          "416-001": {
            "name": "処理深さ×幅0.4×1.6m"
          },
          "420-001": {
            "name": "処理深さ×幅0.4×2.0m"
          }
        }
      },
      "032": {
        "name": "路床改良用・トレンチャ型",
        "items": {
          "120-001": {
            "name": "処理深さ×幅1.0×2.0m"
          }
        }
      }
    }
  },
  "0810": {
    "name": "ロードローラ",
    "items": {
      "021": {
        "name": "マカダム",
        "items": {
          "014-001": {
            "name": "運転質量13~14t　締固め幅2.1m"
          }
        }
      },
      "022": {
        "name": "マカダム・排出ガス対策型（第1次基準値）",
        "items": {
          "012-001": {
            "name": "運転質量10~12t　締固め幅2.1m"
          }
        }
      },
      "024": {
        "name": "マカダム・排出ガス対策型（第3次基準値）",
        "items": {
          "010-001": {
            "name": "運転質量10t　締固め幅2.1m"
          }
        }
      },
      "041": {
        "name": "振動マカダム",
        "items": {
          "010-001": {
            "name": "運転質量8~9t　"
          }
        }
      }
    }
  },
  "0820": {
    "name": "タイヤローラ",
    "items": {
      "021": {
        "name": "普通型",
        "items": {
          "030-001": {
            "name": "運転質量21~30t　"
          }
        }
      },
      "024": {
        "name": "普通型・排出ガス対策型（第3次基準値）",
        "items": {
          "004-001": {
            "name": "運転質量3~4t　"
          },
          "020-001": {
            "name": "運転質量8~20t　"
          }
        }
      },
      "025": {
        "name": "普通型・排出ガス対策型（2011年規制）",
        "items": {
          "013-001": {
            "name": "運転質量13t　"
          }
        }
      },
      "073": {
        "name": "振動タイヤローラ・排出ガス対策型（第2次基準値）",
        "items": {
          "009-001": {
            "name": "運転質量9t　"
          }
        }
      }
    }
  },
  "0841": {
    "name": "振動ローラ（舗装用）",
    "items": {
      "100": {
        "name": "ハンドガイド式",
        "items": {
          "006-001": {
            "name": "運転質量0.5~0.6t　"
          },
          "011-001": {
            "name": "運転質量0.8~1.1t　"
          }
        }
      },
      "211": {
        "name": "搭乗・タンデム式",
        "items": {
          "180-001": {
            "name": "運転質量15~18t　"
          }
        }
      },
      "214": {
        "name": "搭乗・タンデム式・排出ガス対策型（第3次基準値）",
        "items": {
          "015-001": {
            "name": "運転質量1.2~1.5t　"
          },
          "028-001": {
            "name": "運転質量2.4~2.8t　"
          },
          "050-001": {
            "name": "運転質量3~5t　"
          },
          "075-001": {
            "name": "運転質量6~7.5t　"
          },
          "100-001": {
            "name": "運転質量8~10t　"
          },
          "120-001": {
            "name": "運転質量11~12t　"
          }
        }
      },
      "234": {
        "name": "搭乗・タンデム・水平振動式・排出ガス対策型（第3次基準値）",
        "items": {
          "070-001": {
            "name": "運転質量7t　"
          }
        }
      },
      "254": {
        "name": "搭載・タンデム・水平振動式・ラバーロール・排出ガス対策型（第3次基準値）",
        "items": {
          "075-001": {
            "name": "運転質量7.4t"
          }
        }
      },
      "314": {
        "name": "搭乗・コンバインド式・排出ガス対策型（第3次基準値）",
        "items": {
          "015-001": {
            "name": "運転質量1.2~1.5t　"
          },
          "026-001": {
            "name": "運転質量2.4~2.6t　"
          },
          "040-001": {
            "name": "運転質量3~4t　"
          },
          "070-001": {
            "name": "運転質量5~7t　"
          },
          "100-001": {
            "name": "運転質量8~10t　"
          },
          "120-001": {
            "name": "運転質量11~12t　"
          }
        }
      }
    }
  },
  "0845": {
    "name": "振動ローラ（土工用）",
    "items": {
      "214": {
        "name": "フラット・シングルドラム型・排出ガス対策型（第3次基準値）",
        "items": {
          "120-001": {
            "name": "運転質量11~12t　"
          },
          "180-001": {
            "name": "運転質量15~18t　"
          },
          "200-001": {
            "name": "運転質量19~20t　"
          }
        }
      },
      "314": {
        "name": "タンピング・シングルドラム型・排出ガス対策型（第3次基準値）",
        "items": {
          "120-001": {
            "name": "運転質量11~12t　"
          },
          "180-001": {
            "name": "運転質量15~18t　"
          },
          "200-001": {
            "name": "運転質量19~20t　"
          }
        }
      },
      "513": {
        "name": "フラット・シングルドラム型・垂直振動型・排出ガス対策型（第2次基準値）",
        "items": {
          "200-001": {
            "name": "運転質量19~20t　"
          }
        }
      },
      "613": {
        "name": "タンピング・シングルドラム型・垂直振動型・排出ガス対策型（第2次基準値）",
        "items": {
          "200-001": {
            "name": "運転質量19~20t　"
          }
        }
      }
    }
  },
  "0861": {
    "name": "タンパ及びランマ",
    "items": {
      "017": {
        "name": "ランマ",
        "items": {
          "080-001": {
            "name": "質量60~80kg"
          }
        }
      },
      "027": {
        "name": "エアタンパ",
        "items": {
          "018-001": {
            "name": "質量18kg級　エア消費量1.1㎥/min"
          }
        }
      }
    }
  },
  "0870": {
    "name": "振動コンパクタ",
    "items": {
      "100": {
        "name": "前進型",
        "items": {
          "060-001": {
            "name": "機械質量40~60kg"
          },
          "080-001": {
            "name": "機械質量70~80kg"
          },
          "090-001": {
            "name": "機械質量90kg"
          }
        }
      },
      "210": {
        "name": "前後進方（ガソリンエンジン駆動）",
        "items": {
          "060-001": {
            "name": "機械質量60kg"
          },
          "110-001": {
            "name": "機械質量110kg"
          }
        }
      },
      "220": {
        "name": "前後進方（ディーゼルエンジン駆動）",
        "items": {
          "160-001": {
            "name": "機械質量160kg"
          },
          "200-001": {
            "name": "機械質量200kg"
          },
          "330-001": {
            "name": "機械質量330kg"
          },
          "440-001": {
            "name": "機械質量440kg"
          }
        }
      }
    }
  },
  "0921": {
    "name": "アジテータトラック（トラックミキサ）",
    "items": {
      "012": {
        "name": "トラック架装型",
        "items": {
          "008-001": {
            "name": "混合容量0.8~0.9㎥"
          },
          "016-001": {
            "name": "混合容量1.6~1.7㎥"
          },
          "032-001": {
            "name": "混合容量3.0~3.2㎥"
          },
          "044-001": {
            "name": "混合容量4.4㎥"
          }
        }
      }
    }
  },
  "0951": {
    "name": "コンクリートポンプ車",
    "items": {
      "012": {
        "name": "トラック架装・配管式",
        "items": {
          "045-001": {
            "name": "圧送能力40~45㎥/h"
          },
          "055-001": {
            "name": "圧送能力55㎥/h"
          },
          "070-001": {
            "name": "圧送能力70㎥/h"
          },
          "100-001": {
            "name": "圧送能力90~100㎥/h"
          }
        }
      },
      "022": {
        "name": "トラック架装・ブーム式",
        "items": {
          "020-001": {
            "name": "圧送能力20㎥/h"
          },
          "030-001": {
            "name": "圧送能力30㎥/h"
          },
          "045-001": {
            "name": "圧送能力40~45㎥/h"
          },
          "060-001": {
            "name": "圧送能力55~60㎥/h"
          },
          "085-001": {
            "name": "圧送能力65~85㎥/h"
          },
          "110-001": {
            "name": "圧送能力90~110㎥/h"
          },
          "125-001": {
            "name": "圧送能力115~125㎥/h"
          }
        }
      }
    }
  },
};
const NEW_CO2_ITEMS = {
  "9901": {
    "name": "ダンプトラック",
    "items": {
      "001": {
        "name": "日建連機種中項目",
        "items": {
          "001-001": {
            "name": "10t未満"
          },
          "001-002": {
            "name": "10t以上"
          }
        }
      }
    }
  },
  "9902": {
    "name": "トラック",
    "items": {
      "001": {
        "name": "日建連機種中項目",
        "items": {
          "001-001": {
            "name": "4t未満"
          },
          "001-002": {
            "name": "4t以上"
          }
        }
      }
    }
  },
  "9903": {
    "name": "重ダンプトラック",
    "items": {
      "001": {
        "name": "日建連機種中項目",
        "items": {
          "001-001": {
            "name": "32t未満"
          },
          "001-002": {
            "name": "32t以上"
          }
        }
      }
    }
  },
  "9904": {
    "name": "バックホー",
    "items": {
      "001": {
        "name": "日建連機種中項目",
        "items": {
          "001-001": {
            "name": "1m3未満"
          },
          "001-002": {
            "name": "1m3未満ハイブリッド"
          },
          "001-003": {
            "name": "1m3以上"
          }
        }
      }
    }
  },
  "9905": {
    "name": "ミニバックホー",
    "items": {
      "001": {
        "name": "日建連機種中項目",
        "items": {
          "001-001": {
            "name": "ミニバックホー"
          }
        }
      }
    }
  },
  "9906": {
    "name": "ブルドーザー",
    "items": {
      "001": {
        "name": "日建連機種中項目",
        "items": {
          "001-001": {
            "name": "10t未満"
          },
          "001-002": {
            "name": "10t以上"
          }
        }
      }
    }
  },
  "9907": {
    "name": "トラクタショベル",
    "items": {
      "001": {
        "name": "日建連機種中項目",
        "items": {
          "001-001": {
            "name": "クラローダ"
          },
          "001-002": {
            "name": "トラクタショベル"
          }
        }
      }
    }
  },
  "9908": {
    "name": "ホイルローダ",
    "items": {
      "001": {
        "name": "日建連機種中項目",
        "items": {
          "001-001": {
            "name": "4m3未満"
          },
          "001-002": {
            "name": "4m3以上"
          }
        }
      }
    }
  },
  "9909": {
    "name": "ロードローラ",
    "items": {
      "001": {
        "name": "日建連機種中項目",
        "items": {
          "001-001": {
            "name": "ロードローラ"
          }
        }
      }
    }
  },
  "9910": {
    "name": "基礎杭・掘削機械",
    "items": {
      "001": {
        "name": "日建連機種中項目",
        "items": {
          "001-001": {
            "name": "ｸﾛｰﾗ式杭打機"
          },
          "001-002": {
            "name": "ｸﾛｰﾗ式アースオーガ"
          },
          "001-003": {
            "name": "ｸﾛｰﾗ式地下連壁"
          }
        }
      }
    }
  },
  "9911": {
    "name": "クラムシェル",
    "items": {
      "001": {
        "name": "日建連機種中項目",
        "items": {
          "001-001": {
            "name": "1m3未満"
          },
          "001-002": {
            "name": "1m3以上"
          }
        }
      }
    }
  },
  "9912": {
    "name": "トラッククレーン",
    "items": {
      "001": {
        "name": "日建連機種中項目",
        "items": {
          "001-001": {
            "name": "50t吊り未満"
          },
          "001-002": {
            "name": "50t吊り以上"
          }
        }
      }
    }
  },
  "9913": {
    "name": "ラフタークレーン",
    "items": {
      "001": {
        "name": "日建連機種中項目",
        "items": {
          "001-001": {
            "name": "20t吊り未満"
          },
          "001-002": {
            "name": "20t吊り以上"
          }
        }
      }
    }
  },
  "9914": {
    "name": "クローラクレーン",
    "items": {
      "001": {
        "name": "日建連機種中項目",
        "items": {
          "001-001": {
            "name": "50t吊り未満"
          },
          "001-002": {
            "name": "50t吊り以上"
          }
        }
      }
    }
  },
  "9915": {
    "name": "フォークリフト",
    "items": {
      "001": {
        "name": "日建連機種中項目",
        "items": {
          "001-001": {
            "name": "2t吊り未満"
          },
          "001-002": {
            "name": "2t吊り以上"
          }
        }
      }
    }
  },
  "9916": {
    "name": "コンクリートポンプ車",
    "items": {
      "001": {
        "name": "日建連機種中項目",
        "items": {
          "001-001": {
            "name": "50m3未満"
          },
          "001-002": {
            "name": "50m3以上"
          }
        }
      }
    }
  },
  "9917": {
    "name": "高所作業車",
    "items": {
      "001": {
        "name": "日建連機種中項目",
        "items": {
          "001-001": {
            "name": "ブーム型"
          },
          "001-002": {
            "name": "垂直型"
          }
        }
      }
    }
  },
  "9918": {
    "name": "発電機",
    "items": {
      "001": {
        "name": "日建連機種中項目",
        "items": {
          "001-001": {
            "name": "50kVA未満"
          },
          "001-002": {
            "name": "50~149kVA"
          },
          "001-003": {
            "name": "150kVA以上"
          }
        }
      }
    }
  },
  "9919": {
    "name": "空気圧縮機",
    "items": {
      "001": {
        "name": "日建連機種中項目",
        "items": {
          "001-001": {
            "name": "100kw未満"
          },
          "001-002": {
            "name": "100kw以上"
          }
        }
      }
    }
  }
}
const FILTERS_OPTIONS = {
  "ブルドーザ及びスクレーパ": "01",
  "掘削及び積込機": "02",
  "運搬機械": "03",
  "クレーンその他の荷役機械": "04",
  "基礎工事用機械": "05",
  "せん孔機械及びトンネル工事用機械": "06",
  "モータグレーダ及び路盤用機械": "07",
  "締固め機械": "08",
  "コンクリート機械": "09",
  "舗装機械": "10",
  "道路維持用機械": "11",
  "空気圧縮機及び送風機（原動機を含む）": "12",
  "建設用ポンプ（原動機を含む）": "13",
  "電気機器": "15",
  "ウインチ類": "16",
  "試験測定機器": "17",
  "鋼橋・ＰＣ橋架設用仮設備機器": "18",
  "その他の機器": "20",
  "除雪用建設機械等": "50"
};
const DATA_AFTER_CONVERT = [
  {
    "key": "01",
    "label": "ブルドーザスクレープドーザ",
    "group": "ブルドーザ及びスクレーパ"
  },
  {
    "key": "0101",
    "label": "ブルドーザ",
    "items": [
      {
        "key": "126",
        "label": "湿地・ＩＣＴ施工対応型・排出ガス対策型",
        "items": [
          {
            "key": "070-302",
            "label": "7t級"
          },
          {
            "key": "160-302",
            "label": "16t級"
          },
          {
            "key": "200-302",
            "label": "20t級"
          }
        ]
      },
      {
        "key": "014",
        "label": "普通・排出ガス対策型",
        "items": [
          {
            "key": "030-001",
            "label": "3t級"
          },
          {
            "key": "060-001",
            "label": "6t級"
          },
          {
            "key": "090-001",
            "label": "9t級"
          },
          {
            "key": "015-001",
            "label": "15t級"
          },
          {
            "key": "018-001",
            "label": "18t級"
          },
          {
            "key": "021-001",
            "label": "21t級"
          },
          {
            "key": "032-001",
            "label": "32t級"
          }
        ]
      },
      {
        "key": "024",
        "label": "湿地・排出ガス対策型",
        "items": [
          {
            "key": "040-001",
            "label": "4t級"
          },
          {
            "key": "070-001",
            "label": "7t級"
          },
          {
            "key": "100-001",
            "label": "10t級"
          },
          {
            "key": "130-001",
            "label": "13t級"
          },
          {
            "key": "160-001",
            "label": "16t級"
          },
          {
            "key": "200-001",
            "label": "20t級"
          },
          {
            "key": "280-001",
            "label": "28t級"
          }
        ]
      },
      {
        "key": "032",
        "label": "超湿地・排出ガス対策型（第１次基準値）",
        "items": [
          {
            "key": "100-001",
            "label": "10t級"
          }
        ]
      },
      {
        "key": "034",
        "label": "超湿地・排出ガス対策型（第３次基準値）",
        "items": [
          {
            "key": "040-001",
            "label": "4t級"
          },
          {
            "key": "180-001",
            "label": "18t級"
          }
        ]
      },
      {
        "key": "044",
        "label": "超々湿地・排出ガス対策型",
        "items": [
          {
            "key": "040-001",
            "label": "4t級"
          },
          {
            "key": "100-001",
            "label": "10t級"
          }
        ]
      },
      {
        "key": "051",
        "label": "リッパ装置付",
        "items": [
          {
            "key": "440-001",
            "label": "44t級"
          },
          {
            "key": "630-001",
            "label": "63t級"
          },
          {
            "key": "950-001",
            "label": "95t級"
          }
        ]
      },
      {
        "key": "054",
        "label": "リッパ装置付・排出ガス対策型",
        "items": [
          {
            "key": "180-001",
            "label": "18t級"
          },
          {
            "key": "210-001",
            "label": "21t級"
          },
          {
            "key": "320-001",
            "label": "32t級"
          },
          {
            "key": "440-001",
            "label": "44t級"
          },
          {
            "key": "630-001",
            "label": "63t級"
          }
        ]
      }
    ]
  },
  {
    "key": "0104",
    "label": "スクレープドーザ",
    "items": [
      {
        "key": "011",
        "label": "普通型",
        "items": [
          {
            "key": "268-001",
            "label": "26t級"
          }
        ]
      }
    ]
  },
  {
    "key": "02",
    "label": "小型バックホウ（クローラ型）バックホウ（クローラ型）その他バックホウドラグライン及びクラムシェル泥上掘削機クローラローダ（トラクタショベル）ホイールローダ（トラクタショベル）",
    "group": "掘削及び積込機"
  },
  {
    "key": "0201",
    "label": "小型バックホウ（クローラ型）",
    "items": [
      {
        "key": "111",
        "label": "標準型",
        "items": [
          {
            "key": "001-001",
            "label": "標準バケット容量（山積／平積）0.001／0.008m3"
          },
          {
            "key": "002-001",
            "label": "標準バケット容量（山積／平積）0.022／0.015m3"
          }
        ]
      },
      {
        "key": "112",
        "label": "標準型・排出ガス対策型",
        "items": [
          {
            "key": "003-001",
            "label": "標準バケット容量（山積／平積）0.044／0.03m3"
          },
          {
            "key": "004-001",
            "label": "標準バケット容量（山積／平積）0.055／0.44m3"
          },
          {
            "key": "006-001",
            "label": "標準バケット容量（山積／平積）0.08／0.06m3"
          }
        ]
      },
      {
        "key": "113",
        "label": "標準型・排出ガス対策型",
        "items": [
          {
            "key": "006-001",
            "label": "標準バケット容量（山積／平積）0.08／0.06m3"
          },
          {
            "key": "008-001",
            "label": "標準バケット容量（山積／平積）0.11／0.08m3"
          },
          {
            "key": "010-001",
            "label": "標準バケット容量（山積／平積）0.13／0.10m3"
          },
          {
            "key": "011-001",
            "label": "標準バケット容量（山積／平積）0.16／0.11m3"
          }
        ]
      },
      {
        "key": "123",
        "label": "標準型・クレーン機能付き・排出ガス対策型",
        "items": [
          {
            "key": "008-001",
            "label": "標準バケット容量（山積／平積）0.11／0.08m3"
          },
          {
            "key": "010-001",
            "label": "標準バケット容量（山積／平積）0.13／0.10m3"
          },
          {
            "key": "011-001",
            "label": "標準バケット容量（山積／平積）0.16／0.11m3"
          },
          {
            "key": "016-001",
            "label": "標準バケット容量（山積／平積）0.22／0.16m3"
          }
        ]
      },
      {
        "key": "132",
        "label": "標準型・超低騒音型・排出ガス対策型（第１次基準値）",
        "items": [
          {
            "key": "003-001",
            "label": "標準バケット容量（山積／平積）0.044／0.03m3"
          }
        ]
      },
      {
        "key": "134",
        "label": "標準型・超低騒音型・排出ガス対策型（第３次基準値）",
        "items": [
          {
            "key": "004-001",
            "label": "標準バケット容量（山積／平積）0.055／0.44m3"
          },
          {
            "key": "006-001",
            "label": "標準バケット容量（山積／平積）0.08／0.06m3"
          },
          {
            "key": "008-001",
            "label": "標準バケット容量（山積／平積）0.09~0.11／0.07~0.08m3"
          },
          {
            "key": "010-001",
            "label": "標準バケット容量（山積／平積）0.13／0.10m3"
          },
          {
            "key": "011-001",
            "label": "標準バケット容量（山積／平積）0.16／0.11m3"
          }
        ]
      },
      {
        "key": "143",
        "label": "標準型・調停騒音型・クレーン機能付き・排出ガス対策型",
        "items": [
          {
            "key": "008-001",
            "label": "標準バケット容量（山積／平積）0.11／0.08m3"
          },
          {
            "key": "010-001",
            "label": "標準バケット容量（山積／平積）0.13~0.14／0.10m3"
          }
        ]
      },
      {
        "key": "211",
        "label": "後方超小旋回型",
        "items": [
          {
            "key": "001-001",
            "label": "標準バケット容量（山積／平積）0.01／0.008m3"
          },
          {
            "key": "002-001",
            "label": "標準バケット容量（山積／平積）0.022／0.015m3"
          }
        ]
      },
      {
        "key": "213",
        "label": "後方超小旋回型・排出ガス対策型（第２次基準値）",
        "items": [
          {
            "key": "010-001",
            "label": "標準バケット容量（山積／平積）0.13／0.10m3"
          }
        ]
      },
      {
        "key": "214",
        "label": "後方超小旋回型・排出ガス対策型（第３次基準値）",
        "items": [
          {
            "key": "003-001",
            "label": "標準バケット容量（山積／平積）0.044／0.03m3"
          },
          {
            "key": "005-001",
            "label": "標準バケット容量（山積／平積）0.066／0.05m3"
          },
          {
            "key": "007-001",
            "label": "標準バケット容量（山積／平積）0.09／0.07m3"
          },
          {
            "key": "012-001",
            "label": "標準バケット容量（山積／平積）0.16／0.12m3"
          }
        ]
      },
      {
        "key": "233",
        "label": "後方超小旋回型・超低騒音型・排出ガス対策型（第２次基準値）",
        "items": [
          {
            "key": "004-001",
            "label": "標準バケット容量（山積／平積）0.055／0.44m3"
          }
        ]
      },
      {
        "key": "234",
        "label": "後方超小旋回型・超低騒音型・排出ガス対策型（第３次基準値）",
        "items": [
          {
            "key": "002-001",
            "label": "標準バケット容量（山積／平積）0.025／0.02m3"
          },
          {
            "key": "003-001",
            "label": "標準バケット容量（山積／平積）0.044／0.03m3"
          },
          {
            "key": "005-001",
            "label": "標準バケット容量（山積／平積）0.066／0.05m3"
          },
          {
            "key": "006-001",
            "label": "標準バケット容量（山積／平積）0.08／0.06m3"
          },
          {
            "key": "007-001",
            "label": "標準バケット容量（山積／平積）0.09／0.07m3"
          },
          {
            "key": "009-001",
            "label": "標準バケット容量（山積／平積）0.11／0.09m3"
          },
          {
            "key": "010-001",
            "label": "標準バケット容量（山積／平積）0.13／0.10m3"
          },
          {
            "key": "011-001",
            "label": "標準バケット容量（山積／平積）0.14／0.11m3"
          },
          {
            "key": "012-001",
            "label": "標準バケット容量（山積／平積）0.16／0.12m3"
          }
        ]
      },
      {
        "key": "244",
        "label": "後方超小旋回型・超低騒音型・クレーン機能付き・排出ガス対策型（第３次基準値）",
        "items": [
          {
            "key": "006-001",
            "label": "標準バケット容量（山積／平積）0.08／0.06m3"
          },
          {
            "key": "007-001",
            "label": "標準バケット容量（山積／平積）0.09／0.07m3"
          },
          {
            "key": "009-001",
            "label": "標準バケット容量（山積／平積）0.11／0.09m3"
          },
          {
            "key": "011-001",
            "label": "標準バケット容量（山積／平積）0.14／0.11m3"
          },
          {
            "key": "012-001",
            "label": "標準バケット容量（山積／平積）0.16／0.12m3"
          }
        ]
      },
      {
        "key": "313",
        "label": "超小旋回型・排出ガス対策型（第2次基準値）",
        "items": [
          {
            "key": "006-001",
            "label": "標準バケット容量（山積／平積）0.08／0.06m3"
          }
        ]
      },
      {
        "key": "314",
        "label": "超小旋回型・排出ガス対策型（第3次基準値）",
        "items": [
          {
            "key": "008-001",
            "label": "標準バケット容量（山積／平積）0.11／0.08m3"
          },
          {
            "key": "016-001",
            "label": "標準バケット容量（山積／平積）0.22／0.16m3"
          }
        ]
      },
      {
        "key": "324",
        "label": "超小旋回型・クレーン機能付き・排出ガス対策型（第3次基準値）",
        "items": [
          {
            "key": "016-001",
            "label": "標準バケット容量（山積／平積）0.22／0.16m3"
          }
        ]
      },
      {
        "key": "334",
        "label": "超小旋回型・超低騒音型・排出ガス対策型（第3次基準値）",
        "items": [
          {
            "key": "003-001",
            "label": "標準バケット容量（山積／平積）0.044／0.03m3"
          },
          {
            "key": "004-001",
            "label": "標準バケット容量（山積／平積）0.055／0.04m3"
          },
          {
            "key": "005-001",
            "label": "標準バケット容量（山積／平積）0.066／0.05m3"
          },
          {
            "key": "006-001",
            "label": "標準バケット容量（山積／平積）0.08／0.06m3"
          },
          {
            "key": "007-001",
            "label": "標準バケット容量（山積／平積）0.09／0.07m3"
          },
          {
            "key": "008-001",
            "label": "標準バケット容量（山積／平積）0.11／0.08m3"
          },
          {
            "key": "012-001",
            "label": "標準バケット容量（山積／平積）0.16／0.12m3"
          },
          {
            "key": "016-001",
            "label": "標準バケット容量（山積／平積）0.22／0.16m3"
          }
        ]
      },
      {
        "key": "344",
        "label": "超小旋回型・超低騒音型・クレーン機能付き・排出ガス対策型（第3次基準値）",
        "items": [
          {
            "key": "005-001",
            "label": "標準バケット容量（山積／平積）0.066／0.05m3"
          },
          {
            "key": "007-001",
            "label": "標準バケット容量（山積／平積）0.09／0.07m3"
          },
          {
            "key": "009-001",
            "label": "標準バケット容量（山積／平積）0.11／0.09m3"
          },
          {
            "key": "012-001",
            "label": "標準バケット容量（山積／平積）0.16／0.12m3"
          }
        ]
      }
    ]
  },
  {
    "key": "0202",
    "label": "バックホウ（クローラ型）",
    "items": [
      {
        "key": "111",
        "label": "標準型",
        "items": [
          {
            "key": "730-001",
            "label": "標準バケット容量（山積／平積）10.0／7.3m3"
          }
        ]
      },
      {
        "key": "113",
        "label": "標準型・排出ガス対策型（第2次基準値）",
        "items": [
          {
            "key": "035-001",
            "label": "標準バケット容量（山積／平積）0.45／0.35m3"
          }
        ]
      },
      {
        "key": "114",
        "label": "標準型・排出ガス対策型（第3次基準値）",
        "items": [
          {
            "key": "020-001",
            "label": "標準バケット容量（山積／平積）0.28／0.2m3"
          },
          {
            "key": "040-001",
            "label": "標準バケット容量（山積／平積）0.5／0.4m3"
          },
          {
            "key": "050-001",
            "label": "標準バケット容量（山積／平積）0.6／0.5m3"
          },
          {
            "key": "060-001",
            "label": "標準バケット容量（山積／平積）0.8／0.6m3"
          },
          {
            "key": "070-001",
            "label": "標準バケット容量（山積／平積）1.0／0.7m3"
          },
          {
            "key": "080-001",
            "label": "標準バケット容量（山積／平積）1.1／0.8m3"
          },
          {
            "key": "100-001",
            "label": "標準バケット容量（山積／平積）1.4／1.0m3"
          },
          {
            "key": "150-001",
            "label": "標準バケット容量（山積／平積）1.9／1.4m3"
          },
          {
            "key": "210-001",
            "label": "標準バケット容量（山積／平積）2.7／2.1m3"
          },
          {
            "key": "240-001",
            "label": "標準バケット容量（山積／平積）3.1／2.4m3"
          },
          {
            "key": "260-001",
            "label": "標準バケット容量（山積／平積）3.5／2.6m3"
          },
          {
            "key": "380-001",
            "label": "標準バケット容量（山積／平積）5.0／3.8m3"
          }
        ]
      },
      {
        "key": "123",
        "label": "標準型・クレーン機能付き・排出ガス対策型（第2次基準値）",
        "items": [
          {
            "key": "020-001",
            "label": "標準バケット容量（山積／平積）0.28／0.2m3"
          },
          {
            "key": "035-001",
            "label": "標準バケット容量（山積／平積）0.45／0.35m3"
          },
          {
            "key": "040-001",
            "label": "標準バケット容量（山積／平積）0.5／0.4m3"
          },
          {
            "key": "060-001",
            "label": "標準バケット容量（山積／平積）0.8／0.6m3"
          }
        ]
      },
      {
        "key": "124",
        "label": "標準型・クレーン機能付き・排出ガス対策型（第3次基準値）",
        "items": [
          {
            "key": "060-001",
            "label": "標準バケット容量（山積／平積）0.8／0.6m3"
          }
        ]
      },
      {
        "key": "133",
        "label": "標準型・超低騒音型・排出ガス対策型（第2次基準値）",
        "items": [
          {
            "key": "020-001",
            "label": "標準バケット容量（山積／平積）0.28／0.2m3"
          },
          {
            "key": "045-001",
            "label": "標準バケット容量（山積／平積）0.6／0.45m3"
          },
          {
            "key": "070-001",
            "label": "標準バケット容量（山積／平積）1.0／0.7m3"
          }
        ]
      },
      {
        "key": "134",
        "label": "標準型・超低騒音型・排出ガス対策型（第3次基準値）",
        "items": [
          {
            "key": "035-001",
            "label": "標準バケット容量（山積／平積）0.45／0.35m3"
          },
          {
            "key": "040-001",
            "label": "標準バケット容量（山積／平積）0.5／0.4m3"
          },
          {
            "key": "060-001",
            "label": "標準バケット容量（山積／平積）0.8／0.6m3"
          }
        ]
      },
      {
        "key": "144",
        "label": "標準型・超低騒音型・クレーン機能付き・排出ガス対策型（第3次基準値）",
        "items": [
          {
            "key": "060-001",
            "label": "標準バケット容量（山積／平積）0.8／0.6m3"
          }
        ]
      },
      {
        "key": "214",
        "label": "後方超小旋回型・排出ガス対策型（第3次基準値）",
        "items": [
          {
            "key": "020-001",
            "label": "標準バケット容量（山積／平積）0.28／0.2m3"
          },
          {
            "key": "035-001",
            "label": "標準バケット容量（山積／平積）0.45／0.35m3"
          },
          {
            "key": "040-001",
            "label": "標準バケット容量（山積／平積）0.5／0.4m3"
          },
          {
            "key": "060-001",
            "label": "標準バケット容量（山積／平積）0.8／0.6m3"
          }
        ]
      },
      {
        "key": "224",
        "label": "後方超小旋回型・クレーン機能付き・排出ガス対策型（第3次基準値）",
        "items": [
          {
            "key": "020-001",
            "label": "標準バケット容量（山積／平積）0.28／0.2m3"
          },
          {
            "key": "035-001",
            "label": "標準バケット容量（山積／平積）0.45／0.35m3"
          },
          {
            "key": "040-001",
            "label": "標準バケット容量（山積／平積）0.5／0.4m3"
          },
          {
            "key": "060-001",
            "label": "標準バケット容量（山積／平積）0.8／0.6m3"
          }
        ]
      },
      {
        "key": "234",
        "label": "後方超小旋回型・超低騒音型・排出ガス対策型（第3次基準値）",
        "items": [
          {
            "key": "020-001",
            "label": "標準バケット容量（山積／平積）0.28／0.2m3"
          },
          {
            "key": "035-001",
            "label": "標準バケット容量（山積／平積）0.45／0.35m3"
          },
          {
            "key": "040-001",
            "label": "標準バケット容量（山積／平積）0.5／0.4m3"
          },
          {
            "key": "060-001",
            "label": "標準バケット容量（山積／平積）0.8／0.6m3"
          }
        ]
      },
      {
        "key": "245",
        "label": "後方超小旋回型・超低騒音型・クレーン機能付き・排出ガス対策型（2011年規制）",
        "items": [
          {
            "key": "035-001",
            "label": "標準バケット容量（山積／平積）0.45／0.35m3"
          },
          {
            "key": "040-001",
            "label": "標準バケット容量（山積／平積）0.5／0.4m3"
          },
          {
            "key": "060-001",
            "label": "標準バケット容量（山積／平積）0.8／0.6m3"
          }
        ]
      },
      {
        "key": "314",
        "label": "超小旋回型・排出ガス対策型（第3次基準値）",
        "items": [
          {
            "key": "020-001",
            "label": "標準バケット容量（山積／平積）0.28／0.2m3"
          },
          {
            "key": "035-001",
            "label": "標準バケット容量（山積／平積）0.45／0.35m3"
          }
        ]
      },
      {
        "key": "324",
        "label": "超小旋回型・クレーン機能付き・排出ガス対策型（第3次基準値）",
        "items": [
          {
            "key": "020-001",
            "label": "標準バケット容量（山積／平積）0.28／0.2m3"
          },
          {
            "key": "035-001",
            "label": "標準バケット容量（山積／平積）0.45／0.35m3"
          }
        ]
      },
      {
        "key": "414",
        "label": "超ロングアーム型・排出ガス対策型（第3次基準値）",
        "items": [
          {
            "key": "030-001",
            "label": "バケット容量（山積／平積）0.4／0.3m3"
          }
        ]
      },
      {
        "key": "714",
        "label": "ディーゼル／電気ハイブリット型・排出ガス対策型（第3次基準値）",
        "items": [
          {
            "key": "060-001",
            "label": "標準バケット容量（山積／平積）0.8／0.6m3"
          }
        ]
      },
      {
        "key": "825",
        "label": "標準型・ＩＣＴ施工対応型・超低騒音型・クレーン機能付き・排出ガス対策型（第3次基準値）",
        "items": [
          {
            "key": "060-302",
            "label": "標準バケット容量（山積／平積）0.8／0.6m3"
          }
        ]
      }
    ]
  },
  {
    "key": "0203",
    "label": "その他バックホウ",
    "items": [
      {
        "key": "122",
        "label": "ホイール型・抽出ガス対策型（第1次基準値）",
        "items": [
          {
            "key": "020-001",
            "label": "標準バケット容量（山積／平積）0.28／0.2m3"
          }
        ]
      },
      {
        "key": "123",
        "label": "ホイール型・抽出ガス対策型（第2次基準値）",
        "items": [
          {
            "key": "035-001",
            "label": "標準バケット容量（山積／平積）0.45／0.35m3"
          },
          {
            "key": "045-001",
            "label": "標準バケット容量（山積／平積）0.6／0.45m3"
          }
        ]
      },
      {
        "key": "124",
        "label": "ホイール型・抽出ガス対策型（第3次基準値）",
        "items": [
          {
            "key": "040-001",
            "label": "標準バケット容量（山積／平積）0.5／0.4m3"
          }
        ]
      }
    ]
  },
  {
    "key": "0204",
    "label": "ドラグライン及びクラムシェル",
    "items": [
      {
        "key": "021",
        "label": "油圧ローブ式・クローラ型",
        "items": [
          {
            "key": "060-001",
            "label": "バケット容量（平積）0.6m3"
          },
          {
            "key": "080-001",
            "label": "バケット容量（平積）0.8m3"
          },
          {
            "key": "100-001",
            "label": "バケット容量（平積）1.0m3"
          }
        ]
      },
      {
        "key": "031",
        "label": "油圧クラムシェル・クローラ型",
        "items": [
          {
            "key": "030-001",
            "label": "バケット容量（平積）0.3m3"
          },
          {
            "key": "061-001",
            "label": "バケット容量（平積）0.6m3"
          },
          {
            "key": "062-001",
            "label": "バケット容量（平積）[深堀用]0.6m3"
          }
        ]
      },
      {
        "key": "051",
        "label": "油圧クラムシェル・ホイール型",
        "items": [
          {
            "key": "030-001",
            "label": "バケット容量（平積）0.3m3"
          }
        ]
      },
      {
        "key": "062",
        "label": "油圧クラムシェル・テレスコピック型・排出ガス対策型（第1次基準値）",
        "items": [
          {
            "key": "020-001",
            "label": "バケット容量（平積）0.15／0.2m3"
          },
          {
            "key": "025-001",
            "label": "バケット容量（平積）0.25m3"
          },
          {
            "key": "030-001",
            "label": "バケット容量（平積）0.26~0.3m3"
          },
          {
            "key": "040-001",
            "label": "バケット容量（平積）0.4m3"
          },
          {
            "key": "060-001",
            "label": "バケット容量（平積）0.6m3"
          },
          {
            "key": "130-001",
            "label": "バケット容量（平積）1.0~1.3m3"
          }
        ]
      }
    ]
  },
  {
    "key": "0205",
    "label": "泥上掘削機",
    "items": [
      {
        "key": "021",
        "label": "フロート構造トラック・バックホウ型",
        "items": [
          {
            "key": "027-040",
            "label": "バケット容量（平積）×最大作業範囲0.4m3×11m"
          },
          {
            "key": "027-070",
            "label": "バケット容量（平積）×最大作業範囲0.7m3×11m"
          }
        ]
      },
      {
        "key": "024",
        "label": "フロート構造トラック・バックホウ型・排出ガス対策型（第3次基準値）",
        "items": [
          {
            "key": "042-070",
            "label": "バケット容量（平積）×最大作業範囲0.7m3×13m"
          }
        ]
      }
    ]
  },
  {
    "key": "0206",
    "label": "クローラローダ（トラクタショベル）",
    "items": [
      {
        "key": "011",
        "label": "普通型",
        "items": [
          {
            "key": "190-001",
            "label": "標準バケット容量（山積）1.8~1.9m3"
          }
        ]
      }
    ]
  },
  {
    "key": "0207",
    "label": "ホイールローダ（トラクタショベル）",
    "items": [
      {
        "key": "061",
        "label": "普通型",
        "items": [
          {
            "key": "999-001",
            "label": "標準バケット容量（山積）11~12m3"
          }
        ]
      },
      {
        "key": "062",
        "label": "普通・排出ガス対策型（第1次基準値）",
        "items": [
          {
            "key": "034-001",
            "label": "標準バケット容量（山積）0.34~0.35m3"
          },
          {
            "key": "080-001",
            "label": "標準バケット容量（山積）0.8m3"
          },
          {
            "key": "120-001",
            "label": "標準バケット容量（山積）1.2m3"
          }
        ]
      },
      {
        "key": "063",
        "label": "普通・排出ガス対策型（第2次基準値）",
        "items": [
          {
            "key": "060-001",
            "label": "標準バケット容量（山積）0.6m3"
          }
        ]
      },
      {
        "key": "064",
        "label": "普通・排出ガス対策型（第3次基準値）",
        "items": [
          {
            "key": "030-001",
            "label": "標準バケット容量（山積）0.3m3"
          },
          {
            "key": "040-001",
            "label": "標準バケット容量（山積）0.4m3"
          },
          {
            "key": "050-001",
            "label": "標準バケット容量（山積）0.5m3"
          },
          {
            "key": "100-001",
            "label": "標準バケット容量（山積）0.9~1.0m3"
          },
          {
            "key": "140-001",
            "label": "標準バケット容量（山積）1.3~1.4m3"
          },
          {
            "key": "160-001",
            "label": "標準バケット容量（山積）1.5~1.6m3"
          },
          {
            "key": "220-001",
            "label": "標準バケット容量（山積）1.9~2.2m3"
          },
          {
            "key": "300-001",
            "label": "標準バケット容量（山積）2.5~3.0m3"
          },
          {
            "key": "340-001",
            "label": "標準バケット容量（山積）3.2~3.4m3"
          },
          {
            "key": "370-001",
            "label": "標準バケット容量（山積）3.5~3.7m3"
          },
          {
            "key": "410-001",
            "label": "標準バケット容量（山積）4.0~4.1m3"
          },
          {
            "key": "460-001",
            "label": "標準バケット容量（山積）4.5~4.6m3"
          },
          {
            "key": "560-001",
            "label": "標準バケット容量（山積）5.0~5.6m3"
          },
          {
            "key": "700-001",
            "label": "標準バケット容量（山積）6.0~7.0m3"
          }
        ]
      },
      {
        "key": "074",
        "label": "普通・排出ガス対策型（第3次基準値）",
        "items": [
          {
            "key": "030-001",
            "label": "標準バケット容量（山積）0.3m3"
          },
          {
            "key": "040-001",
            "label": "標準バケット容量（山積）0.4m3"
          },
          {
            "key": "050-001",
            "label": "標準バケット容量（山積）0.5m3"
          },
          {
            "key": "060-001",
            "label": "標準バケット容量（山積）0.6m3"
          },
          {
            "key": "100-001",
            "label": "標準バケット容量（山積）0.9~1.0m3"
          },
          {
            "key": "140-001",
            "label": "標準バケット容量（山積）1.3~1.4m3"
          }
        ]
      }
    ]
  },
  {
    "key": "03",
    "label": "ダンプトラックトラックトレーラ不整地運搬車",
    "group": "運搬機械"
  },
  {
    "key": "0301",
    "label": "ダンプトラック",
    "items": [
      {
        "key": "011",
        "label": "オンロード・ディーゼル",
        "items": [
          {
            "key": "020-001",
            "label": "2t積級"
          },
          {
            "key": "030-001",
            "label": "3t積級"
          },
          {
            "key": "040-001",
            "label": "4t積級"
          },
          {
            "key": "070-001",
            "label": "6~7t積級"
          },
          {
            "key": "080-001",
            "label": "8t積級"
          },
          {
            "key": "110-001",
            "label": "10t積級"
          },
          {
            "key": "120-001",
            "label": "12t積級"
          }
        ]
      },
      {
        "key": "031",
        "label": "オフロード・リジッドフレーム式",
        "items": [
          {
            "key": "200-001",
            "label": "20t積級"
          },
          {
            "key": "780-001",
            "label": "78~95t積級"
          }
        ]
      },
      {
        "key": "032",
        "label": "オフロード・リジッドフレーム式・排出ガス対策型（第1次基準値）",
        "items": [
          {
            "key": "250-001",
            "label": "25t積級"
          }
        ]
      },
      {
        "key": "033",
        "label": "オフロード・リジッドフレーム式・排出ガス対策型（第2次基準値）",
        "items": [
          {
            "key": "250-001",
            "label": "25t積級"
          }
        ]
      },
      {
        "key": "034",
        "label": "オフロード・リジッドフレーム式・排出ガス対策型（第3次基準値）",
        "items": [
          {
            "key": "320-001",
            "label": "32~37t積級"
          },
          {
            "key": "460-001",
            "label": "46~55t積級"
          }
        ]
      },
      {
        "key": "074",
        "label": "オフロード・アーティキューレート式・排出ガス対策型（第3次基準値）",
        "items": [
          {
            "key": "225-001",
            "label": "22~24t積級"
          },
          {
            "key": "270-001",
            "label": "27~28t積級"
          },
          {
            "key": "320-001",
            "label": "32~34t積級"
          },
          {
            "key": "370-001",
            "label": "36~39t積級"
          }
        ]
      },
      {
        "key": "075",
        "label": "オフロード・アーティキューレート式・排出ガス対策型（2011年規制）",
        "items": [
          {
            "key": "370-001",
            "label": "36~41t積級"
          }
        ]
      }
    ]
  },
  {
    "key": "0302",
    "label": "トラック",
    "items": [
      {
        "key": "011",
        "label": "普通型",
        "items": [
          {
            "key": "015-001",
            "label": "1.5t積"
          },
          {
            "key": "020-001",
            "label": "2t積"
          },
          {
            "key": "035-001",
            "label": "3~3.5t積"
          },
          {
            "key": "045-001",
            "label": "4~4.5t積"
          },
          {
            "key": "055-001",
            "label": "5~5.5t積"
          },
          {
            "key": "065-001",
            "label": "6~6.5t積"
          },
          {
            "key": "080-001",
            "label": "8t積"
          },
          {
            "key": "110-001",
            "label": "11t積"
          },
          {
            "key": "150-001",
            "label": "15t積"
          }
        ]
      },
      {
        "key": "021",
        "label": "クレーン装置付き",
        "items": [
          {
            "key": "022-001",
            "label": "ベーストラック2t級"
          },
          {
            "key": "023-001",
            "label": "ベーストラック2t級"
          },
          {
            "key": "033-001",
            "label": "ベーストラック3t級"
          },
          {
            "key": "042-001",
            "label": "ベーストラック4t級"
          },
          {
            "key": "043-001",
            "label": "ベーストラック4t級"
          },
          {
            "key": "053-001",
            "label": "ベーストラック5t級"
          },
          {
            "key": "063-001",
            "label": "ベーストラック6t級"
          },
          {
            "key": "073-001",
            "label": "ベーストラック7t級"
          },
          {
            "key": "083-001",
            "label": "ベーストラック8t級"
          },
          {
            "key": "103-001",
            "label": "ベーストラック10t級"
          }
        ]
      }
    ]
  },
  {
    "key": "0303",
    "label": "トレーラ",
    "items": [
      {
        "key": "011",
        "label": "セミ",
        "items": [
          {
            "key": "150-001",
            "label": "15t積"
          },
          {
            "key": "200-001",
            "label": "20t積"
          },
          {
            "key": "250-001",
            "label": "25t積"
          },
          {
            "key": "280-001",
            "label": "28t積"
          },
          {
            "key": "320-001",
            "label": "32t積"
          },
          {
            "key": "400-001",
            "label": "40t積"
          },
          {
            "key": "500-001",
            "label": "50t積"
          }
        ]
      }
    ]
  },
  {
    "key": "0308",
    "label": "不整地運搬車",
    "items": [
      {
        "key": "011",
        "label": "クローラ型・ダンプ式",
        "items": [
          {
            "key": "030-001",
            "label": "3t積"
          },
          {
            "key": "035-001",
            "label": "3.5t積"
          },
          {
            "key": "040-001",
            "label": "4t積"
          },
          {
            "key": "050-001",
            "label": "5t積"
          }
        ]
      },
      {
        "key": "012",
        "label": "クローラ型・ダンプ式・排出ガス対策型（第1次基準値）",
        "items": [
          {
            "key": "020-001",
            "label": "2t積"
          },
          {
            "key": "035-001",
            "label": "3.3~3.5t積"
          },
          {
            "key": "070-001",
            "label": "6.3~7t積"
          },
          {
            "key": "110-001",
            "label": "8~11t積"
          },
          {
            "key": "150-001",
            "label": "12.5~15t積"
          }
        ]
      },
      {
        "key": "013",
        "label": "クローラ型・ダンプ式・排出ガス対策型（第2次基準値）",
        "items": [
          {
            "key": "010-001",
            "label": "1t積"
          },
          {
            "key": "015-001",
            "label": "1.5t積"
          },
          {
            "key": "050-001",
            "label": "4~5t積"
          },
          {
            "key": "070-001",
            "label": "7t積"
          },
          {
            "key": "100-001",
            "label": "10t積"
          }
        ]
      },
      {
        "key": "014",
        "label": "クローラ型・ダンプ式・排出ガス対策型（第3次基準値）",
        "items": [
          {
            "key": "018-001",
            "label": "1.8t積"
          },
          {
            "key": "025-001",
            "label": "2.5t積"
          },
          {
            "key": "038-001",
            "label": "3.8t積"
          }
        ]
      },
      {
        "key": "016",
        "label": "クローラ型・ダンプ式・排出ガス対策型（2014年規制）",
        "items": [
          {
            "key": "050-001",
            "label": "5t積"
          },
          {
            "key": "070-001",
            "label": "6~7t積"
          },
          {
            "key": "110-001",
            "label": "11t積"
          }
        ]
      },
      {
        "key": "021",
        "label": "クローラ型・カーゴ式・クレーン装置付",
        "items": [
          {
            "key": "171-001",
            "label": "1.7t積"
          },
          {
            "key": "201-001",
            "label": "2t積"
          },
          {
            "key": "252-001",
            "label": "2.5t積"
          },
          {
            "key": "352-001",
            "label": "3.5t積"
          }
        ]
      },
      {
        "key": "063",
        "label": "クローラ型・ダンプ・全旋回式・排出ガス対策型（第2次基準値）",
        "items": [
          {
            "key": "010-001",
            "label": "1t積"
          },
          {
            "key": "030-001",
            "label": "3t積"
          },
          {
            "key": "040-001",
            "label": "4t積"
          },
          {
            "key": "065-001",
            "label": "6~7t積"
          },
          {
            "key": "110-001",
            "label": "10~11t積"
          }
        ]
      }
    ]
  },
  {
    "key": "04",
    "label": "クローラクレーントラッククレーンラフテレーンクレーンフォークリフト高所作業車",
    "group": "クレーンその他の荷役機械"
  },
  {
    "key": "0401",
    "label": "クローラクレーン",
    "items": [
      {
        "key": "011",
        "label": "機会駆動式ウインチ・ラチスジブ型",
        "items": [
          {
            "key": "016-001",
            "label": "16t吊"
          },
          {
            "key": "020-001",
            "label": "22.5t吊"
          },
          {
            "key": "040-001",
            "label": "35~40t吊"
          },
          {
            "key": "050-001",
            "label": "45~50t吊"
          },
          {
            "key": "080-001",
            "label": "80t吊"
          },
          {
            "key": "100-001",
            "label": "100t吊"
          },
          {
            "key": "150-001",
            "label": "150t吊"
          }
        ]
      },
      {
        "key": "022",
        "label": "油圧駆動式ウインチ・ラチスジブ型・排出ガス対策型（第1次基準値）",
        "items": [
          {
            "key": "065-001",
            "label": "60~65t吊"
          },
          {
            "key": "150-001",
            "label": "150t吊"
          },
          {
            "key": "300-001",
            "label": "300t吊"
          },
          {
            "key": "650-001",
            "label": "650t吊"
          }
        ]
      },
      {
        "key": "023",
        "label": "油圧駆動式ウインチ・ラチスジブ型・排出ガス対策型（第2次基準値）",
        "items": [
          {
            "key": "035-001",
            "label": "30~35t吊"
          }
        ]
      },
      {
        "key": "024",
        "label": "油圧駆動式ウインチ・ラチスジブ型・排出ガス対策型（第3次基準値）",
        "items": [
          {
            "key": "045-001",
            "label": "40~45t吊"
          },
          {
            "key": "055-001",
            "label": "50~55t吊"
          },
          {
            "key": "070-001",
            "label": "70t吊"
          },
          {
            "key": "080-001",
            "label": "80t吊"
          },
          {
            "key": "090-001",
            "label": "90t吊"
          },
          {
            "key": "100-001",
            "label": "100t吊"
          },
          {
            "key": "120-001",
            "label": "120t吊"
          },
          {
            "key": "200-001",
            "label": "200t吊"
          },
          {
            "key": "350-001",
            "label": "350t吊"
          },
          {
            "key": "500-001",
            "label": "500t吊"
          }
        ]
      },
      {
        "key": "043",
        "label": "油圧駆動式ウインチ・タワー型・排出ガス対策型（第2次基準値）",
        "items": [
          {
            "key": "011-050",
            "label": "タワー型能力11.4t吊ベースマシン50t吊"
          }
        ]
      },
      {
        "key": "044",
        "label": "油圧駆動式ウインチ・タワー型・排出ガス対策型（第3次基準値）",
        "items": [
          {
            "key": "011-055",
            "label": "タワー型能力11.5t吊ベースマシン55t吊"
          },
          {
            "key": "013-070",
            "label": "タワー型能力13t吊ベースマシン70t吊"
          },
          {
            "key": "015-090",
            "label": "タワー型能力15t吊ベースマシン90t吊"
          },
          {
            "key": "020-120",
            "label": "タワー型能力20t吊ベースマシン120t吊"
          },
          {
            "key": "025-200",
            "label": "タワー型能力25t吊ベースマシン200t吊"
          },
          {
            "key": "100-350",
            "label": "タワー型能力100t吊ベースマシン350t吊"
          },
          {
            "key": "210-500",
            "label": "タワー型能力210t吊ベースマシン500t吊"
          }
        ]
      },
      {
        "key": "052",
        "label": "油圧伸縮ジブ型・排出ガス対策型（第1次基準値）",
        "items": [
          {
            "key": "035-001",
            "label": "35t吊"
          },
          {
            "key": "055-001",
            "label": "55t吊"
          }
        ]
      },
      {
        "key": "053",
        "label": "油圧伸縮ジブ型・排出ガス対策型（第2次基準値）",
        "items": [
          {
            "key": "055-001",
            "label": "50~55t吊"
          },
          {
            "key": "075-001",
            "label": "75t吊"
          }
        ]
      },
      {
        "key": "054",
        "label": "油圧伸縮ジブ型・排出ガス対策型（第3次基準値）",
        "items": [
          {
            "key": "005-001",
            "label": "4.9t吊"
          },
          {
            "key": "040-001",
            "label": "40t吊"
          }
        ]
      },
      {
        "key": "055",
        "label": "油圧伸縮ジブ型・排出ガス対策型（2011年規制）",
        "items": [
          {
            "key": "065-001",
            "label": "65t吊"
          }
        ]
      },
      {
        "key": "061",
        "label": "油圧伸縮ジブ型・4脚式ミニクレーン",
        "items": [
          {
            "key": "280-140",
            "label": "2.8t×1.4m級"
          },
          {
            "key": "300-250",
            "label": "3t×2.5m級"
          },
          {
            "key": "300-350",
            "label": "3t×3.5m級"
          }
        ]
      }
    ]
  },
  {
    "key": "0402",
    "label": "トラッククレーン",
    "items": [
      {
        "key": "022",
        "label": "トラッククレーン・油圧伸縮ジブ型",
        "items": [
          {
            "key": "005-001",
            "label": "4.9t吊"
          },
          {
            "key": "007-001",
            "label": "7.0t吊"
          },
          {
            "key": "016-001",
            "label": "16t吊"
          },
          {
            "key": "020-001",
            "label": "20t吊"
          },
          {
            "key": "025-001",
            "label": "25t吊"
          },
          {
            "key": "030-001",
            "label": "30t吊"
          },
          {
            "key": "035-001",
            "label": "35t吊"
          },
          {
            "key": "045-001",
            "label": "40~45t吊"
          },
          {
            "key": "050-001",
            "label": "50t吊"
          },
          {
            "key": "080-001",
            "label": "80t吊"
          },
          {
            "key": "100-001",
            "label": "100t吊"
          },
          {
            "key": "120-001",
            "label": "120t吊"
          },
          {
            "key": "160-001",
            "label": "160t吊"
          },
          {
            "key": "360-001",
            "label": "360t吊"
          },
          {
            "key": "500-001",
            "label": "500t吊"
          }
        ]
      },
      {
        "key": "032",
        "label": "オールテレーンクレーン・油圧伸縮ジブ型",
        "items": [
          {
            "key": "100-001",
            "label": "100t吊"
          },
          {
            "key": "130-001",
            "label": "120~130t吊"
          },
          {
            "key": "170-001",
            "label": "150~170t吊"
          },
          {
            "key": "250-001",
            "label": "200~250t吊"
          },
          {
            "key": "300-001",
            "label": "300t吊"
          },
          {
            "key": "360-001",
            "label": "360t吊"
          },
          {
            "key": "400-001",
            "label": "400t吊"
          },
          {
            "key": "550-001",
            "label": "550t吊"
          },
          {
            "key": "650-001",
            "label": "600t吊"
          }
        ]
      }
    ]
  },
  {
    "key": "0403",
    "label": "ラフテレーンクレーン",
    "items": [
      {
        "key": "012",
        "label": "油圧伸縮ジブ型・排出ガス対策型（第1次基準値）",
        "items": [
          {
            "key": "007-001",
            "label": "7t吊"
          },
          {
            "key": "010-001",
            "label": "10t吊"
          },
          {
            "key": "022-001",
            "label": "22t吊"
          }
        ]
      },
      {
        "key": "013",
        "label": "油圧伸縮ジブ型・排出ガス対策型（第2次基準値）",
        "items": [
          {
            "key": "020-001",
            "label": "20t吊"
          },
          {
            "key": "030-001",
            "label": "30t吊"
          },
          {
            "key": "051-001",
            "label": "50~51t吊"
          },
          {
            "key": "065-001",
            "label": "60~65t吊"
          }
        ]
      },
      {
        "key": "014",
        "label": "油圧伸縮ジブ型・排出ガス対策型（第3次基準値）",
        "items": [
          {
            "key": "005-001",
            "label": "4.9t吊"
          },
          {
            "key": "013-001",
            "label": "12~13t吊"
          },
          {
            "key": "016-001",
            "label": "16t吊"
          },
          {
            "key": "025-001",
            "label": "25t吊"
          },
          {
            "key": "035-001",
            "label": "35t吊"
          },
          {
            "key": "065-001",
            "label": "60~70t吊"
          }
        ]
      },
      {
        "key": "015",
        "label": "油圧伸縮ジブ型・排出ガス対策型（2011年規制）",
        "items": [
          {
            "key": "065-001",
            "label": "60~75t吊"
          }
        ]
      },
      {
        "key": "016",
        "label": "油圧伸縮ジブ型・排出ガス対策型（2014年規制）",
        "items": [
          {
            "key": "080-001",
            "label": "80t吊"
          }
        ]
      }
    ]
  },
  {
    "key": "0431",
    "label": "フォークリフト",
    "items": [
      {
        "key": "012",
        "label": "エンジン駆動",
        "items": [
          {
            "key": "009-001",
            "label": "最大積載荷重0.9t級"
          },
          {
            "key": "015-001",
            "label": "最大積載荷重1.5t級"
          },
          {
            "key": "020-001",
            "label": "最大積載荷重2.0t級"
          },
          {
            "key": "025-001",
            "label": "最大積載荷重2.5t級"
          }
        ]
      }
    ]
  },
  {
    "key": "0433",
    "label": "高所作業車",
    "items": [
      {
        "key": "110",
        "label": "トラック架装・伸縮ブーム・バスケット型",
        "items": [
          {
            "key": "100-020",
            "label": "作業床高9.7m 積載荷重200kg"
          },
          {
            "key": "120-020",
            "label": "作業床高12.0m 積載荷重200kg"
          },
          {
            "key": "140-020",
            "label": "作業床高14.0m 積載荷重200kg"
          },
          {
            "key": "170-020",
            "label": "作業床高17.0m 積載荷重200kg"
          },
          {
            "key": "230-020",
            "label": "作業床高22.0m 積載荷重200kg"
          }
        ]
      },
      {
        "key": "150",
        "label": "トラック架装・伸縮ブーム・プラットフォーム型",
        "items": [
          {
            "key": "100-011",
            "label": "作業床高9.9m 積載荷重1000kg"
          },
          {
            "key": "120-011",
            "label": "作業床高12.0m 積載荷重1000kg"
          },
          {
            "key": "150-100",
            "label": "作業床高14.8m 積載荷重1000kg"
          },
          {
            "key": "200-100",
            "label": "作業床高19.7m 積載荷重1000kg"
          }
        ]
      },
      {
        "key": "250",
        "label": "トラック架装・垂直昇降・プラットフォーム型",
        "items": [
          {
            "key": "100-100",
            "label": "作業床高9.9m 積載荷重1000kg"
          },
          {
            "key": "100-130",
            "label": "作業床高13.2m 積載荷重1000kg"
          },
          {
            "key": "170-005",
            "label": "揚程5m 積載荷重1700kg"
          },
          {
            "key": "320-005",
            "label": "揚程5m 積載荷重3200kg"
          }
        ]
      }
    ]
  },
  {
    "key": "05",
    "label": "油圧ハンマ（単体）パイプロハンマ（単体）杭打ち用ウォータジェットクローラ式杭打機（ベースマシン）クローラ式杭打機クローラ式アースオーガアースドリルラフテレーンクレーン装着式アースオーガ油圧式杭圧入引抜機全回転型オールケーシング掘削機地下連続壁施工機深層混合処理機（スラリー式）粉体噴射攪拌機クローラ式サンドパイル打機ペーパードレーン打機汚泥吸排車",
    "group": "基礎工事用機械"
  },
  {
    "key": "0502",
    "label": "油圧ハンマ（単体）",
    "items": [
      {
        "key": "017",
        "label": "直抗用",
        "items": [
          {
            "key": "020-002",
            "label": "ラム質量2t"
          },
          {
            "key": "040-002",
            "label": "ラム質量4~4.5t"
          },
          {
            "key": "065-002",
            "label": "ラム質量6.5~8.0t"
          },
          {
            "key": "125-002",
            "label": "ラム質量10~12.5t"
          }
        ]
      },
      {
        "key": "018",
        "label": "直抗用・斜坑兼用",
        "items": [
          {
            "key": "012-002",
            "label": "ラム質量11.5~12.5t"
          },
          {
            "key": "015-002",
            "label": "ラム質量15t"
          }
        ]
      }
    ]
  },
  {
    "key": "0503",
    "label": "パイプロハンマ（単体）",
    "items": [
      {
        "key": "034",
        "label": "油圧式・可変高周波型・排出ガス対策型（第3次基準値）",
        "items": [
          {
            "key": "070-002",
            "label": "[振り子式]最大起振力700kN 振動周波数20-38Hz"
          }
        ]
      },
      {
        "key": "042",
        "label": "油圧式・可変超高周波型・排出ガス対策型（第1次基準値）",
        "items": [
          {
            "key": "016-002",
            "label": "[ピストン式]最大起振力157kN 振動周波数20-60Hz"
          },
          {
            "key": "025-002",
            "label": "[ピストン式]最大起振力245kN 振動周波数20-60Hz"
          },
          {
            "key": "029-002",
            "label": "[振り子式]最大起振力284kN 振動周波数20-60Hz"
          },
          {
            "key": "032-002",
            "label": "[ピストン式]最大起振力314kN 振動周波数20-60Hz"
          },
          {
            "key": "045-002",
            "label": "[振り子式]最大起振力441kN 振動周波数20-60Hz"
          }
        ]
      },
      {
        "key": "043",
        "label": "油圧式・可変超高周波型・排出ガス対策型（第2次基準値）",
        "items": [
          {
            "key": "035-002",
            "label": "[振り子式]最大起振力347kN 振動周波数20-60Hz"
          }
        ]
      },
      {
        "key": "044",
        "label": "油圧式・可変超高周波型・排出ガス対策型（第3次基準値）",
        "items": [
          {
            "key": "048-002",
            "label": "[振り子式]最大起振力4473kN 振動周波数20-60Hz"
          }
        ]
      },
      {
        "key": "055",
        "label": "油圧ショベル装着式・可変超高周波型",
        "items": [
          {
            "key": "005-002",
            "label": "[ピストン式]最大起振力49.0kN 振動周波数20-60Hz"
          },
          {
            "key": "010-002",
            "label": "[ピストン式]最大起振力98.1kN 振動周波数20-60Hz"
          }
        ]
      },
      {
        "key": "058",
        "label": "油圧ショベル装着式（超低騒音型）",
        "items": [
          {
            "key": "060-002",
            "label": "最大起振力58.8kN 振動周波数27-36Hz"
          },
          {
            "key": "090-002",
            "label": "最大起振力88.3kN 振動周波数27-36Hz"
          },
          {
            "key": "130-002",
            "label": "最大起振力128kN 振動周波数27-36Hz"
          },
          {
            "key": "160-002",
            "label": "最大起振力160kN 振動周波数27-36Hz"
          },
          {
            "key": "200-002",
            "label": "最大起振力200kN 振動周波数27-36Hz"
          }
        ]
      }
    ]
  },
  {
    "key": "0504",
    "label": "杭打ち用ウォータジェット",
    "items": [
      {
        "key": "022",
        "label": "エンジン式・排出ガス対策型（第1次基準値）",
        "items": [
          {
            "key": "147-033",
            "label": "圧力14.7MPa吐出量325ℓ/min"
          },
          {
            "key": "147-090",
            "label": "圧力14.7MPa吐出量896ℓ/min"
          }
        ]
      },
      {
        "key": "023",
        "label": "エンジン式・排出ガス対策型（第2次基準値）",
        "items": [
          {
            "key": "100-060",
            "label": "圧力100MPa吐出量60~600ℓ/min"
          }
        ]
      },
      {
        "key": "024",
        "label": "エンジン式・排出ガス対策型（第3次基準値）",
        "items": [
          {
            "key": "147-033",
            "label": "圧力14.7MPa吐出量325ℓ/min"
          },
          {
            "key": "147-090",
            "label": "圧力14.7MPa吐出量900ℓ/min"
          }
        ]
      }
    ]
  },
  {
    "key": "0509",
    "label": "クローラ式杭打機（ベースマシン）",
    "items": [
      {
        "key": "011",
        "label": "直結三点支持式",
        "items": [
          {
            "key": "040-001",
            "label": "リーダ長11.5~15.5m全装備質量30~40t"
          },
          {
            "key": "055-001",
            "label": "リーダ長18~21m全装備質量50~55t"
          },
          {
            "key": "065-001",
            "label": "リーダ長18~21m全装備質量60~65t"
          },
          {
            "key": "085-001",
            "label": "リーダ長21~24m全装備質量80~85t"
          },
          {
            "key": "095-001",
            "label": "リーダ長21~30m全装備質量90~95t"
          },
          {
            "key": "110-001",
            "label": "リーダ長21~33m全装備質量100~110t"
          },
          {
            "key": "125-001",
            "label": "リーダ長21~33m全装備質量120~125t"
          },
          {
            "key": "145-001",
            "label": "リーダ長21~36m全装備質量135~145t"
          },
          {
            "key": "165-001",
            "label": "リーダ長21~39m全装備質量150~165t"
          },
          {
            "key": "180-001",
            "label": "リーダ長21~36m全装備質量170~180t"
          }
        ]
      },
      {
        "key": "031",
        "label": "多関節バックホウ・リーダレス型（軌跡制御機能付）",
        "items": [
          {
            "key": "160-001",
            "label": "適応パイプロハンマ：油圧式起振力160kN級適応アースオーガ：油圧式最大掘削トルク26kN・m級"
          },
          {
            "key": "200-001",
            "label": "適応パイプロハンマ：油圧式起振力200kN級適応アースオーガ：油圧式最大掘削トルク60kN・m級"
          }
        ]
      }
    ]
  },
  {
    "key": "0511",
    "label": "クローラ式杭打機",
    "items": [
      {
        "key": "410",
        "label": "パイプロハンマ及びアースオーガ併用・直結三点支持式",
        "items": [
          {
            "key": "226-001",
            "label": "パイプロ出力22kWオーガ径Φ320~600mm/出力30kWリーダ長18~21m"
          },
          {
            "key": "306-001",
            "label": "パイプロ出力30kWオーガ径Φ320~600mm/出力30kWリーダ長18~21m"
          },
          {
            "key": "456-001",
            "label": "パイプロ出力45kWオーガ径Φ320~600mm/出力30kWリーダ長18~21m"
          },
          {
            "key": "606-001",
            "label": "パイプロ出力60kWオーガ径Φ320~600mm/出力30kWリーダ長18~21m"
          }
        ]
      },
      {
        "key": "510",
        "label": "モンケン及びアースオーガ併用・直結三点支持式",
        "items": [
          {
            "key": "206-001",
            "label": "モンケン質量2tオーガ径Φ320~600mm/出力30kWリーダ長11.5~15.5m"
          },
          {
            "key": "208-001",
            "label": "モンケン質量2tオーガ径Φ350~800mm/出力45kWリーダ長18~21m"
          }
        ]
      },
      {
        "key": "610",
        "label": "油圧ハンマ・直結三点支持式",
        "items": [
          {
            "key": "020-001",
            "label": "ラム質量2tリーダ長11.5~15.5m吊能力35~40t"
          },
          {
            "key": "045-001",
            "label": "ラム質量4~4.5tリーダ長18~21m吊能力35~40t"
          },
          {
            "key": "080-001",
            "label": "ラム質量6.5~8tリーダ長21~24m吊能力35~40t"
          },
          {
            "key": "125-001",
            "label": "ラム質量10~12.5tリーダ長21~33m吊能力35~40t"
          }
        ]
      },
      {
        "key": "620",
        "label": "直/斜杭打ち兼用油圧ハンマ・直結三点支持式",
        "items": [
          {
            "key": "115-001",
            "label": "ラム質量11.5~12.5tリーダ長21~33m吊能力60~65t"
          },
          {
            "key": "150-001",
            "label": "ラム質量15tリーダ長21~36m吊能力80t"
          }
        ]
      },
      {
        "key": "710",
        "label": "鋼管ソイルセメント杭打機",
        "items": [
          {
            "key": "110-001",
            "label": "杭径900~1500mm最大施工深度70mオーガ出力110~150kW"
          }
        ]
      },
      {
        "key": "810",
        "label": "鋼管回転圧入機",
        "items": [
          {
            "key": "009-001",
            "label": "全装備質量6~9t掘削トルク43.7kN・m（4.5t・m）最大適合管長6m"
          },
          {
            "key": "016-001",
            "label": "全装備質量11~16t掘削トルク67.9kN・m（6.9t・m）最大適合管長6m"
          },
          {
            "key": "030-001",
            "label": "全装備質量25~30t掘削トルク274kN・m（28.1t・m）最大適合管長10m"
          },
          {
            "key": "055-001",
            "label": "全装備質量50~55t掘削トルク548kN・m（4.5t・m）最大適合管長10m"
          }
        ]
      },
      {
        "key": "011",
        "label": "ディーゼルハンマ・直結三点支持式",
        "items": [
          {
            "key": "350-001",
            "label": "ラム質量3.5tリーダ長18~21m吊能力35~40t"
          }
        ]
      },
      {
        "key": "031",
        "label": "ディーゼルハンマ・ブーム式",
        "items": [
          {
            "key": "130-001",
            "label": "ラム質量1.3tリーダ長18m吊能力16t"
          },
          {
            "key": "250-001",
            "label": "ラム質量2.5tリーダ長19m吊能力25t"
          }
        ]
      },
      {
        "key": "041",
        "label": "ディーゼルハンマ及びアースオーガ併用・直結三点支持式",
        "items": [
          {
            "key": "136-001",
            "label": "ラム質量1.3tオーガ径Φ320~600mm/出力30kWリーダ長18~21m"
          },
          {
            "key": "138-001",
            "label": "ラム質量1.3tオーガ径Φ320~800mm/出力45kWリーダ長18~21m"
          }
        ]
      }
    ]
  },
  {
    "key": "0512",
    "label": "クローラ式アースオーガ",
    "items": [
      {
        "key": "111",
        "label": "単軸式・直結三点支持式",
        "items": [
          {
            "key": "045-001",
            "label": "オーガ出力45kW掘削径Φ350~800mmリーダ長18~21m"
          },
          {
            "key": "055-001",
            "label": "オーガ出力55kW掘削径Φ450~1000mmリーダ長18~21m"
          },
          {
            "key": "075-001",
            "label": "オーガ出力75kW掘削径Φ450~1000mmリーダ長21~30m"
          },
          {
            "key": "090-001",
            "label": "オーガ出力90kW掘削径Φ450~1200mmリーダ長21~33m"
          },
          {
            "key": "110-001",
            "label": "オーガ出力110kW掘削径Φ450~1200mmリーダ長21~33m"
          },
          {
            "key": "150-001",
            "label": "オーガ出力150kW掘削径Φ600~1200mmリーダ長21~36m"
          },
          {
            "key": "180-001",
            "label": "オーガ出力180kW掘削径Φ600~1800mmリーダ長21~36m"
          }
        ]
      },
      {
        "key": "115",
        "label": "単軸（油圧）式・直結三点支持式",
        "items": [
          {
            "key": "035-001",
            "label": "掘削トルク29~35kN・m掘削径Φ260~600mmリーダ長18~21m"
          }
        ]
      },
      {
        "key": "121",
        "label": "二軸同軸式・直結三点支持式",
        "items": [
          {
            "key": "055-001",
            "label": "オーガ出力55kWリーダ長21~30m掘削径Φ320~600mm"
          },
          {
            "key": "090-001",
            "label": "オーガ出力90kWリーダ長21~33m掘削径Φ400~800mm"
          },
          {
            "key": "110-001",
            "label": "オーガ出力110kWリーダ長21~33m掘削径Φ800~1200mm"
          },
          {
            "key": "150-001",
            "label": "オーガ出力150kWリーダ長21~36m掘削径Φ800~1200mm"
          }
        ]
      },
      {
        "key": "310",
        "label": "三軸式・直結三点支持式",
        "items": [
          {
            "key": "090-001",
            "label": "オーガ出力90kW掘削径Φ500~600mm吊能力50~55tリーダ長21~33m"
          },
          {
            "key": "110-001",
            "label": "オーガ出力110kW掘削径Φ500~600mm吊能力60~65tリーダ長21~33m"
          },
          {
            "key": "150-001",
            "label": "オーガ出力150kW掘削径Φ650~850mm吊能力60~65tリーダ長21~36m"
          },
          {
            "key": "180-001",
            "label": "オーガ出力180kW掘削径Φ800~900mm吊能力80tリーダ長21~36m"
          }
        ]
      },
      {
        "key": "410",
        "label": "アースオーガ中掘機・直結三点支持式",
        "items": [
          {
            "key": "045-001",
            "label": "オーガ出力45kW公称杭径Φ400~1000mmリーダ長21~24m"
          },
          {
            "key": "055-001",
            "label": "オーガ出力55kW公称杭径Φ400~1200mmリーダ長21~33m"
          },
          {
            "key": "090-001",
            "label": "オーガ出力90kW公称杭径Φ400~1200mmリーダ長21~33m"
          },
          {
            "key": "110-001",
            "label": "オーガ出力110kW公称杭径Φ600~1200mmリーダ長21~36m"
          }
        ]
      },
      {
        "key": "510",
        "label": "アースオーガ併用圧入杭打機",
        "items": [
          {
            "key": "045-001",
            "label": "オーガ出力45kW適応鋼矢板Ⅱ~Ⅴ型リーダ長21~24m"
          },
          {
            "key": "046-001",
            "label": "オーガ出力45kW適応鋼矢板Ⅱ~Ⅴ型リーダ長21~30m"
          },
          {
            "key": "055-001",
            "label": "オーガ出力55kW適応鋼矢板Ⅱ~Ⅴ型リーダ長21~33m"
          },
          {
            "key": "090-001",
            "label": "オーガ出力90kW適応鋼矢板Ⅱ~Ⅴ型リーダ長21~33m"
          }
        ]
      },
      {
        "key": "540",
        "label": "アースオーガ（油圧式）併用圧入杭打機",
        "items": [
          {
            "key": "021-001",
            "label": "掘削トルク21kN・mリーダ長11.5~15.5m"
          },
          {
            "key": "034-001",
            "label": "掘削トルク34kN・mリーダ長18~21m"
          }
        ]
      }
    ]
  },
  {
    "key": "0513",
    "label": "アースドリル",
    "items": [
      {
        "key": "100",
        "label": "クローラ型",
        "items": [
          {
            "key": "150-002",
            "label": "最大掘削径Φ1500mm最大掘削長35~43"
          },
          {
            "key": "170-002",
            "label": "最大掘削径Φ1700mm最大掘削長43~65"
          },
          {
            "key": "200-002",
            "label": "最大掘削径Φ2000mm最大掘削長41~58"
          },
          {
            "key": "220-002",
            "label": "最大掘削径Φ2200mm最大掘削長54~63"
          },
          {
            "key": "300-002",
            "label": "最大掘削径Φ3000mm最大掘削長60~71"
          }
        ]
      }
    ]
  },
  {
    "key": "0515",
    "label": "ラフテレーンクレーン装着式アースオーガ",
    "items": [
      {
        "key": "012",
        "label": "アースオーガ（油圧式）及びモンケン架装",
        "items": [
          {
            "key": "160-001",
            "label": "ベースマシン16t吊　オーガトルク22kN・m　リーダ長16.4m　モンケン質量1.2t"
          },
          {
            "key": "250-001",
            "label": "ベースマシン25t吊　オーガトルク35kN・m　リーダ長17.5m　モンケン質量2.0t"
          },
          {
            "key": "350-001",
            "label": "ベースマシン35t吊　オーガトルク43kN・m　リーダ長22.0m　モンケン質量2.0t"
          },
          {
            "key": "500-001",
            "label": "ベースマシン50t吊　オーガトルク60kN・m　リーダ長27.5m　モンケン質量2.0t"
          }
        ]
      },
      {
        "key": "024",
        "label": "アースオーガ併用油圧圧入式",
        "items": [
          {
            "key": "166-001",
            "label": "ベースマシン16t吊　オーガ径Φ600mm　リーダ長16.2m　圧入力196kN"
          },
          {
            "key": "206-001",
            "label": "ベースマシン20t吊　オーガ径Φ600mm　リーダ長16.2m　圧入力196kN"
          },
          {
            "key": "207-001",
            "label": "ベースマシン20t吊　オーガ径Φ700mm　リーダ長17.5m　圧入力274kN"
          },
          {
            "key": "257-001",
            "label": "ベースマシン25t吊　オーガ径Φ700mm　リーダ長17.5m　圧入力274kN"
          },
          {
            "key": "258-001",
            "label": "ベースマシン25t吊　オーガ径Φ750mm　リーダ長17.5m　圧入力274kN"
          },
          {
            "key": "358-001",
            "label": "ベースマシン35t吊　オーガ径Φ750mm　リーダ長17.5m　圧入力274kN"
          },
          {
            "key": "508-001",
            "label": "ベースマシン50t吊　オーガ径Φ800mm　リーダ長22.0m　圧入力274kN"
          },
          {
            "key": "508-002",
            "label": "ベースマシン50t吊　オーガ径Φ800mm　リーダ長26.0m　圧入力274kN"
          }
        ]
      }
    ]
  },
  {
    "key": "0522",
    "label": "油圧式杭圧入引抜機",
    "items": [
      {
        "key": "022",
        "label": "エンジン式ユニット・排出ガス対策型（第1次基準値）",
        "items": [
          {
            "key": "030-001",
            "label": "[軽量鋼矢板用]圧入/引抜力294/392kN"
          },
          {
            "key": "080-001",
            "label": "[軽量鋼矢板用]圧入/引抜力736~882/785~980kN"
          },
          {
            "key": "150-001",
            "label": "[軽量鋼矢板用]圧入/引抜力981~1471/1079~1569kN"
          },
          {
            "key": "152-001",
            "label": "[広幅鋼矢板用]圧入/引抜力981~1471/1079~1569kN"
          }
        ]
      },
      {
        "key": "024",
        "label": "エンジン式ユニット・排出ガス対策型（第3次基準値）",
        "items": [
          {
            "key": "080-001",
            "label": "圧入/引抜力800/900kN"
          },
          {
            "key": "100-001",
            "label": "圧入/引抜力1000/1100kN"
          },
          {
            "key": "101-001",
            "label": "[ハット形鋼矢板900mm用]圧入/引抜力1000/1100kN"
          },
          {
            "key": "102-001",
            "label": "[広幅鋼矢板用]圧入/引抜力1000/1100kN"
          }
        ]
      },
      {
        "key": "026",
        "label": "エンジン式ユニット・排出ガス対策型（2014年規制）",
        "items": [
          {
            "key": "152-001",
            "label": "[広幅鋼矢板用]圧入/引抜力1500/1600kN"
          }
        ]
      },
      {
        "key": "033",
        "label": "エンジン式ユニット（硬質地盤専用）・排出ガス対策型（第2次基準値）",
        "items": [
          {
            "key": "082-001",
            "label": "[広幅鋼矢板用]圧入/引抜力800/900kN"
          }
        ]
      },
      {
        "key": "034",
        "label": "エンジン式ユニット（硬質地盤専用）・排出ガス対策型（第3次基準値）",
        "items": [
          {
            "key": "080-001",
            "label": "[普通鋼矢板用]圧入/引抜力800/900kN"
          },
          {
            "key": "082-001",
            "label": "[広幅鋼矢板用]圧入/引抜力800/1000kN"
          }
        ]
      },
      {
        "key": "036",
        "label": "エンジン式ユニット（硬質地盤専用）・排出ガス対策型（2014年規制）",
        "items": [
          {
            "key": "101-001",
            "label": "[ハット形鋼矢板900mm用]圧入/引抜力1000/1200kN"
          }
        ]
      }
    ]
  },
  {
    "key": "0532",
    "label": "全回転型オールケーシング掘削機",
    "items": [
      {
        "key": "110",
        "label": "ケーシングドライバ（クローラ式・ディーゼル/油圧駆動）",
        "items": [
          {
            "key": "150-001",
            "label": "最大掘削径Φ1500mm"
          },
          {
            "key": "200-001",
            "label": "最大掘削径Φ2000mm"
          }
        ]
      },
      {
        "key": "150",
        "label": "ケーシングドライバ（スキッド式・ディーゼル/油圧駆動）",
        "items": [
          {
            "key": "150-001",
            "label": "最大掘削径Φ1500mm"
          },
          {
            "key": "200-001",
            "label": "最大掘削径Φ2000mm"
          },
          {
            "key": "260-001",
            "label": "最大掘削径Φ2600mm"
          },
          {
            "key": "300-001",
            "label": "最大掘削径Φ3000mm"
          }
        ]
      },
      {
        "key": "200",
        "label": "ケーシングドライバ（スキッド式・ディーゼル/油圧駆動・回転杭用）・排出ガス対策型（第3次基準値）",
        "items": [
          {
            "key": "200-001",
            "label": "最大掘削径Φ2000mm"
          }
        ]
      }
    ]
  },
  {
    "key": "0551",
    "label": "地下連続壁施工機",
    "items": [
      {
        "key": "110",
        "label": "回転水平多軸・クローラクレーン装着式",
        "items": [
          {
            "key": "150-100",
            "label": "壁厚630~1500mm　掘削長100m　カッタトルク×台数4t・m×2台"
          },
          {
            "key": "150-150",
            "label": "壁厚650~1500mm　掘削長150m　カッタトルク×台数8t・m×2台"
          },
          {
            "key": "240-150",
            "label": "壁厚1200~2400mm　掘削長150m　カッタトルク×台数5t・m×2台"
          },
          {
            "key": "320-150",
            "label": "壁厚1500~3200mm　掘削長150m　カッタトルク×台数13.5t・m×2台"
          }
        ]
      },
      {
        "key": "120",
        "label": "回転水平多軸（輸入）・クローラクレーン装着式",
        "items": [
          {
            "key": "280-150",
            "label": "壁厚640~2800mm　掘削長150m　カッタトルク×台数8t・m×2台"
          }
        ]
      },
      {
        "key": "010",
        "label": "クローラクレーン（地下連続壁施工機用）",
        "items": [
          {
            "key": "100-001",
            "label": "吊上能力100t"
          },
          {
            "key": "150-001",
            "label": "吊上能力150t"
          }
        ]
      }
    ]
  },
  {
    "key": "0561",
    "label": "深層混合処理機（スラリー式）",
    "items": [
      {
        "key": "100",
        "label": "単軸式",
        "items": [
          {
            "key": "045-161",
            "label": "モータ出力45kW×1　杭径Φ1000~1600mm　最大施工深度10m"
          },
          {
            "key": "110-162",
            "label": "モータ出力90~110kW×1　杭径Φ1000~1600mm　最大施工深度20m"
          },
          {
            "key": "110-163",
            "label": "モータ出力90~110kW×1　杭径Φ1000~1600mm　最大施工深度30m"
          },
          {
            "key": "180-203",
            "label": "モータ出力90kW×2　杭径Φ1800~2000mm　最大施工深度27m"
          }
        ]
      },
      {
        "key": "200",
        "label": "二軸式",
        "items": [
          {
            "key": "090-101",
            "label": "モータ出力45kW×2　杭径Φ1000mm　最大施工深度10m"
          },
          {
            "key": "120-102",
            "label": "モータ出力55~60kW×2　杭径Φ1000mm　最大施工深度20m"
          },
          {
            "key": "180-103",
            "label": "モータ出力75~90kW×2　杭径Φ1000mm　最大施工深度30m"
          },
          {
            "key": "180-104",
            "label": "モータ出力90kW×2　杭径Φ1000mm　最大施工深度40m"
          },
          {
            "key": "180-105",
            "label": "モータ出力90kW×2　杭径Φ1000mm　最大施工深度45m"
          },
          {
            "key": "180-121",
            "label": "モータ出力75~90kW×2　杭径Φ1200mm　最大施工深度10m"
          },
          {
            "key": "180-122",
            "label": "モータ出力90kW×2　杭径Φ1200mm　最大施工深度20m"
          },
          {
            "key": "180-131",
            "label": "モータ出力90kW×2　杭径Φ1300mm　最大施工深度10m"
          },
          {
            "key": "220-123",
            "label": "モータ出力90~110kW×2　杭径Φ1200mm　最大施工深度30m"
          },
          {
            "key": "220-124",
            "label": "モータ出力90~110kW×2　杭径Φ1200mm　最大施工深度40m"
          },
          {
            "key": "230-132",
            "label": "モータ出力90~110kW×2　杭径Φ1300mm　最大施工深度20m"
          },
          {
            "key": "220-133",
            "label": "モータ出力90~110kW×2　杭径Φ1300mm　最大施工深度30m"
          }
        ]
      },
      {
        "key": "300",
        "label": "二軸式・変異低減型",
        "items": [
          {
            "key": "180-161",
            "label": "モータ出力90kW×2　杭径Φ1600mm　最大施工深度10m"
          },
          {
            "key": "180-162",
            "label": "モータ出力90kW×2　杭径Φ1600mm　最大施工深度20m"
          },
          {
            "key": "180-163",
            "label": "モータ出力90kW×2　杭径Φ1600mm　最大施工深度26m"
          },
          {
            "key": "180-164",
            "label": "モータ出力90kW×2　杭径Φ1600mm　最大施工深度36m"
          }
        ]
      },
      {
        "key": "500",
        "label": "単軸式・小型地盤改良機",
        "items": [
          {
            "key": "009-001",
            "label": "全装備質量6~9t　掘削トルク11.2kN・m　改良径Φ600~800mm"
          },
          {
            "key": "011-001",
            "label": "全装備質量11t　掘削トルク22.2kN・m　改良径Φ800~1000mm"
          },
          {
            "key": "013-001",
            "label": "全装備質量13t　掘削トルク27.4kN・m　改良径Φ800~1300mm"
          },
          {
            "key": "015-001",
            "label": "全装備質量17.6t　掘削トルク39.0kN・m　改良径Φ1000~1300mm"
          },
          {
            "key": "030-001",
            "label": "全装備質量25~30t　掘削トルク71.1kN・m　改良径Φ1200~1400mm"
          }
        ]
      }
    ]
  },
  {
    "key": "0563",
    "label": "粉体噴射攪拌機",
    "items": [
      {
        "key": "120",
        "label": "単軸（油圧）・スキッド式",
        "items": [
          {
            "key": "075-001",
            "label": "攪拌モータ（トルク×台数）19.6kN・m×1台　最大改良深度20m"
          }
        ]
      },
      {
        "key": "250",
        "label": "二軸（電動）・クローラ式",
        "items": [
          {
            "key": "055-001",
            "label": "攪拌モータ（出力×台数）55kW×2台　最大改良深度26m"
          },
          {
            "key": "090-001",
            "label": "攪拌モータ（出力×台数）90kW×2台　最大改良深度33m"
          },
          {
            "key": "110-001",
            "label": "攪拌モータ（出力×台数）110kW×2台　最大改良深度33m"
          }
        ]
      },
      {
        "key": "255",
        "label": "二軸（電動・軸間拡大）・クローラ式",
        "items": [
          {
            "key": "090-001",
            "label": "攪拌モータ（出力×台数）90kW×2台　最大改良深度20m"
          },
          {
            "key": "110-001",
            "label": "攪拌モータ（出力×台数）110kW×2台　最大改良深度33m"
          }
        ]
      }
    ]
  },
  {
    "key": "0564",
    "label": "クローラ式サンドパイル打機",
    "items": [
      {
        "key": "110",
        "label": "バイブロ式",
        "items": [
          {
            "key": "083-001",
            "label": "バイブロ出力75kW　リーダ長30m　クレーン能力35~37t"
          },
          {
            "key": "123-001",
            "label": "バイブロ出力120kW　リーダ長30m　クレーン能力40t"
          },
          {
            "key": "124-001",
            "label": "バイブロ出力120kW　リーダ長45m　クレーン能力40t"
          },
          {
            "key": "153-001",
            "label": "バイブロ出力150kW　リーダ長35m　クレーン能力70t"
          },
          {
            "key": "185-001",
            "label": "バイブロ出力180kW　リーダ長55m　クレーン能力150t"
          }
        ]
      },
      {
        "key": "210",
        "label": "袋詰式・サンドドレーン用",
        "items": [
          {
            "key": "006-001",
            "label": "[標準クローラ]バイブロ出力60kW　リーダ長30m　クレーン能力35~37t"
          },
          {
            "key": "007-001",
            "label": "[湿地クローラ]バイブロ出力60kW　リーダ長30m　クレーン能力35~37t"
          },
          {
            "key": "009-001",
            "label": "[湿地クローラ]バイブロ出力60~90kW　リーダ長35~40m　クレーン能力40~60t"
          }
        ]
      }
    ]
  },
  {
    "key": "0565",
    "label": "ペーパードレーン打機",
    "items": [
      {
        "key": "017",
        "label": "湿地型",
        "items": [
          {
            "key": "030-001",
            "label": "打設長~30m"
          },
          {
            "key": "040-001",
            "label": "打設長30~40m"
          }
        ]
      }
    ]
  },
  {
    "key": "0593",
    "label": "汚泥吸排車",
    "items": [
      {
        "key": "012",
        "label": "トラック架装型",
        "items": [
          {
            "key": "035-001",
            "label": "積載質量3.1~3.5t　吸入管径Φ75mm"
          },
          {
            "key": "055-001",
            "label": "積載質量5.5t　吸入管径Φ75mm"
          },
          {
            "key": "080-001",
            "label": "積載質量8.0t　吸入管径Φ75mm"
          },
          {
            "key": "095-001",
            "label": "積載質量9.5t　吸入管径Φ75mm"
          }
        ]
      }
    ]
  },
  {
    "key": "06",
    "label": "ボーリングマシンクローラドリル大型ブレーカ（ベースマシン含む）ドリルジャンボバックホウ（トンネル専用機）クローラローダ（トンネル専用機）ホイールローダ（トンネル専用機）ズリ積込・運搬機ダンプトラック（トンネル工事用）トラック（トンネル工事用）コンクリート吹付機支保工建込エレクタ",
    "group": "せん孔機械及びトンネル工事用機械"
  },
  {
    "key": "0601",
    "label": "ボーリングマシン",
    "items": [
      {
        "key": "11",
        "label": "油圧式",
        "items": [
          {
            "key": "022-001",
            "label": "2.2kW級"
          },
          {
            "key": "037-001",
            "label": "3.7kW級"
          },
          {
            "key": "055-001",
            "label": "5.5kW級"
          },
          {
            "key": "075-001",
            "label": "7.5kW級"
          },
          {
            "key": "110-001",
            "label": "11kW級"
          },
          {
            "key": "150-001",
            "label": "15kW級"
          }
        ]
      },
      {
        "key": "210",
        "label": "ロータリパーカッション式・スキッド型",
        "items": [
          {
            "key": "550-001",
            "label": "55kW級"
          }
        ]
      },
      {
        "key": "250",
        "label": "ロータリパーカッション式・クローラ型",
        "items": [
          {
            "key": "015-001",
            "label": "15kW級"
          },
          {
            "key": "081-001",
            "label": "81kW級"
          }
        ]
      }
    ]
  },
  {
    "key": "0605",
    "label": "クローラドリル",
    "items": [
      {
        "key": "031",
        "label": "油圧式",
        "items": [
          {
            "key": "100-001",
            "label": "[搭乗式]ドリフタ質量100kg級"
          },
          {
            "key": "150-001",
            "label": "[搭乗式]ドリフタ質量150kg級"
          },
          {
            "key": "180-001",
            "label": "[搭乗式]ドリフタ質量180kg級"
          },
          {
            "key": "220-001",
            "label": "[搭乗式]ドリフタ質量220kg級"
          },
          {
            "key": "250-001",
            "label": "[搭乗式]ドリフタ質量250kg級"
          }
        ]
      }
    ]
  },
  {
    "key": "0610",
    "label": "大型ブレーカ（ベースマシン含む）",
    "items": [
      {
        "key": "072",
        "label": "排出ガス対策型（第1次基準値）",
        "items": [
          {
            "key": "220-001",
            "label": "ブレーカー　油圧式2000kg級　ベースマシン30t級"
          },
          {
            "key": "230-001",
            "label": "ブレーカー　油圧式3000kg級　ベースマシン30t級"
          },
          {
            "key": "240-001",
            "label": "ブレーカー　油圧式4000kg級　ベースマシン46t級"
          }
        ]
      },
      {
        "key": "074",
        "label": "排出ガス対策型（第3次基準値）",
        "items": [
          {
            "key": "208-001",
            "label": "ブレーカー　油圧式600~800kg級　ベースマシン12t級"
          },
          {
            "key": "213-001",
            "label": "ブレーカー　油圧式1300kg級　ベースマシン20t級"
          }
        ]
      }
    ]
  },
  {
    "key": "0611",
    "label": "ドリルジャンボ",
    "items": [
      {
        "key": "011",
        "label": "レール式",
        "items": [
          {
            "key": "210-001",
            "label": "形式　2ブーム　ドリフタ質量100kg級"
          }
        ]
      },
      {
        "key": "032",
        "label": "ホイール式・排出ガス対策型（第1次基準値）",
        "items": [
          {
            "key": "210-001",
            "label": "形式　2ブーム・1バスケット　ドリフタ質量100kg級"
          },
          {
            "key": "215-001",
            "label": "形式　2ブーム・1バスケット　ドリフタ質量150kg級"
          },
          {
            "key": "215-002",
            "label": "形式　2ブーム・2バスケット　ドリフタ質量150kg級"
          },
          {
            "key": "315-002",
            "label": "形式　3ブーム・2バスケット　ドリフタ質量150kg級"
          },
          {
            "key": "317-002",
            "label": "形式　3ブーム・2バスケット　ドリフタ質量170kg超級"
          }
        ]
      },
      {
        "key": "033",
        "label": "ホイール式・排出ガス対策型（第2次基準値）",
        "items": [
          {
            "key": "217-002",
            "label": "形式　2ブーム・2バスケット　ドリフタ質量170kg超級"
          }
        ]
      },
      {
        "key": "034",
        "label": "ホイール式・排出ガス対策型（第3次基準値）",
        "items": [
          {
            "key": "217-001",
            "label": "形式　2ブーム・1バスケット　ドリフタ質量170kg超級"
          },
          {
            "key": "217-002",
            "label": "形式　2ブーム・2バスケット　ドリフタ質量170kg超級"
          },
          {
            "key": "317-002",
            "label": "形式　3ブーム・2バスケット　ドリフタ質量170kg超級"
          }
        ]
      }
    ]
  },
  {
    "key": "0613",
    "label": "バックホウ（トンネル専用機）",
    "items": [
      {
        "key": "022",
        "label": "標準型・排出ガス対策型（第1次基準値）",
        "items": [
          {
            "key": "020-001",
            "label": "標準パケット容量（山積/平積）0.28/0.2㎥"
          },
          {
            "key": "035-001",
            "label": "標準パケット容量（山積/平積）0.45/0.35㎥"
          }
        ]
      },
      {
        "key": "023",
        "label": "標準型・排出ガス対策型（第2次基準値）",
        "items": [
          {
            "key": "040-001",
            "label": "標準パケット容量（山積/平積）0.5/0.4㎥"
          },
          {
            "key": "060-001",
            "label": "標準パケット容量（山積/平積）0.8/0.6㎥"
          }
        ]
      },
      {
        "key": "034",
        "label": "後方小旋回型・排出ガス対策型（第3次基準値）",
        "items": [
          {
            "key": "060-001",
            "label": "標準パケット容量（山積/平積）0.8/0.6㎥"
          }
        ]
      },
      {
        "key": "044",
        "label": "後方超小旋回型・排出ガス対策型（第3次基準値）",
        "items": [
          {
            "key": "020-001",
            "label": "標準パケット容量（山積/平積）0.28/0.2㎥"
          },
          {
            "key": "035-001",
            "label": "標準パケット容量（山積/平積）0.45/0.35㎥"
          },
          {
            "key": "040-001",
            "label": "標準パケット容量（山積/平積）0.5/0.4㎥"
          },
          {
            "key": "060-001",
            "label": "標準パケット容量（山積/平積）0.8/0.6㎥"
          },
          {
            "key": "085-001",
            "label": "標準パケット容量（山積/平積）1.2/0.85㎥"
          }
        ]
      }
    ]
  },
  {
    "key": "0615",
    "label": "クローラローダ（トンネル専用機）",
    "items": [
      {
        "key": "042",
        "label": "サイドダンプ式・排出ガス対策型（第1次基準値）",
        "items": [
          {
            "key": "160-001",
            "label": "パケット容量（山積）1.5~1.6㎥"
          }
        ]
      }
    ]
  },
  {
    "key": "0616",
    "label": "ホイールローダ（トンネル専用機）",
    "items": [
      {
        "key": "053",
        "label": "サイドダンプ式・排出ガス対策型（第2次基準値）",
        "items": [
          {
            "key": "190-001",
            "label": "パケット容量（山積）1.9㎥"
          },
          {
            "key": "230-001",
            "label": "パケット容量（山積）2.3㎥"
          }
        ]
      },
      {
        "key": "054",
        "label": "サイドダンプ式・排出ガス対策型（第3次基準値）",
        "items": [
          {
            "key": "250-001",
            "label": "パケット容量（山積）2.5㎥"
          },
          {
            "key": "300-001",
            "label": "パケット容量（山積）3.0㎥"
          }
        ]
      }
    ]
  },
  {
    "key": "0618",
    "label": "ズリ積込・運搬機",
    "items": [
      {
        "key": "071",
        "label": "ロードホウルダンプ",
        "items": [
          {
            "key": "170-001",
            "label": "パケット容量（山積）1.7㎥"
          },
          {
            "key": "200-001",
            "label": "パケット容量（山積）2.0㎥"
          },
          {
            "key": "300-001",
            "label": "パケット容量（山積）3.0㎥"
          },
          {
            "key": "380-001",
            "label": "パケット容量（山積）3.8㎥"
          }
        ]
      }
    ]
  },
  {
    "key": "0619",
    "label": "ダンプトラック（トンネル工事用）",
    "items": [
      {
        "key": "063",
        "label": "オフロード・排出ガス対策型（第2次基準値）",
        "items": [
          {
            "key": "250-001",
            "label": "23~25t積"
          },
          {
            "key": "270-001",
            "label": "27t積"
          }
        ]
      },
      {
        "key": "064",
        "label": "オフロード・排出ガス対策型（第3次基準値）",
        "items": [
          {
            "key": "100-001",
            "label": "10t積"
          },
          {
            "key": "160-001",
            "label": "16t積"
          },
          {
            "key": "200-001",
            "label": "20t積"
          }
        ]
      },
      {
        "key": "065",
        "label": "オフロード・排出ガス対策型（2011年規制）",
        "items": [
          {
            "key": "300-001",
            "label": "30t積"
          }
        ]
      },
      {
        "key": "072",
        "label": "コンテナ着脱式・排出ガス対策型（第1次基準値）",
        "items": [
          {
            "key": "250-001",
            "label": "積載質量25t　コンテナ容量（山積）15㎥"
          }
        ]
      }
    ]
  },
  {
    "key": "0620",
    "label": "トラック（トンネル工事用）",
    "items": [
      {
        "key": "012",
        "label": "普通型",
        "items": [
          {
            "key": "020-001",
            "label": "2t積"
          }
        ]
      },
      {
        "key": "022",
        "label": "クレーン装置付",
        "items": [
          {
            "key": "043-001",
            "label": "ベーストラック4t積級　吊能力2.9t"
          }
        ]
      }
    ]
  },
  {
    "key": "0625",
    "label": "コンクリート吹付機",
    "items": [
      {
        "key": "072",
        "label": "湿式吹付・R一体・C搭載・排出ガス対策型（第1次基準値）",
        "items": [
          {
            "key": "220-001",
            "label": "吐出量8~22㎥/h級　吹付半径7m級"
          }
        ]
      },
      {
        "key": "073",
        "label": "湿式吹付・R一体・C搭載・排出ガス対策型（第2次基準値）",
        "items": [
          {
            "key": "220-001",
            "label": "吐出量6~22㎥/h級　吹付半径7m級"
          }
        ]
      },
      {
        "key": "082",
        "label": "湿式吹付・R一体・エレクタ型・排出ガス対策型（第1次基準値）",
        "items": [
          {
            "key": "220-001",
            "label": "吐出量6~22㎥/h級　吹付半径7m級"
          }
        ]
      },
      {
        "key": "094",
        "label": "湿式吹付・R一体・C搭載・エレクタ型・排出ガス対策型（第3次基準値）",
        "items": [
          {
            "key": "220-001",
            "label": "吐出量6~22㎥/h級　吹付半径7m級"
          }
        ]
      }
    ]
  },
  {
    "key": "0626",
    "label": "支保工建込エレクタ",
    "items": [
      {
        "key": "011",
        "label": "クローラ式",
        "items": [
          {
            "key": "010-001",
            "label": "1.0t×2ブーム"
          }
        ]
      },
      {
        "key": "021",
        "label": "ホイール式",
        "items": [
          {
            "key": "010-001",
            "label": "1.0t×2ブーム"
          }
        ]
      }
    ]
  },
  {
    "key": "07",
    "label": "モータグレーダスタビライザ",
    "group": "モータグレーダ及び路盤用機械"
  },
  {
    "key": "0701",
    "label": "モータグレーダ",
    "items": [
      {
        "key": "012",
        "label": "土工用・排出ガス対策型（第1次基準値）",
        "items": [
          {
            "key": "400-001",
            "label": "ブレード幅4.0m"
          }
        ]
      },
      {
        "key": "014",
        "label": "土工用・排出ガス対策型（第3次基準値）",
        "items": [
          {
            "key": "310-001",
            "label": "ブレード幅3.1m"
          },
          {
            "key": "340-001",
            "label": "ブレード幅3.4m"
          },
          {
            "key": "370-001",
            "label": "ブレード幅3.7m"
          }
        ]
      },
      {
        "key": "016",
        "label": "土工用・排出ガス対策型（2014規制型）",
        "items": [
          {
            "key": "430-001",
            "label": "ブレード幅3.7~4.3m"
          }
        ]
      }
    ]
  },
  {
    "key": "0702",
    "label": "スタビライザ",
    "items": [
      {
        "key": "012",
        "label": "路床改良用",
        "items": [
          {
            "key": "312-001",
            "label": "処理深さ×幅0.3×1.2m"
          },
          {
            "key": "616-001",
            "label": "処理深さ×幅0.6×1.6m"
          },
          {
            "key": "620-001",
            "label": "処理深さ×幅0.6×2.0m"
          },
          {
            "key": "720-001",
            "label": "処理深さ×幅0.7×2.0m"
          },
          {
            "key": "920-001",
            "label": "処理深さ×幅1.2×2.0m"
          }
        ]
      },
      {
        "key": "013",
        "label": "路床改良用・排出ガス対策型（第2次基準値）",
        "items": [
          {
            "key": "620-001",
            "label": "処理深さ×幅0.6×2.0m"
          },
          {
            "key": "920-001",
            "label": "処理深さ×幅1.2×2.0m"
          }
        ]
      },
      {
        "key": "022",
        "label": "路盤再生用",
        "items": [
          {
            "key": "416-001",
            "label": "処理深さ×幅0.4×1.6m"
          },
          {
            "key": "420-001",
            "label": "処理深さ×幅0.4×2.0m"
          }
        ]
      },
      {
        "key": "032",
        "label": "路床改良用・トレンチャ型",
        "items": [
          {
            "key": "120-001",
            "label": "処理深さ×幅1.0×2.0m"
          }
        ]
      }
    ]
  },
  {
    "key": "08",
    "label": "ロードローラタイヤローラ振動ローラ（舗装用）振動ローラ（土工用）タンパ及びランマ振動コンパクタ",
    "group": "締固め機械"
  },
  {
    "key": "0810",
    "label": "ロードローラ",
    "items": [
      {
        "key": "021",
        "label": "マカダム",
        "items": [
          {
            "key": "014-001",
            "label": "運転質量13~14t　締固め幅2.1m"
          }
        ]
      },
      {
        "key": "022",
        "label": "マカダム・排出ガス対策型（第1次基準値）",
        "items": [
          {
            "key": "012-001",
            "label": "運転質量10~12t　締固め幅2.1m"
          }
        ]
      },
      {
        "key": "024",
        "label": "マカダム・排出ガス対策型（第3次基準値）",
        "items": [
          {
            "key": "010-001",
            "label": "運転質量10t　締固め幅2.1m"
          }
        ]
      },
      {
        "key": "041",
        "label": "振動マカダム",
        "items": [
          {
            "key": "010-001",
            "label": "運転質量8~9t　"
          }
        ]
      }
    ]
  },
  {
    "key": "0820",
    "label": "タイヤローラ",
    "items": [
      {
        "key": "021",
        "label": "普通型",
        "items": [
          {
            "key": "030-001",
            "label": "運転質量21~30t　"
          }
        ]
      },
      {
        "key": "024",
        "label": "普通型・排出ガス対策型（第3次基準値）",
        "items": [
          {
            "key": "004-001",
            "label": "運転質量3~4t　"
          },
          {
            "key": "020-001",
            "label": "運転質量8~20t　"
          }
        ]
      },
      {
        "key": "025",
        "label": "普通型・排出ガス対策型（2011年規制）",
        "items": [
          {
            "key": "013-001",
            "label": "運転質量13t　"
          }
        ]
      },
      {
        "key": "073",
        "label": "振動タイヤローラ・排出ガス対策型（第2次基準値）",
        "items": [
          {
            "key": "009-001",
            "label": "運転質量9t　"
          }
        ]
      }
    ]
  },
  {
    "key": "0841",
    "label": "振動ローラ（舗装用）",
    "items": [
      {
        "key": "100",
        "label": "ハンドガイド式",
        "items": [
          {
            "key": "006-001",
            "label": "運転質量0.5~0.6t　"
          },
          {
            "key": "011-001",
            "label": "運転質量0.8~1.1t　"
          }
        ]
      },
      {
        "key": "211",
        "label": "搭乗・タンデム式",
        "items": [
          {
            "key": "180-001",
            "label": "運転質量15~18t　"
          }
        ]
      },
      {
        "key": "214",
        "label": "搭乗・タンデム式・排出ガス対策型（第3次基準値）",
        "items": [
          {
            "key": "015-001",
            "label": "運転質量1.2~1.5t　"
          },
          {
            "key": "028-001",
            "label": "運転質量2.4~2.8t　"
          },
          {
            "key": "050-001",
            "label": "運転質量3~5t　"
          },
          {
            "key": "075-001",
            "label": "運転質量6~7.5t　"
          },
          {
            "key": "100-001",
            "label": "運転質量8~10t　"
          },
          {
            "key": "120-001",
            "label": "運転質量11~12t　"
          }
        ]
      },
      {
        "key": "234",
        "label": "搭乗・タンデム・水平振動式・排出ガス対策型（第3次基準値）",
        "items": [
          {
            "key": "070-001",
            "label": "運転質量7t　"
          }
        ]
      },
      {
        "key": "254",
        "label": "搭載・タンデム・水平振動式・ラバーロール・排出ガス対策型（第3次基準値）",
        "items": [
          {
            "key": "075-001",
            "label": "運転質量7.4t"
          }
        ]
      },
      {
        "key": "314",
        "label": "搭乗・コンバインド式・排出ガス対策型（第3次基準値）",
        "items": [
          {
            "key": "015-001",
            "label": "運転質量1.2~1.5t　"
          },
          {
            "key": "026-001",
            "label": "運転質量2.4~2.6t　"
          },
          {
            "key": "040-001",
            "label": "運転質量3~4t　"
          },
          {
            "key": "070-001",
            "label": "運転質量5~7t　"
          },
          {
            "key": "100-001",
            "label": "運転質量8~10t　"
          },
          {
            "key": "120-001",
            "label": "運転質量11~12t　"
          }
        ]
      }
    ]
  },
  {
    "key": "0845",
    "label": "振動ローラ（土工用）",
    "items": [
      {
        "key": "214",
        "label": "フラット・シングルドラム型・排出ガス対策型（第3次基準値）",
        "items": [
          {
            "key": "120-001",
            "label": "運転質量11~12t　"
          },
          {
            "key": "180-001",
            "label": "運転質量15~18t　"
          },
          {
            "key": "200-001",
            "label": "運転質量19~20t　"
          }
        ]
      },
      {
        "key": "314",
        "label": "タンピング・シングルドラム型・排出ガス対策型（第3次基準値）",
        "items": [
          {
            "key": "120-001",
            "label": "運転質量11~12t　"
          },
          {
            "key": "180-001",
            "label": "運転質量15~18t　"
          },
          {
            "key": "200-001",
            "label": "運転質量19~20t　"
          }
        ]
      },
      {
        "key": "513",
        "label": "フラット・シングルドラム型・垂直振動型・排出ガス対策型（第2次基準値）",
        "items": [
          {
            "key": "200-001",
            "label": "運転質量19~20t　"
          }
        ]
      },
      {
        "key": "613",
        "label": "タンピング・シングルドラム型・垂直振動型・排出ガス対策型（第2次基準値）",
        "items": [
          {
            "key": "200-001",
            "label": "運転質量19~20t　"
          }
        ]
      }
    ]
  },
  {
    "key": "0861",
    "label": "タンパ及びランマ",
    "items": [
      {
        "key": "017",
        "label": "ランマ",
        "items": [
          {
            "key": "080-001",
            "label": "質量60~80kg"
          }
        ]
      },
      {
        "key": "027",
        "label": "エアタンパ",
        "items": [
          {
            "key": "018-001",
            "label": "質量18kg級　エア消費量1.1㎥/min"
          }
        ]
      }
    ]
  },
  {
    "key": "0870",
    "label": "振動コンパクタ",
    "items": [
      {
        "key": "100",
        "label": "前進型",
        "items": [
          {
            "key": "060-001",
            "label": "機械質量40~60kg"
          },
          {
            "key": "080-001",
            "label": "機械質量70~80kg"
          },
          {
            "key": "090-001",
            "label": "機械質量90kg"
          }
        ]
      },
      {
        "key": "210",
        "label": "前後進方（ガソリンエンジン駆動）",
        "items": [
          {
            "key": "060-001",
            "label": "機械質量60kg"
          },
          {
            "key": "110-001",
            "label": "機械質量110kg"
          }
        ]
      },
      {
        "key": "220",
        "label": "前後進方（ディーゼルエンジン駆動）",
        "items": [
          {
            "key": "160-001",
            "label": "機械質量160kg"
          },
          {
            "key": "200-001",
            "label": "機械質量200kg"
          },
          {
            "key": "330-001",
            "label": "機械質量330kg"
          },
          {
            "key": "440-001",
            "label": "機械質量440kg"
          }
        ]
      }
    ]
  },
  {
    "key": "09",
    "label": "アジテータトラック（トラックミキサ）コンクリートポンプ車",
    "group": "コンクリート機械"
  },
  {
    "key": "0921",
    "label": "アジテータトラック（トラックミキサ）",
    "items": [
      {
        "key": "012",
        "label": "トラック架装型",
        "items": [
          {
            "key": "008-001",
            "label": "混合容量0.8~0.9㎥"
          },
          {
            "key": "016-001",
            "label": "混合容量1.6~1.7㎥"
          },
          {
            "key": "032-001",
            "label": "混合容量3.0~3.2㎥"
          },
          {
            "key": "044-001",
            "label": "混合容量4.4㎥"
          }
        ]
      }
    ]
  },
  {
    "key": "0951",
    "label": "コンクリートポンプ車",
    "items": [
      {
        "key": "012",
        "label": "トラック架装・配管式",
        "items": [
          {
            "key": "045-001",
            "label": "圧送能力40~45㎥/h"
          },
          {
            "key": "055-001",
            "label": "圧送能力55㎥/h"
          },
          {
            "key": "070-001",
            "label": "圧送能力70㎥/h"
          },
          {
            "key": "100-001",
            "label": "圧送能力90~100㎥/h"
          }
        ]
      },
      {
        "key": "022",
        "label": "トラック架装・ブーム式",
        "items": [
          {
            "key": "020-001",
            "label": "圧送能力20㎥/h"
          },
          {
            "key": "030-001",
            "label": "圧送能力30㎥/h"
          },
          {
            "key": "045-001",
            "label": "圧送能力40~45㎥/h"
          },
          {
            "key": "060-001",
            "label": "圧送能力55~60㎥/h"
          },
          {
            "key": "085-001",
            "label": "圧送能力65~85㎥/h"
          },
          {
            "key": "110-001",
            "label": "圧送能力90~110㎥/h"
          },
          {
            "key": "125-001",
            "label": "圧送能力115~125㎥/h"
          }
        ]
      }
    ]
  },
  {
    "key": "10",
    "label": "アスファルトフィニッシャディストリビュータチップスプレッダアスファルトクッカコンクリートスプレッダコンクリートフィニッシャコンクリートレベラコンクリート簡易仕上機コンクリート横取機振動目地切機インナバイブレータアスファルトスプレヤアスファルトカーバ",
    "group": "舗装機械"
  },
  {
    "key": "1003",
    "label": "アスファルトフィニッシャ",
    "items": [
      {
        "key": "011",
        "label": "クローラ型",
        "items": [
          {
            "key": "030-001",
            "label": "舗装幅1.4~3.0m"
          }
        ]
      },
      {
        "key": "012",
        "label": "クローラ型・排出ガス対策型（第1次基準値）",
        "items": [
          {
            "key": "120-001",
            "label": "舗装幅3.0~12.0m"
          }
        ]
      },
      {
        "key": "013",
        "label": "クローラ型・排出ガス対策型（第2次基準値）",
        "items": [
          {
            "key": "025-001",
            "label": "舗装幅1.4~2.5m"
          },
          {
            "key": "031-001",
            "label": "舗装幅1.7~3.1m"
          },
          {
            "key": "080-001",
            "label": "舗装幅2.5~8.0m"
          },
          {
            "key": "120-001",
            "label": "舗装幅3.0~12.0m"
          }
        ]
      },
      {
        "key": "014",
        "label": "クローラ型・排出ガス対策型（第3次基準値）",
        "items": [
          {
            "key": "014-001",
            "label": "舗装幅0.8~1.4m"
          },
          {
            "key": "030-001",
            "label": "舗装幅1.4~3.0m"
          },
          {
            "key": "031-001",
            "label": "舗装幅1.7~3.1m"
          },
          {
            "key": "045-001",
            "label": "舗装幅2.0~4.5m"
          },
          {
            "key": "060-001",
            "label": "舗装幅2.4~6.0m"
          }
        ]
      },
      {
        "key": "023",
        "label": "ホイール型・排出ガス対策型（第2次基準値）",
        "items": [
          {
            "key": "030-001",
            "label": "舗装幅1.4~3.0m"
          },
          {
            "key": "085-001",
            "label": "舗装幅3.0~8.5m"
          }
        ]
      },
      {
        "key": "024",
        "label": "ホイール型・排出ガス対策型（第3次基準値）",
        "items": [
          {
            "key": "030-001",
            "label": "舗装幅1.4~3.0m"
          },
          {
            "key": "031-001",
            "label": "舗装幅1.7~3.1m"
          },
          {
            "key": "045-001",
            "label": "舗装幅2.0~4.5m"
          },
          {
            "key": "060-001",
            "label": "舗装幅2.4~6.0m"
          }
        ]
      },
      {
        "key": "025",
        "label": "ホイール型・排出ガス対策型（2011年規制）",
        "items": [
          {
            "key": "045-001",
            "label": "舗装幅2.0~5.0m"
          },
          {
            "key": "060-001",
            "label": "舗装幅2.3~6.0m"
          }
        ]
      },
      {
        "key": "026",
        "label": "ホイール型・排出ガス対策型（2014年規制）",
        "items": [
          {
            "key": "032-001",
            "label": "舗装幅1.4~3.2m"
          },
          {
            "key": "080-001",
            "label": "舗装幅2.5~8.0m"
          }
        ]
      },
      {
        "key": "031",
        "label": "乳剤散布装置付アスファルトフィニッシャ",
        "items": [
          {
            "key": "060-001",
            "label": "舗装幅2.5~6.0m"
          }
        ]
      },
      {
        "key": "044",
        "label": "グースアスファルトフィニッシャ・排出ガス対策型（第3次基準値）",
        "items": [
          {
            "key": "045-001",
            "label": "舗装幅2.4~4.5m"
          }
        ]
      },
      {
        "key": "051",
        "label": "グースアスファルトフィニッシャ（歩道用）",
        "items": [
          {
            "key": "017-001",
            "label": "舗装幅1.7m"
          }
        ]
      },
      {
        "key": "061",
        "label": "二層式同時敷均アスファルトフィニッシャ（歩道用）",
        "items": [
          {
            "key": "050-001",
            "label": "舗装幅2.5~5.2m"
          },
          {
            "key": "060-001",
            "label": "舗装幅2.5~6.0m"
          }
        ]
      }
    ]
  },
  {
    "key": "1005",
    "label": "ディストリビュータ",
    "items": [
      {
        "key": "022",
        "label": "自走式（トラック架装式）",
        "items": [
          {
            "key": "150-001",
            "label": "タンク容量1000~1500ℓ"
          },
          {
            "key": "300-001",
            "label": "タンク容量2000~3000ℓ"
          },
          {
            "key": "400-001",
            "label": "タンク容量4000ℓ"
          },
          {
            "key": "600-001",
            "label": "タンク容量6000ℓ"
          }
        ]
      }
    ]
  },
  {
    "key": "1006",
    "label": "チップスプレッダ",
    "items": [
      {
        "key": "017",
        "label": "ハンガ敷",
        "items": [
          {
            "key": "050-001",
            "label": "ホッパ容量0.4㎥　散布幅2.0~5.0m"
          }
        ]
      },
      {
        "key": "027",
        "label": "テールゲート式",
        "items": [
          {
            "key": "022-001",
            "label": "ホッパ容量0.25㎥　散布幅1.6~2.2m"
          }
        ]
      }
    ]
  },
  {
    "key": "1007",
    "label": "アスファルトクッカ",
    "items": [
      {
        "key": "100",
        "label": "トラック架装・バーナ加熱式",
        "items": [
          {
            "key": "400-001",
            "label": "容量3.0~4.0㎥"
          }
        ]
      },
      {
        "key": "200",
        "label": "トラック架装・電気加熱式",
        "items": [
          {
            "key": "400-001",
            "label": "容量3.0~4.0㎥"
          }
        ]
      }
    ]
  },
  {
    "key": "1008",
    "label": "コンクリートスプレッダ",
    "items": [
      {
        "key": "100",
        "label": "ブレード式",
        "items": [
          {
            "key": "075-001",
            "label": "舗装幅3.0~7.5m"
          },
          {
            "key": "085-001",
            "label": "舗装幅5.0~8.5m"
          }
        ]
      },
      {
        "key": "150",
        "label": "勾配可変型・ブレード敷",
        "items": [
          {
            "key": "085-001",
            "label": "舗装幅5.0~8.5m"
          }
        ]
      },
      {
        "key": "300",
        "label": "ボックス式",
        "items": [
          {
            "key": "075-001",
            "label": "舗装幅3.0~7.5mボックス容量4.0㎥"
          },
          {
            "key": "085-001",
            "label": "舗装幅5.0~8.5mボックス容量4.0㎥"
          }
        ]
      }
    ]
  },
  {
    "key": "1009",
    "label": "コンクリートフィニッシャ",
    "items": [
      {
        "key": "015",
        "label": "勾配固定型",
        "items": [
          {
            "key": "075-001",
            "label": "舗装幅3.0~7.5m"
          },
          {
            "key": "085-001",
            "label": "舗装幅5.0~8.5m"
          }
        ]
      },
      {
        "key": "025",
        "label": "勾配可変型",
        "items": [
          {
            "key": "085-001",
            "label": "舗装幅5.0~8.5m"
          }
        ]
      }
    ]
  },
  {
    "key": "1010",
    "label": "コンクリートレベラ",
    "items": [
      {
        "key": "015",
        "label": "勾配固定型",
        "items": [
          {
            "key": "075-001",
            "label": "舗装幅3.0~7.5m"
          },
          {
            "key": "085-001",
            "label": "舗装幅5.0~8.5m"
          }
        ]
      },
      {
        "key": "025",
        "label": "勾配可変型",
        "items": [
          {
            "key": "085-001",
            "label": "舗装幅5.0~8.5m"
          }
        ]
      }
    ]
  },
  {
    "key": "1013",
    "label": "コンクリート簡易仕上機",
    "items": [
      {
        "key": "015",
        "label": "エンジン駆動式",
        "items": [
          {
            "key": "050-001",
            "label": "舗装幅3.5~5.0m"
          }
        ]
      }
    ]
  },
  {
    "key": "1014",
    "label": "コンクリート横取機",
    "items": [
      {
        "key": "011",
        "label": "ホイール型",
        "items": [
          {
            "key": "350-001",
            "label": "最大供給能力350㎥/h"
          }
        ]
      }
    ]
  },
  {
    "key": "1015",
    "label": "振動目地切機",
    "items": [
      {
        "key": "015",
        "label": "舗装用",
        "items": [
          {
            "key": "085-001",
            "label": "施工幅3.5~8.5m"
          }
        ]
      }
    ]
  },
  {
    "key": "1018",
    "label": "インナバイブレータ",
    "items": [
      {
        "key": "015",
        "label": "自走式",
        "items": [
          {
            "key": "085-001",
            "label": "施工幅3.5~8.5m"
          }
        ]
      }
    ]
  },
  {
    "key": "1019",
    "label": "アスファルトスプレヤ",
    "items": [
      {
        "key": "017",
        "label": "ガソリンエンジン駆動・手押し式",
        "items": [
          {
            "key": "015-001",
            "label": "散布能力15ℓ/min"
          },
          {
            "key": "025-001",
            "label": "散布能力25ℓ/min"
          }
        ]
      },
      {
        "key": "027",
        "label": "ガソリンエンジン駆動・車載式",
        "items": [
          {
            "key": "015-001",
            "label": "散布能力15ℓ/min"
          },
          {
            "key": "025-001",
            "label": "散布能力25ℓ/min"
          }
        ]
      }
    ]
  },
  {
    "key": "1020",
    "label": "アスファルトカーバ",
    "items": [
      {
        "key": "017",
        "label": "ガソリンエンジン駆動式",
        "items": [
          {
            "key": "450-001",
            "label": "能力4.0~4.5㎥/h"
          }
        ]
      }
    ]
  },
  {
    "key": "11",
    "label": "路面清掃車ガードレール清掃車トンネル清掃車側溝清掃車排水管清掃車散水車ラインマーカ高視認性区間線施工機区画線消去機路面切削機路上表層再生機路面ヒータ（路上表層再生用）路面安全溝切削機（グルーピング機械）ガードレール支柱打込機床版上面増厚機マイクロサーフェスマシン排水性舗装機能回復機コンクリートカッタ",
    "group": "道路維持用機械"
  },
  {
    "key": "1101",
    "label": "路面清掃車",
    "items": [
      {
        "key": "012",
        "label": "ブラシ・三輪式",
        "items": [
          {
            "key": "020-001",
            "label": "ホッパ容量2.2㎥"
          }
        ]
      },
      {
        "key": "014",
        "label": "ブラシ・四輪式",
        "items": [
          {
            "key": "015-001",
            "label": "ホッパ容量1.5㎥"
          },
          {
            "key": "020-001",
            "label": "ホッパ容量2.5~3.1㎥"
          }
        ]
      },
      {
        "key": "015",
        "label": "ブラシ・四輪式・路面切削工事用",
        "items": [
          {
            "key": "015-001",
            "label": "ホッパ容量1.5㎥"
          },
          {
            "key": "025-001",
            "label": "ホッパ容量2.5㎥"
          }
        ]
      },
      {
        "key": "023",
        "label": "真空・リヤダンプ式",
        "items": [
          {
            "key": "032-001",
            "label": "ホッパ容量3.2㎥"
          },
          {
            "key": "045-001",
            "label": "ホッパ容量4.5㎥"
          },
          {
            "key": "055-001",
            "label": "ホッパ容量5.5~6.5㎥"
          },
          {
            "key": "080-001",
            "label": "ホッパ容量8.0㎥"
          }
        ]
      },
      {
        "key": "024",
        "label": "真空・リヤリフト式",
        "items": [
          {
            "key": "035-001",
            "label": "ホッパ容量3.5㎥"
          },
          {
            "key": "055-001",
            "label": "ホッパ容量5.5~6.1㎥"
          }
        ]
      },
      {
        "key": "026",
        "label": "真空還流・リヤリフト式",
        "items": [
          {
            "key": "061-001",
            "label": "ホッパ容量6.1㎥"
          }
        ]
      }
    ]
  },
  {
    "key": "1103",
    "label": "ガードレール清掃車",
    "items": [
      {
        "key": "210",
        "label": "トラック架装・両ブラシ式",
        "items": [
          {
            "key": "001-001",
            "label": "-"
          }
        ]
      },
      {
        "key": "250",
        "label": "トラック架装・両ブラシ式・自動追従型・CNG型",
        "items": [
          {
            "key": "001-001",
            "label": "-"
          }
        ]
      }
    ]
  },
  {
    "key": "1104",
    "label": "トンネル清掃車",
    "items": [
      {
        "key": "250",
        "label": "トラック架装・2本ブラシ式・自動追従型",
        "items": [
          {
            "key": "001-001",
            "label": "-"
          }
        ]
      }
    ]
  },
  {
    "key": "1105",
    "label": "側溝清掃車",
    "items": [
      {
        "key": "017",
        "label": "ブロワ式",
        "items": [
          {
            "key": "030-020",
            "label": "ホッパ容量3.0㎥　風量20㎥/min"
          },
          {
            "key": "030-040",
            "label": "ホッパ容量2.8㎥　風量40㎥/min"
          },
          {
            "key": "045-040",
            "label": "ホッパ容量4.5~5.0㎥　風量40㎥/min"
          },
          {
            "key": "050-040",
            "label": "ホッパ容量5.1㎥　風量40㎥/min"
          },
          {
            "key": "090-040",
            "label": "ホッパ容量9.0㎥　風量40㎥/min"
          },
          {
            "key": "100-040",
            "label": "ホッパ容量10.3㎥　風量40㎥/min"
          }
        ]
      }
    ]
  },
  {
    "key": "1106",
    "label": "排水管清掃車",
    "items": [
      {
        "key": "017",
        "label": "高圧水洗浄式",
        "items": [
          {
            "key": "020-014",
            "label": "タンク容量2.0㎥　圧力14MPa"
          },
          {
            "key": "022-054",
            "label": "タンク容量2.2㎥　圧力54MPa"
          },
          {
            "key": "028-020",
            "label": "タンク容量2.8㎥　圧力20MPa"
          },
          {
            "key": "053-012",
            "label": "[ジェット式]タンク容量5.3~5.8㎥　圧力12MPa"
          }
        ]
      }
    ]
  },
  {
    "key": "1108",
    "label": "散水車",
    "items": [
      {
        "key": "012",
        "label": "トラック架装型",
        "items": [
          {
            "key": "018-001",
            "label": "タンク容量1800ℓ"
          },
          {
            "key": "038-001",
            "label": "タンク容量3800ℓ"
          },
          {
            "key": "065-001",
            "label": "タンク容量5500~6500ℓ"
          },
          {
            "key": "080-001",
            "label": "タンク容量7500~8500ℓ"
          },
          {
            "key": "100-001",
            "label": "タンク容量10000ℓ"
          }
        ]
      }
    ]
  },
  {
    "key": "1121",
    "label": "ラインマーカ",
    "items": [
      {
        "key": "150",
        "label": "溶融・車載式",
        "items": [
          {
            "key": "030-001",
            "label": "ライン幅15・20・30cm　ホッパ容量800kg"
          }
        ]
      },
      {
        "key": "510",
        "label": "ペイント・ハンドガイド式",
        "items": [
          {
            "key": "020-001",
            "label": "ライン幅15・20cm　吐出量1.3ℓ/min"
          }
        ]
      },
      {
        "key": "550",
        "label": "ペイント・車載式",
        "items": [
          {
            "key": "045-001",
            "label": "ライン幅15・20・30・40cm　吐出量8.0ℓ/min"
          }
        ]
      }
    ]
  },
  {
    "key": "1123",
    "label": "高視認性区間線施工機",
    "items": [
      {
        "key": "100",
        "label": "溶融式",
        "items": [
          {
            "key": "022-001",
            "label": "-"
          }
        ]
      },
      {
        "key": "200",
        "label": "二液反応式",
        "items": [
          {
            "key": "300-001",
            "label": "-"
          }
        ]
      }
    ]
  },
  {
    "key": "1126",
    "label": "区画線消去機",
    "items": [
      {
        "key": "017",
        "label": "ハンドガイド式",
        "items": [
          {
            "key": "010-001",
            "label": "-"
          }
        ]
      }
    ]
  },
  {
    "key": "1131",
    "label": "路面切削機",
    "items": [
      {
        "key": "151",
        "label": "ホイール式・廃材積込装置機",
        "items": [
          {
            "key": "120-001",
            "label": "切削幅×深さ　0.35m×10cm"
          }
        ]
      },
      {
        "key": "153",
        "label": "ホイール式・廃材積込装置機・排出ガス対策型（第2次基準値）",
        "items": [
          {
            "key": "035-001",
            "label": "切削幅×深さ　0.5m×20cm"
          },
          {
            "key": "050-001",
            "label": "切削幅×深さ　1.0m×10cm"
          },
          {
            "key": "100-001",
            "label": "切削幅×深さ　1.2m×15cm"
          }
        ]
      },
      {
        "key": "154",
        "label": "ホイール式・廃材積込装置機・排出ガス対策型（第3次基準値）",
        "items": [
          {
            "key": "202-001",
            "label": "切削幅×深さ　2.0m×23cm"
          }
        ]
      },
      {
        "key": "251",
        "label": "クローラ式・廃材積込装置機",
        "items": [
          {
            "key": "100-001",
            "label": "切削幅×深さ　1.0m×32cm"
          },
          {
            "key": "120-001",
            "label": "切削幅×深さ　1.2m×32cm"
          },
          {
            "key": "200-001",
            "label": "切削幅×深さ　2.0m×32cm"
          },
          {
            "key": "210-001",
            "label": "切削幅×深さ　2.1m×32cm"
          }
        ]
      }
    ]
  },
  {
    "key": "1133",
    "label": "路上表層再生機",
    "items": [
      {
        "key": "011",
        "label": "リミックス用",
        "items": [
          {
            "key": "405-001",
            "label": "施工幅×かきおこし深さ2.3~4.0×5.0cm"
          },
          {
            "key": "410-001",
            "label": "施工幅×かきおこし深さ2.5~4.0×9.5cm"
          }
        ]
      },
      {
        "key": "021",
        "label": "リペーブ用",
        "items": [
          {
            "key": "405-001",
            "label": "施工幅×かきおこし深さ2.3~4.0×5.0cm"
          }
        ]
      }
    ]
  },
  {
    "key": "1134",
    "label": "路面ヒータ（路上表層再生用）",
    "items": [
      {
        "key": "012",
        "label": "間接加熱式",
        "items": [
          {
            "key": "034-001",
            "label": "加熱面積13㎥　発熱量335万kJ/h"
          },
          {
            "key": "060-001",
            "label": "加熱面積20~23㎥　発熱量502~586万kJ/h"
          },
          {
            "key": "100-001",
            "label": "加熱面積38~40㎥　発熱量879~1047万kJ/h"
          }
        ]
      },
      {
        "key": "022",
        "label": "熱風循環式",
        "items": [
          {
            "key": "060-001",
            "label": "加熱面積20~22㎥　発熱量500~600万kJ/h"
          }
        ]
      }
    ]
  },
  {
    "key": "1141",
    "label": "路面安全溝切削機（グルーピング機械）",
    "items": [
      {
        "key": "012",
        "label": "湿式",
        "items": [
          {
            "key": "020-001",
            "label": "施工幅200mm"
          },
          {
            "key": "075-001",
            "label": "施工幅750mm"
          },
          {
            "key": "090-001",
            "label": "施工幅900mm"
          }
        ]
      },
      {
        "key": "022",
        "label": "乾式",
        "items": [
          {
            "key": "060-001",
            "label": "施工幅600mm"
          },
          {
            "key": "080-001",
            "label": "施工幅800mm"
          }
        ]
      }
    ]
  },
  {
    "key": "1144",
    "label": "ガードレール支柱打込機",
    "items": [
      {
        "key": "012",
        "label": "モンケン式",
        "items": [
          {
            "key": "600-001",
            "label": "モンケン質量400~600kg"
          }
        ]
      },
      {
        "key": "013",
        "label": "エアブレーカ式",
        "items": [
          {
            "key": "070-001",
            "label": "ブレーカ質量700kg級　打撃周波数530bpm"
          },
          {
            "key": "080-001",
            "label": "ブレーカ質量800kg級　打撃周波数500"
          }
        ]
      }
    ]
  },
  {
    "key": "1151",
    "label": "床版上面増厚機",
    "items": [
      {
        "key": "015",
        "label": "オンレール式",
        "items": [
          {
            "key": "055-001",
            "label": "施工幅3.0~5.5m"
          }
        ]
      },
      {
        "key": "025",
        "label": "オフレール式",
        "items": [
          {
            "key": "036-001",
            "label": "施工幅2.5~3.6m"
          }
        ]
      }
    ]
  },
  {
    "key": "1153",
    "label": "マイクロサーフェスマシン",
    "items": [
      {
        "key": "012",
        "label": "自走式",
        "items": [
          {
            "key": "090-001",
            "label": "積載質量9.0t"
          }
        ]
      }
    ]
  },
  {
    "key": "1158",
    "label": "排水性舗装機能回復機",
    "items": [
      {
        "key": "012",
        "label": "自走式",
        "items": [
          {
            "key": "021-001",
            "label": "作業幅2.0~2,1m"
          }
        ]
      }
    ]
  },
  {
    "key": "1161",
    "label": "コンクリートカッタ",
    "items": [
      {
        "key": "110",
        "label": "手動式・湿式",
        "items": [
          {
            "key": "005-001",
            "label": "切削深5cm級　ブレード径20cm"
          },
          {
            "key": "010-001",
            "label": "切削深10cm級　ブレード径30cm"
          },
          {
            "key": "015-001",
            "label": "切削深15cm級　ブレード径45cm"
          }
        ]
      },
      {
        "key": "211",
        "label": "バキューム式・湿式",
        "items": [
          {
            "key": "020-001",
            "label": "切削深20cm級　ブレード径56cm"
          }
        ]
      },
      {
        "key": "215",
        "label": "バキューム式（超低騒音型）・湿式",
        "items": [
          {
            "key": "030-001",
            "label": "切削深30cm級　ブレード径75cm"
          },
          {
            "key": "040-001",
            "label": "切削深40cm級　ブレード径96cm"
          },
          {
            "key": "050-001",
            "label": "切削深50cm級　ブレード径116cm"
          },
          {
            "key": "060-001",
            "label": "切削深60cm級　ブレード径137cm"
          },
          {
            "key": "080-001",
            "label": "切削深70~80cm級　ブレード径178cm"
          }
        ]
      },
      {
        "key": "230",
        "label": "乾式",
        "items": [
          {
            "key": "020-001",
            "label": "切削深20cm級　ブレード径44~56cm"
          }
        ]
      },
      {
        "key": "910",
        "label": "人孔外周切断機",
        "items": [
          {
            "key": "180-001",
            "label": "最大切断線直径1800mm"
          }
        ]
      }
    ]
  },
  {
    "key": "12",
    "label": "空気圧縮機",
    "group": "空気圧縮機及び送風機（原動機を含む）"
  },
  {
    "key": "1201",
    "label": "空気圧縮機",
    "items": [
      {
        "key": "031",
        "label": "可搬式・エンジン駆動・スクリュ型",
        "items": [
          {
            "key": "255-024",
            "label": "吐出量25.5㎥/min　吐出圧力2.41MPa"
          },
          {
            "key": "360-013",
            "label": "吐出量36㎥/min　吐出圧力1.27/1.03MPa"
          }
        ]
      },
      {
        "key": "032",
        "label": "可搬式・エンジン駆動・スクリュ型・排出ガス対策型（第1次基準値）",
        "items": [
          {
            "key": "014-007",
            "label": "吐出量1.4㎥/min　吐出圧力0.7MPa"
          },
          {
            "key": "020-007",
            "label": "吐出量2.0㎥/min　吐出圧力0.7MPa"
          },
          {
            "key": "025-007",
            "label": "吐出量2.5㎥/min　吐出圧力0.7MPa"
          },
          {
            "key": "142-007",
            "label": "吐出量14.2㎥/min　吐出圧力0.7MPa"
          }
        ]
      },
      {
        "key": "033",
        "label": "可搬式・エンジン駆動・スクリュ型・排出ガス対策型（第2次基準値）",
        "items": [
          {
            "key": "037-007",
            "label": "吐出量3.5~3.7㎥/min　吐出圧力0.7MPa"
          },
          {
            "key": "050-007",
            "label": "吐出量5.0㎥/min　吐出圧力0.7MPa"
          },
          {
            "key": "078-007",
            "label": "吐出量7.5~7.8㎥/min　吐出圧力0.7MPa"
          },
          {
            "key": "110-007",
            "label": "吐出量10.5~11㎥/min　吐出圧力0.7MPa"
          },
          {
            "key": "190-007",
            "label": "吐出量18~19㎥/min　吐出圧力0.7MPa"
          },
          {
            "key": "210-007",
            "label": "吐出量20~21㎥/min　吐出圧力0.7MPa"
          }
        ]
      },
      {
        "key": "042",
        "label": "可搬式・エンジン駆動・スクリュ型（超低騒音型）・排出ガス対策型（第1次基準値）",
        "items": [
          {
            "key": "075-007",
            "label": "吐出量7.5㎥/min　吐出圧力0.7MPa"
          }
        ]
      },
      {
        "key": "043",
        "label": "可搬式・エンジン駆動・スクリュ型（超低騒音型）・排出ガス対策型（第2次基準値）",
        "items": [
          {
            "key": "017-007",
            "label": "吐出量1.7㎥/min　吐出圧力0.7MPa"
          },
          {
            "key": "020-007",
            "label": "吐出量2.0㎥/min　吐出圧力0.7MPa"
          },
          {
            "key": "025-007",
            "label": "吐出量2.5㎥/min　吐出圧力0.7MPa"
          },
          {
            "key": "051-007",
            "label": "吐出量5.0~5.1㎥/min　吐出圧力0.7MPa"
          },
          {
            "key": "078-007",
            "label": "吐出量7.5~7.8㎥/min　吐出圧力0.7MPa"
          },
          {
            "key": "110-007",
            "label": "吐出量10.5~11㎥/min　吐出圧力0.7MPa"
          },
          {
            "key": "150-010",
            "label": "吐出量15.0㎥/min　吐出圧力0.7MPa"
          },
          {
            "key": "170-007",
            "label": "吐出量17.0㎥/min　吐出圧力0.7MPa"
          },
          {
            "key": "194-007",
            "label": "吐出量19.4㎥/min　吐出圧力0.7MPa"
          },
          {
            "key": "227-007",
            "label": "吐出量22.7㎥/min　吐出圧力0.7MPa"
          }
        ]
      },
      {
        "key": "044",
        "label": "可搬式・エンジン駆動・スクリュ型（超低騒音型）・排出ガス対策型（第3次基準値）",
        "items": [
          {
            "key": "017-007",
            "label": "吐出量1.6~1.7㎥/min　吐出圧力0.7MPa"
          },
          {
            "key": "021-007",
            "label": "吐出量2.0~2.1㎥/min　吐出圧力0.7MPa"
          },
          {
            "key": "028-007",
            "label": "吐出量2.5~2.8㎥/min　吐出圧力0.7MPa"
          },
          {
            "key": "037-007",
            "label": "吐出量3.5~3.7㎥/min　吐出圧力0.7MPa"
          },
          {
            "key": "050-007",
            "label": "吐出量5.0㎥/min　吐出圧力0.7MPa"
          },
          {
            "key": "122-007",
            "label": "吐出量12.2㎥/min　吐出圧力0.7MPa"
          },
          {
            "key": "255-007",
            "label": "吐出量25.5㎥/min　吐出圧力0.7MPa"
          }
        ]
      }
    ]
  },
  {
    "key": "13",
    "label": "小型渦巻ポンプ",
    "group": "建設用ポンプ（原動機を含む）"
  },
  {
    "key": "1301",
    "label": "小型渦巻ポンプ",
    "items": [
      {
        "key": "037",
        "label": "可搬・自吸・エンジン駆動型",
        "items": [
          {
            "key": "040-030",
            "label": "口径Φ40mm全揚程30m"
          },
          {
            "key": "050-030",
            "label": "口径Φ50mm全揚程30m"
          },
          {
            "key": "080-030",
            "label": "口径Φ80mm全揚程30m"
          }
        ]
      }
    ]
  },
  {
    "key": "15",
    "label": "発動発電機",
    "group": "電気機器"
  },
  {
    "key": "1510",
    "label": "発動発電機",
    "items": [
      {
        "key": "017",
        "label": "ガソリンエンジン駆動",
        "items": [
          {
            "key": "001-001",
            "label": "定格容量1kVA"
          },
          {
            "key": "002-001",
            "label": "定格容量2kVA"
          },
          {
            "key": "003-001",
            "label": "定格容量3kVA"
          },
          {
            "key": "005-001",
            "label": "定格容量5kVA"
          }
        ]
      },
      {
        "key": "021",
        "label": "ディーゼルエンジン",
        "items": [
          {
            "key": "001-003",
            "label": "定格容量（50/60Hz）2.7/3kVA"
          },
          {
            "key": "001-005",
            "label": "定格容量（50/60Hz）4.5/5kVA"
          },
          {
            "key": "010-060",
            "label": "定格容量（50/60Hz）550/600kVA"
          },
          {
            "key": "010-080",
            "label": "定格容量（50/60Hz）700/800kVA"
          },
          {
            "key": "010-110",
            "label": "定格容量（50/60Hz）1000/1100kVA"
          }
        ]
      },
      {
        "key": "022",
        "label": "ディーゼルエンジン駆動・排出ガス対策型（第1次基準値）",
        "items": [
          {
            "key": "001-015",
            "label": "定格容量（50/60Hz）13/15kVA"
          },
          {
            "key": "001-020",
            "label": "定格容量（50/60Hz）17/20kVA"
          },
          {
            "key": "001-025",
            "label": "定格容量（50/60Hz）20/25kVA"
          },
          {
            "key": "001-045",
            "label": "定格容量（50/60Hz）37/45kVA"
          },
          {
            "key": "001-060",
            "label": "定格容量（50/60Hz）50/60kVA"
          },
          {
            "key": "001-075",
            "label": "定格容量（50/60Hz）65/75kVA"
          },
          {
            "key": "010-012",
            "label": "定格容量（50/60Hz）100/125kVA"
          },
          {
            "key": "010-015",
            "label": "定格容量（50/60Hz）125/150kVA"
          }
        ]
      },
      {
        "key": "023",
        "label": "ディーゼルエンジン駆動・排出ガス対策型（第2次基準値）",
        "items": [
          {
            "key": "010-050",
            "label": "定格容量（50/60Hz）450/500kVA"
          }
        ]
      },
      {
        "key": "024",
        "label": "ディーゼルエンジン駆動・排出ガス対策型（第3次基準値）",
        "items": [
          {
            "key": "010-030",
            "label": "定格容量（50/60Hz）270/300kVA"
          },
          {
            "key": "010-040",
            "label": "定格容量（50/60Hz）350/400kVA"
          }
        ]
      },
      {
        "key": "032",
        "label": "ディーゼルエンジン駆動（超低騒音型）・排出ガス対策型（第1次基準値）",
        "items": [
          {
            "key": "001-035",
            "label": "定格容量（50/60Hz）30/35kVA"
          },
          {
            "key": "001-075",
            "label": "定格容量（50/60Hz）65/75kVA"
          }
        ]
      },
      {
        "key": "034",
        "label": "ディーゼルエンジン駆動（超低騒音型）・排出ガス対策型（第3次基準値）",
        "items": [
          {
            "key": "001-010",
            "label": "定格容量（50/60Hz）10.5/13kVA"
          },
          {
            "key": "001-015",
            "label": "定格容量（50/60Hz）13/15kVA"
          },
          {
            "key": "001-020",
            "label": "定格容量（50/60Hz）17/20kVA"
          },
          {
            "key": "001-025",
            "label": "定格容量（50/60Hz）20/25kVA"
          },
          {
            "key": "001-045",
            "label": "定格容量（50/60Hz）37/45kVA"
          },
          {
            "key": "001-060",
            "label": "定格容量（50/60Hz）50/60kVA"
          },
          {
            "key": "010-010",
            "label": "定格容量（50/60Hz）80/100kVA"
          },
          {
            "key": "010-012",
            "label": "定格容量（50/60Hz）100/125kVA"
          },
          {
            "key": "010-015",
            "label": "定格容量（50/60Hz）125/150kVA"
          },
          {
            "key": "010-022",
            "label": "定格容量（50/60Hz）200/220kVA"
          }
        ]
      },
      {
        "key": "044",
        "label": "ディーゼルエンジン駆動（超低騒音型・大容量タンク型）・排出ガス対策型（第3次基準値）",
        "items": [
          {
            "key": "001-010",
            "label": "定格容量（50/60Hz）10.5/13kVA"
          },
          {
            "key": "001-025",
            "label": "定格容量（50/60Hz）20/25kVA"
          },
          {
            "key": "001-045",
            "label": "定格容量（50/60Hz）37/45kVA"
          },
          {
            "key": "001-060",
            "label": "定格容量（50/60Hz）50/60kVA"
          },
          {
            "key": "010-010",
            "label": "定格容量（50/60Hz）80/100kVA"
          },
          {
            "key": "010-012",
            "label": "定格容量（50/60Hz）100/125kVA"
          },
          {
            "key": "010-015",
            "label": "定格容量（50/60Hz）125/150kVA"
          },
          {
            "key": "010-022",
            "label": "定格容量（50/60Hz）200/220kVA"
          }
        ]
      }
    ]
  },
  {
    "key": "16",
    "label": "ウインチ",
    "group": "ウインチ類"
  },
  {
    "key": "1602",
    "label": "ウインチ",
    "items": [
      {
        "key": "152",
        "label": "開放型（エンジン駆動）・複胴",
        "items": [
          {
            "key": "150-001",
            "label": "巻上能力1.5t×42m/min　巻取容量Φ12×850m+Φ2.12×1020m"
          }
        ]
      }
    ]
  },
  {
    "key": "18",
    "label": "多軸式特殊台車",
    "group": "鋼橋・ＰＣ橋架設用仮設備機器"
  },
  {
    "key": "1818",
    "label": "多軸式特殊台車",
    "items": [
      {
        "key": "010",
        "label": "自走式",
        "items": [
          {
            "key": "165-001",
            "label": "積載能力165t"
          },
          {
            "key": "250-001",
            "label": "積載能力250t"
          }
        ]
      }
    ]
  },
  {
    "key": "20",
    "label": "バイブレータ用電源装置コンクリート吹付機コンクリート穿孔機中小型トラック（ダブルキャブ）ライトバン草刈機集草機刈草梱包機械チェンソー薬剤散布機種子吹付機トラクタ自走式破砕機自走式土質改良機自走式木材破砕機ベルトコンベヤ（ポータブル）高圧洗浄機パッカー車電気溶接機トラック式アースオーガ",
    "group": "その他の機器"
  },
  {
    "key": "2005",
    "label": "バイブレータ用電源装置",
    "items": [
      {
        "key": "100",
        "label": "高周波発電機（ガソリンエンジン式）",
        "items": [
          {
            "key": "013-001",
            "label": "定格容量1.3kVA　電圧48V　電流15.6A"
          },
          {
            "key": "020-001",
            "label": "定格容量2.0kVA　電圧48V　電流23.0A"
          },
          {
            "key": "030-001",
            "label": "定格容量3.0kVA　電圧48V　電流37.0A"
          }
        ]
      }
    ]
  },
  {
    "key": "2012",
    "label": "コンクリート吹付機",
    "items": [
      {
        "key": "017",
        "label": "湿式",
        "items": [
          {
            "key": "060-001",
            "label": "能力6㎥/h　所要空気量10㎥/min"
          }
        ]
      },
      {
        "key": "027",
        "label": "乾式",
        "items": [
          {
            "key": "040-001",
            "label": "能力4㎥/h　所要空気量10㎥/min"
          }
        ]
      }
    ]
  },
  {
    "key": "2015",
    "label": "コンクリート穿孔機",
    "items": [
      {
        "key": "012",
        "label": "油圧式コアボーリングマシン",
        "items": [
          {
            "key": "060-001",
            "label": "最大穿孔径Φ60cm級"
          }
        ]
      }
    ]
  },
  {
    "key": "2021",
    "label": "中小型トラック（ダブルキャブ）",
    "items": [
      {
        "key": "012",
        "label": "ガソリンエンジン駆動",
        "items": [
          {
            "key": "608-001",
            "label": "乗車定員6名　最大積載質量750kg"
          },
          {
            "key": "613-001",
            "label": "乗車定員6名　最大積載質量1250kg"
          },
          {
            "key": "618-001",
            "label": "乗車定員6名　最大積載質量1750kg"
          }
        ]
      },
      {
        "key": "022",
        "label": "ディーゼルエンジン駆動",
        "items": [
          {
            "key": "608-001",
            "label": "乗車定員6名　最大積載質量750kg"
          },
          {
            "key": "613-001",
            "label": "乗車定員6名　最大積載質量1250kg"
          },
          {
            "key": "618-001",
            "label": "乗車定員6名　最大積載質量1750kg"
          },
          {
            "key": "620-001",
            "label": "乗車定員6名　最大積載質量2000kg"
          }
        ]
      }
    ]
  },
  {
    "key": "2022",
    "label": "ライトバン",
    "items": [
      {
        "key": "200",
        "label": "二輪駆動",
        "items": [
          {
            "key": "015-001",
            "label": "乗車定員5名　排気量1.5ℓ"
          },
          {
            "key": "020-001",
            "label": "乗車定員5名　排気量2ℓ"
          }
        ]
      },
      {
        "key": "400",
        "label": "四輪駆動",
        "items": [
          {
            "key": "015-001",
            "label": "乗車定員5名　排気量1.5ℓ"
          }
        ]
      }
    ]
  },
  {
    "key": "2031",
    "label": "草刈機",
    "items": [
      {
        "key": "100",
        "label": "肩掛式",
        "items": [
          {
            "key": "230-001",
            "label": "カッタ径Φ230mm"
          },
          {
            "key": "255-001",
            "label": "カッタ径Φ255mm"
          }
        ]
      },
      {
        "key": "310",
        "label": "ハンドガイド式・芝用",
        "items": [
          {
            "key": "060-001",
            "label": "刈幅55~65cm"
          },
          {
            "key": "080-001",
            "label": "刈幅77cm"
          }
        ]
      },
      {
        "key": "510",
        "label": "ハンドガイド式・笹/ヨシ等用",
        "items": [
          {
            "key": "070-001",
            "label": "刈幅70cm"
          },
          {
            "key": "095-001",
            "label": "刈幅95cm"
          },
          {
            "key": "150-001",
            "label": "［簡易搭乗型］刈幅150cm"
          },
          {
            "key": "170-001",
            "label": "［簡易搭乗型］刈幅170cm"
          }
        ]
      },
      {
        "key": "535",
        "label": "遠隔操縦式",
        "items": [
          {
            "key": "120-001",
            "label": "刈幅120cm"
          },
          {
            "key": "185-001",
            "label": "刈幅185cm"
          }
        ]
      }
    ]
  },
  {
    "key": "2032",
    "label": "集草機",
    "items": [
      {
        "key": "510",
        "label": "ハンドガイド式",
        "items": [
          {
            "key": "160-001",
            "label": "集草幅160cm"
          },
          {
            "key": "200-001",
            "label": "［簡易搭乗型］200cm"
          }
        ]
      },
      {
        "key": "535",
        "label": "遠隔操縦式",
        "items": [
          {
            "key": "180-001",
            "label": "集草幅180cm"
          }
        ]
      }
    ]
  },
  {
    "key": "2033",
    "label": "刈草梱包機械",
    "items": [
      {
        "key": "530",
        "label": "ハンドガイド式",
        "items": [
          {
            "key": "100-070",
            "label": "［簡易搭乗型］ディーゼルエンジン駆動　梱包系×幅Φ50×70cm"
          },
          {
            "key": "200-070",
            "label": "［簡易搭乗型］ガソリンエンジン駆動　梱包系×幅Φ50×70cm"
          }
        ]
      }
    ]
  },
  {
    "key": "2035",
    "label": "チェンソー",
    "items": [
      {
        "key": "017",
        "label": "ガソリンエンジン",
        "items": [
          {
            "key": "035-001",
            "label": "鋸長350mm　エンジン排気量0.034ℓ"
          },
          {
            "key": "050-001",
            "label": "鋸長500mm　エンジン排気量0.06ℓ"
          },
          {
            "key": "060-001",
            "label": "鋸長600mm　エンジン排気量0.08ℓ"
          }
        ]
      }
    ]
  },
  {
    "key": "2037",
    "label": "薬剤散布機",
    "items": [
      {
        "key": "017",
        "label": "背負式",
        "items": [
          {
            "key": "015-001",
            "label": "1.5kW級"
          },
          {
            "key": "022-001",
            "label": "2.2kW級"
          }
        ]
      }
    ]
  },
  {
    "key": "2038",
    "label": "種子吹付機",
    "items": [
      {
        "key": "027",
        "label": "車載式（種子専用）",
        "items": [
          {
            "key": "100-001",
            "label": "タンク容量1.0㎥　搭載トラック1t車"
          },
          {
            "key": "200-001",
            "label": "タンク容量2.0㎥　搭載トラック2t車"
          },
          {
            "key": "250-001",
            "label": "タンク容量2.5㎥　搭載トラック3t車"
          },
          {
            "key": "300-001",
            "label": "タンク容量3.0㎥　搭載トラック4t車"
          },
          {
            "key": "400-001",
            "label": "タンク容量4.0㎥　搭載トラック4t車"
          }
        ]
      },
      {
        "key": "037",
        "label": "車載式（客土用）",
        "items": [
          {
            "key": "400-001",
            "label": "タンク容量4.0㎥　搭載トラック4t車"
          }
        ]
      },
      {
        "key": "047",
        "label": "車載式（厚層植生基材吹付用）",
        "items": [
          {
            "key": "250-001",
            "label": "タンク容量2.5+0.3㎥　搭載トラック4t車"
          },
          {
            "key": "460-001",
            "label": "タンク容量4.6+0.4㎥　搭載トラック4t車"
          },
          {
            "key": "500-001",
            "label": "タンク容量5.0+0.5㎥　搭載トラック4t車"
          }
        ]
      }
    ]
  },
  {
    "key": "2041",
    "label": "トラクタ",
    "items": [
      {
        "key": "110",
        "label": "ホイール式",
        "items": [
          {
            "key": "010-001",
            "label": "機械質量1t級"
          }
        ]
      }
    ]
  },
  {
    "key": "2051",
    "label": "自走式破砕機",
    "items": [
      {
        "key": "017",
        "label": "ジョークラッシャー",
        "items": [
          {
            "key": "010-001",
            "label": "機械質量10t級　供給口開き×幅325×600mm"
          },
          {
            "key": "020-001",
            "label": "機械質量20t級　供給口開き×幅375×750mm"
          },
          {
            "key": "030-001",
            "label": "機械質量30t級　供給口開き×幅450×925mm"
          },
          {
            "key": "050-001",
            "label": "機械質量50t級　供給口開き×幅750×1100mm"
          }
        ]
      }
    ]
  },
  {
    "key": "2052",
    "label": "自走式土質改良機",
    "items": [
      {
        "key": "017",
        "label": "解砕・固化材混合式",
        "items": [
          {
            "key": "010-001",
            "label": "機械質量10t級"
          },
          {
            "key": "020-001",
            "label": "機械質量20t級"
          },
          {
            "key": "030-001",
            "label": "機械質量30t級"
          }
        ]
      }
    ]
  },
  {
    "key": "2053",
    "label": "自走式木材破砕機",
    "items": [
      {
        "key": "017",
        "label": "タブ式",
        "items": [
          {
            "key": "150-001",
            "label": "機関出力130~150kW"
          },
          {
            "key": "270-001",
            "label": "機関出力230~270kW"
          },
          {
            "key": "300-001",
            "label": "機関出力290~300kW"
          },
          {
            "key": "400-001",
            "label": "機関出力370~440kW"
          }
        ]
      },
      {
        "key": "027",
        "label": "横入れ式",
        "items": [
          {
            "key": "100-001",
            "label": "機関出力100kW"
          },
          {
            "key": "160-001",
            "label": "機関出力130~160kW"
          },
          {
            "key": "270-001",
            "label": "機関出力230~270kW"
          },
          {
            "key": "350-001",
            "label": "機関出力330~350kW"
          },
          {
            "key": "400-001",
            "label": "機関出力370~400kW"
          }
        ]
      }
    ]
  },
  {
    "key": "2061",
    "label": "ベルトコンベヤ（ポータブル）",
    "items": [
      {
        "key": "017",
        "label": "エンジン駆動",
        "items": [
          {
            "key": "007-001",
            "label": "ベルト幅350mm　機長7m"
          }
        ]
      }
    ]
  },
  {
    "key": "2071",
    "label": "高圧洗浄機",
    "items": [
      {
        "key": "021",
        "label": "工事用・エンジン駆動",
        "items": [
          {
            "key": "070-015",
            "label": "吐出量35~70ℓ/min　圧力14.7MPa"
          }
        ]
      }
    ]
  },
  {
    "key": "2072",
    "label": "パッカー車",
    "items": [
      {
        "key": "011",
        "label": "回転式",
        "items": [
          {
            "key": "040-001",
            "label": "積載容量4㎥"
          },
          {
            "key": "080-001",
            "label": "積載容量8㎥"
          }
        ]
      }
    ]
  },
  {
    "key": "2081",
    "label": "電気溶接機",
    "items": [
      {
        "key": "510",
        "label": "ガソリンエンジン駆動・直流アーク式",
        "items": [
          {
            "key": "135-001",
            "label": "最大溶接電流135A"
          },
          {
            "key": "150-001",
            "label": "最大溶接電流150A"
          },
          {
            "key": "180-001",
            "label": "最大溶接電流180A"
          }
        ]
      },
      {
        "key": "531",
        "label": "ディーゼルエンジン駆動・直流アーク式",
        "items": [
          {
            "key": "180-001",
            "label": "最大溶接電流180A"
          },
          {
            "key": "250-001",
            "label": "最大溶接電流250A"
          },
          {
            "key": "300-001",
            "label": "最大溶接電流300A"
          }
        ]
      },
      {
        "key": "532",
        "label": "ディーゼルエンジン駆動・直流アーク式・排出ガス対策型（第1次基準値）",
        "items": [
          {
            "key": "250-001",
            "label": "最大溶接電流250A"
          },
          {
            "key": "300-001",
            "label": "最大溶接電流300A"
          },
          {
            "key": "400-001",
            "label": "最大溶接電流400A"
          },
          {
            "key": "500-001",
            "label": "最大溶接電流500A"
          }
        ]
      },
      {
        "key": "533",
        "label": "ディーゼルエンジン駆動・直流アーク式・排出ガス対策型（第2次基準値）",
        "items": [
          {
            "key": "200-001",
            "label": "最大溶接電流200A"
          },
          {
            "key": "300-001",
            "label": "最大溶接電流300A"
          },
          {
            "key": "400-001",
            "label": "最大溶接電流400A"
          },
          {
            "key": "500-001",
            "label": "最大溶接電流500A"
          }
        ]
      },
      {
        "key": "534",
        "label": "ディーゼルエンジン駆動・直流アーク式・排出ガス対策型（第3次基準値）",
        "items": [
          {
            "key": "230-001",
            "label": "最大溶接電流230A"
          },
          {
            "key": "300-001",
            "label": "最大溶接電流300A"
          }
        ]
      }
    ]
  },
  {
    "key": "2088",
    "label": "トラック式アースオーガ",
    "items": [
      {
        "key": "100",
        "label": "建柱車",
        "items": [
          {
            "key": "450-020",
            "label": "オーガΦ450mm　吊能力2.0t"
          },
          {
            "key": "450-030",
            "label": "オーガΦ450mm　吊能力2.9t"
          }
        ]
      }
    ]
  },
  {
    "key": "50",
    "label": "除雪ドーザ（ホイール型）除雪ドーザ（ホイール型）用アタッチメント除雪トラック除雪グレーダロータリ式除雪機械小型ロータリ除雪機凍結防止剤散布車凍結防止剤散布車用シャシその他除雪用機械",
    "group": "除雪用建設機械等"
  },
  {
    "key": "5020",
    "label": "除雪ドーザ（ホイール型）",
    "items": [
      {
        "key": "111",
        "label": "プラウ・バケット兼用型",
        "items": [
          {
            "key": "050",
            "label": "機械質量5t級　標準山積容量0.8㎥"
          },
          {
            "key": "060",
            "label": "機械質量6t級　標準山積容量1㎥"
          },
          {
            "key": "070",
            "label": "機械質量7t級　標準山積容量1.2㎥"
          }
        ]
      },
      {
        "key": "112",
        "label": "プラウ・バケット兼用型・排出ガス対策型（第1次基準値）",
        "items": [
          {
            "key": "130",
            "label": "機械質量13t級　標準山積容量2.4~2.6㎥"
          },
          {
            "key": "131",
            "label": "（中速型）機械質量13t級　標準山積容量1.9㎥"
          },
          {
            "key": "160",
            "label": "機械質量16t級　標準山積容量3.1~3.3㎥"
          },
          {
            "key": "080",
            "label": "機械質量8t級　標準山積容量1.3~1.4㎥"
          }
        ]
      },
      {
        "key": "113",
        "label": "プラウ・バケット兼用型・排出ガス対策型（第2次基準値）",
        "items": [
          {
            "key": "110",
            "label": "機械質量11t級　標準山積容量2.1㎥"
          },
          {
            "key": "130",
            "label": "機械質量13t級　標準山積容量2.4~2.6㎥"
          },
          {
            "key": "131",
            "label": "（中速型）機械質量13t級　標準山積容量1.9㎥"
          },
          {
            "key": "190",
            "label": "機械質量19t級　標準山積容量3.4~3.7㎥"
          },
          {
            "key": "080",
            "label": "機械質量8t級　標準山積容量1.3~1.4㎥"
          }
        ]
      },
      {
        "key": "114",
        "label": "プラウ・バケット兼用型・排出ガス対策型（第3次基準値）",
        "items": [
          {
            "key": "110",
            "label": "機械質量11t級　標準山積容量2.1㎥"
          },
          {
            "key": "130",
            "label": "機械質量13t級　標準山積容量2.4~2.6㎥"
          },
          {
            "key": "190",
            "label": "機械質量19t級　標準山積容量3.4~3.7㎥"
          },
          {
            "key": "080",
            "label": "機械質量8t級　標準山積容量1.3~1.4㎥"
          }
        ]
      },
      {
        "key": "115",
        "label": "プラウ・バケット兼用型・排出ガス対策型（2011年規制）",
        "items": [
          {
            "key": "110",
            "label": "機械質量11t級　標準山積容量2.1㎥"
          },
          {
            "key": "140",
            "label": "機械質量14t級　標準山積容量2.5~3.0㎥"
          },
          {
            "key": "180",
            "label": "機械質量18t級　標準山積容量3.3~3.7㎥"
          },
          {
            "key": "080",
            "label": "機械質量8t級　標準山積容量1.3~1.4㎥"
          }
        ]
      },
      {
        "key": "116",
        "label": "プラウ・バケット兼用型・排出ガス対策型（2014年規制）",
        "items": [
          {
            "key": "110",
            "label": "機械質量11t級　標準山積容量2.1㎥"
          },
          {
            "key": "140",
            "label": "機械質量14t級　標準山積容量2.5~3.0㎥"
          },
          {
            "key": "180",
            "label": "機械質量18t級　標準山積容量3.4~3.7㎥"
          }
        ]
      },
      {
        "key": "211",
        "label": "プラウ専用型",
        "items": [
          {
            "key": "190",
            "label": "機械質量19t級"
          }
        ]
      },
      {
        "key": "212",
        "label": "プラウ専用型・排出ガス対策型（第1次基準値）",
        "items": [
          {
            "key": "190",
            "label": "機械質量19t級"
          }
        ]
      },
      {
        "key": "213",
        "label": "プラウ専用型・排出ガス対策型（第2次基準値）",
        "items": [
          {
            "key": "190",
            "label": "機械質量19t級"
          }
        ]
      }
    ]
  },
  {
    "key": "5029",
    "label": "除雪ドーザ（ホイール型）用アタッチメント",
    "items": [
      {
        "key": "111",
        "label": "ロータリ除雪装置（2ステージ・ユニット型）",
        "items": [
          {
            "key": "120",
            "label": "機関出力90kW（120ps）級"
          },
          {
            "key": "080",
            "label": "機関出力60kW（80ps）級"
          }
        ]
      },
      {
        "key": "112",
        "label": "ロータリ除雪装置（2ステージ・ユニット型）・排出ガス対策型（第1次基準値）",
        "items": [
          {
            "key": "120",
            "label": "機関出力90kW（120ps）級"
          },
          {
            "key": "080",
            "label": "機関出力60kW（80ps）級"
          }
        ]
      },
      {
        "key": "113",
        "label": "ロータリ除雪装置（2ステージ・ユニット型）・排出ガス対策型（第2次基準値）",
        "items": [
          {
            "key": "120",
            "label": "機関出力90kW（120ps）級"
          },
          {
            "key": "080",
            "label": "機関出力60kW（80ps）級"
          }
        ]
      },
      {
        "key": "114",
        "label": "ロータリ除雪装置（2ステージ・ユニット型）・排出ガス対策型（第3次基準値）",
        "items": [
          {
            "key": "150",
            "label": "機関出力110kW（150ps）級"
          }
        ]
      }
    ]
  },
  {
    "key": "5030",
    "label": "除雪トラック",
    "items": [
      {
        "key": "100",
        "label": "ダンプ架装型",
        "items": [
          {
            "key": "100",
            "label": "積載質量10t級　駆動方式6×4"
          },
          {
            "key": "102",
            "label": "積載質量10t級　駆動方式6×4"
          },
          {
            "key": "020",
            "label": "積載質量2t級　駆動方式4×4"
          },
          {
            "key": "040",
            "label": "積載質量4t級　駆動方式4×4"
          },
          {
            "key": "060",
            "label": "積載質量6t級　駆動方式4×4"
          },
          {
            "key": "070",
            "label": "積載質量7t級　駆動方式4×4"
          }
        ]
      },
      {
        "key": "200",
        "label": "除雪専用型",
        "items": [
          {
            "key": "100",
            "label": "積載質量10t級　駆動方式6×4"
          },
          {
            "key": "101",
            "label": "積載質量10t級　駆動方式4×4"
          },
          {
            "key": "102",
            "label": "積載質量10t級　駆動方式4×6"
          },
          {
            "key": "040",
            "label": "積載質量4t級　駆動方式4×4"
          },
          {
            "key": "060",
            "label": "積載質量6t級　駆動方式4×4"
          },
          {
            "key": "070",
            "label": "積載質量7t級　駆動方式4×4"
          }
        ]
      }
    ]
  },
  {
    "key": "5040",
    "label": "除雪グレーダ",
    "items": [
      {
        "key": "114",
        "label": "排出ガス対策型（第3次基準値）",
        "items": [
          {
            "key": "310",
            "label": "ブレード幅3.1m"
          },
          {
            "key": "370",
            "label": "ブレード幅3.7m"
          },
          {
            "key": "400",
            "label": "ブレード幅4.0m"
          },
          {
            "key": "430",
            "label": "ブレード幅4.3m"
          }
        ]
      },
      {
        "key": "116",
        "label": "排出ガス対策型（2014年規制）",
        "items": [
          {
            "key": "400",
            "label": "[ワンマンキャブ]ブレード幅3.7~4.3m"
          }
        ]
      },
      {
        "key": "314",
        "label": "自動ブレード敷・排出ガス対策型（第3次基準値）",
        "items": [
          {
            "key": "400",
            "label": "ブレード幅4.0m"
          },
          {
            "key": "430",
            "label": "ブレード幅4.3m"
          }
        ]
      }
    ]
  },
  {
    "key": "5050",
    "label": "ロータリ式除雪機械",
    "items": [
      {
        "key": "212",
        "label": "ロータリ除雪車（ホイール・2ステージ型）・排出ガス対策型（第1次基準値）",
        "items": [
          {
            "key": "330",
            "label": "除雪幅2.6m級　機関出力240kW（330ps）級"
          }
        ]
      },
      {
        "key": "213",
        "label": "ロータリ除雪車（ホイール・2ステージ型）・排出ガス対策型（第2次基準値）",
        "items": [
          {
            "key": "500",
            "label": "除雪幅2.6m級　機関出力360kW（500ps）級"
          }
        ]
      },
      {
        "key": "214",
        "label": "ロータリ除雪車（ホイール・2ステージ型）・排出ガス対策型（第3次基準値）",
        "items": [
          {
            "key": "100",
            "label": "除雪幅1.5~1.8m級　機関出力75kW（100ps）級"
          },
          {
            "key": "130",
            "label": "除雪幅1.5~1.8m級　機関出力90kW（130ps）級"
          },
          {
            "key": "250",
            "label": "除雪幅2.2~2.6m級　機関出力180kW（250ps）級"
          },
          {
            "key": "300",
            "label": "除雪幅2.6m級　機関出力220kW（300ps）級"
          },
          {
            "key": "400",
            "label": "除雪幅2.6m級　機関出力290kW（400ps）級"
          },
          {
            "key": "600",
            "label": "除雪幅2.6m級　機関出力440kW（600ps）級"
          },
          {
            "key": "040",
            "label": "除雪幅1.0m級　機関出力30kW（40ps）級"
          },
          {
            "key": "080",
            "label": "除雪幅1.3~1.5m級　機関出力60kW（80ps）級"
          }
        ]
      },
      {
        "key": "312",
        "label": "一車線積込除雪車・ロータリ式・排出ガス対策型（第1次基準値）",
        "items": [
          {
            "key": "175",
            "label": "機関出力130kW（175ps）級"
          },
          {
            "key": "250",
            "label": "機関出力180kW（250ps）級"
          }
        ]
      },
      {
        "key": "313",
        "label": "一車線積込除雪車・ロータリ式・排出ガス対策型（第2次基準値）",
        "items": [
          {
            "key": "250",
            "label": "機関出力180kW（250ps）級"
          }
        ]
      },
      {
        "key": "314",
        "label": "一車線積込除雪車・ロータリ式・排出ガス対策型（第3次基準値）",
        "items": [
          {
            "key": "300",
            "label": "機関出力220kW（300ps）級"
          }
        ]
      },
      {
        "key": "514",
        "label": "多機能型ロータリ除雪車・排出ガス対策型（第3次基準値）",
        "items": [
          {
            "key": "340",
            "label": "除雪車（ロータリ/ブラウ）2.6/3.0m　機関出力250kW（340ps）級"
          }
        ]
      }
    ]
  },
  {
    "key": "5060",
    "label": "小型ロータリ除雪機",
    "items": [
      {
        "key": "011",
        "label": "クローラ・ハンドガイド型・ガソリンエンジン駆動",
        "items": [
          {
            "key": "006",
            "label": "機関出力4kW（6ps）級"
          },
          {
            "key": "009",
            "label": "機関出力7kW（9ps）級"
          },
          {
            "key": "011",
            "label": "機関出力8kW（11ps）級"
          },
          {
            "key": "012",
            "label": "機関出力9kW（12ps）級"
          },
          {
            "key": "016",
            "label": "機関出力12kW（16ps）級"
          },
          {
            "key": "020",
            "label": "機関出力15kW（20ps）級"
          },
          {
            "key": "030",
            "label": "機関出力22kW（30ps）級"
          }
        ]
      },
      {
        "key": "021",
        "label": "クローラ・ハンドガイド型・ディーゼルエンジン駆動",
        "items": [
          {
            "key": "006",
            "label": "機関出力4kW（6ps）級"
          },
          {
            "key": "009",
            "label": "機関出力7kW（9ps）級"
          },
          {
            "key": "016",
            "label": "機関出力12kW（16ps）級"
          },
          {
            "key": "025",
            "label": "機関出力18kW（25ps）級"
          },
          {
            "key": "038",
            "label": "機関出力28kW（38ps）級"
          }
        ]
      }
    ]
  },
  {
    "key": "5070",
    "label": "凍結防止剤散布車",
    "items": [
      {
        "key": "110",
        "label": "乾式",
        "items": [
          {
            "key": "325",
            "label": "乾燥散布剤積載量3t級　ホッバ容量2.5㎥　シャシ（駆動方式）5.5t車以上（4×4）"
          },
          {
            "key": "435",
            "label": "乾燥散布剤積載量4t級　ホッバ容量3.5㎥　シャシ（駆動方式）5.5t車以上（4×4）"
          },
          {
            "key": "540",
            "label": "乾燥散布剤積載量5t級　ホッバ容量4.0㎥　シャシ（駆動方式）7t車以上（4×4）"
          }
        ]
      },
      {
        "key": "120",
        "label": "湿式",
        "items": [
          {
            "key": "325",
            "label": "乾燥散布剤積載量3t級　ホッバ容量2.5㎥　シャシ（駆動方式）5.5t車以上（4×4）"
          },
          {
            "key": "435",
            "label": "乾燥散布剤積載量4t級　ホッバ容量3.5㎥　シャシ（駆動方式）5.5t車以上（4×4）"
          },
          {
            "key": "540",
            "label": "乾燥散布剤積載量5t級　ホッバ容量4.0㎥　シャシ（駆動方式）7t車以上（4×4）"
          },
          {
            "key": "760",
            "label": "乾燥散布剤積載量7t級　ホッバ容量6.0㎥　シャシ（駆動方式）10t車以上（6×4）"
          }
        ]
      },
      {
        "key": "130",
        "label": "湿潤式",
        "items": [
          {
            "key": "325",
            "label": "乾燥散布剤積載量3t級　ホッバ容量2.5㎥　シャシ（駆動方式）5.5t車以上（4×4）"
          },
          {
            "key": "434",
            "label": "乾燥散布剤積載量4t級　ホッバ容量3.4㎥　シャシ（駆動方式）5.5t車以上（4×4）"
          },
          {
            "key": "650",
            "label": "乾燥散布剤積載量6t級　ホッバ容量5.0㎥　シャシ（駆動方式）7t車以上（4×4）"
          }
        ]
      }
    ]
  },
  {
    "key": "5075",
    "label": "凍結防止剤散布車用シャシ",
    "items": [
      {
        "key": "100",
        "label": "10t級",
        "items": [
          {
            "key": "441",
            "label": "駆動方式4×4"
          },
          {
            "key": "641",
            "label": "駆動方式6×6"
          }
        ]
      }
    ]
  },
  {
    "key": "5099",
    "label": "その他除雪用機械",
    "items": [
      {
        "key": "111",
        "label": "雪上車（乗用・クローラ・ディーゼルエンジン）",
        "items": [
          {
            "key": "005",
            "label": "5人乗"
          },
          {
            "key": "010",
            "label": "10人乗"
          }
        ]
      },
      {
        "key": "211",
        "label": "多目的作業者（オンロード・ホイール型）",
        "items": [
          {
            "key": "147",
            "label": "機関出力110kW（147ps）級駆動方式4×4"
          },
          {
            "key": "173",
            "label": "機関出力130kW（173ps）級駆動方式4×4"
          },
          {
            "key": "088",
            "label": "機関出力66kW（88ps）級駆動方式4×4"
          }
        ]
      }
    ]
  },
];
const NEW_DATA_AFTER_CONVERT = [
  {
    "key": "9901",
    "label": "ダンプトラック",
    "items": [
      {
        "key": "001",
        "label": "日建連機種中項目",
        "items": [
          {
            "key": "001-001",
            "label": "10t未満"
          },
          {
            "key": "001-002",
            "label": "10t以上"
          }
        ]
      }
    ]
  },
  {
    "key": "9902",
    "label": "トラック",
    "items": [
      {
        "key": "001",
        "label": "日建連機種中項目",
        "items": [
          {
            "key": "001-001",
            "label": "4t未満"
          },
          {
            "key": "001-002",
            "label": "4t以上"
          }
        ]
      }
    ]
  },
  {
    "key": "9903",
    "label": "重ダンプトラック",
    "items": [
      {
        "key": "001",
        "label": "日建連機種中項目",
        "items": [
          {
            "key": "001-001",
            "label": "32t未満"
          },
          {
            "key": "001-002",
            "label": "32t以上"
          }
        ]
      }
    ]
  },
  {
    "key": "9904",
    "label": "バックホー",
    "items": [
      {
        "key": "001",
        "label": "日建連機種中項目",
        "items": [
          {
            "key": "001-001",
            "label": "1m3未満"
          },
          {
            "key": "001-002",
            "label": "1m3未満ハイブリッド"
          },
          {
            "key": "001-003",
            "label": "1m3以上"
          }
        ]
      }
    ]
  },
  {
    "key": "9905",
    "label": "ミニバックホー",
    "items": [
      {
        "key": "001",
        "label": "日建連機種中項目",
        "items": [
          {
            "key": "001-001",
            "label": "ミニバックホー"
          }
        ]
      }
    ]
  },
  {
    "key": "9906",
    "label": "ブルドーザー",
    "items": [
      {
        "key": "001",
        "label": "日建連機種中項目",
        "items": [
          {
            "key": "001-001",
            "label": "10t未満"
          },
          {
            "key": "001-002",
            "label": "10t以上"
          }
        ]
      }
    ]
  },
  {
    "key": "9907",
    "label": "トラクタショベル",
    "items": [
      {
        "key": "001",
        "label": "日建連機種中項目",
        "items": [
          {
            "key": "001-001",
            "label": "クラローダ"
          }
        ]
      }
    ]
  },
  {
    "key": "9908",
    "label": "ホイルローダ",
    "items": [
      {
        "key": "001",
        "label": "日建連機種中項目",
        "items": [
          {
            "key": "001-001",
            "label": "4m3未満"
          },
          {
            "key": "001-002",
            "label": "4m3以上"
          }
        ]
      }
    ]
  },
  {
    "key": "9909",
    "label": "ロードローラ",
    "items": [
      {
        "key": "001",
        "label": "日建連機種中項目",
        "items": [
          {
            "key": "001-001",
            "label": "ロードローラ"
          }
        ]
      }
    ]
  },
  {
    "key": "9910",
    "label": "基礎杭・掘削機械",
    "items": [
      {
        "key": "001",
        "label": "日建連機種中項目",
        "items": [
          {
            "key": "001-001",
            "label": "ｸﾛｰﾗ式杭打機"
          },
          {
            "key": "001-002",
            "label": "ｸﾛｰﾗ式アースオーガ"
          },
          {
            "key": "001-003",
            "label": "ｸﾛｰﾗ式地下連壁"
          }
        ]
      }
    ]
  },
  {
    "key": "9911",
    "label": "クラムシェル",
    "items": [
      {
        "key": "001",
        "label": "日建連機種中項目",
        "items": [
          {
            "key": "001-001",
            "label": "1m3未満"
          },
          {
            "key": "001-002",
            "label": "1m3以上"
          }
        ]
      }
    ]
  },
  {
    "key": "9912",
    "label": "トラッククレーン",
    "items": [
      {
        "key": "001",
        "label": "日建連機種中項目",
        "items": [
          {
            "key": "001-001",
            "label": "50t吊り未満"
          },
          {
            "key": "001-002",
            "label": "50t吊り以上"
          }
        ]
      }
    ]
  },
  {
    "key": "9913",
    "label": "ラフタークレーン",
    "items": [
      {
        "key": "001",
        "label": "日建連機種中項目",
        "items": [
          {
            "key": "001-001",
            "label": "20t吊り未満"
          },
          {
            "key": "001-002",
            "label": "20t吊り以上"
          }
        ]
      }
    ]
  },
  {
    "key": "9914",
    "label": "クローラクレーン",
    "items": [
      {
        "key": "001",
        "label": "日建連機種中項目",
        "items": [
          {
            "key": "001-001",
            "label": "50t吊り未満"
          },
          {
            "key": "001-002",
            "label": "50t吊り以上"
          }
        ]
      }
    ]
  },
  {
    "key": "9915",
    "label": "フォークリフト",
    "items": [
      {
        "key": "001",
        "label": "日建連機種中項目",
        "items": [
          {
            "key": "001-001",
            "label": "2t吊り未満"
          },
          {
            "key": "001-002",
            "label": "2t吊り以上"
          }
        ]
      }
    ]
  },
  {
    "key": "9916",
    "label": "コンクリートポンプ車",
    "items": [
      {
        "key": "001",
        "label": "日建連機種中項目",
        "items": [
          {
            "key": "001-001",
            "label": "50m3未満"
          },
          {
            "key": "001-002",
            "label": "50m3以上"
          }
        ]
      }
    ]
  },
  {
    "key": "9917",
    "label": "高所作業車",
    "items": [
      {
        "key": "001",
        "label": "日建連機種中項目",
        "items": [
          {
            "key": "001-001",
            "label": "ブーム型"
          },
          {
            "key": "001-002",
            "label": "垂直型"
          }
        ]
      }
    ]
  },
  {
    "key": "9918",
    "label": "発電機",
    "items": [
      {
        "key": "001",
        "label": "日建連機種中項目",
        "items": [
          {
            "key": "001-001",
            "label": "50kVA未満"
          },
          {
            "key": "001-002",
            "label": "50~149kVA"
          },
          {
            "key": "001-003",
            "label": "150kVA以上"
          }
        ]
      }
    ]
  },
  {
    "key": "9919",
    "label": "空気圧縮機",
    "items": [
      {
        "key": "001",
        "label": "日建連機種中項目",
        "items": [
          {
            "key": "001-001",
            "label": "100kw未満"
          },
          {
            "key": "001-002",
            "label": "100kw以上"
          }
        ]
      }
    ]
  }
];
export default { CO2_ITEMS, FILTERS_OPTIONS, DATA_AFTER_CONVERT, NEW_CO2_ITEMS, NEW_DATA_AFTER_CONVERT };
